const Content = {
	"people": {
		"sections": [
			{
				"slug": "leaders",
				"name": "Leaders"
			},
			{
				"slug": "client-services",
				"name": "Client Services"
			},
			{
				"slug": "operations",
				"name": "Operations"
			}
		],
		"leaders": {
			"title": "Running the show",
			"list": [
				{
					"name": "Jon Penn",
					"jobTitle": "Chief Executive Officer",
					"pictureUrl": "../../assets/img/people/Jon.Penn.jpg",
					"bio": "As CEO, Jon is responsible for all things NRG. Jon has spent nearly two decades modernizing and expanding the strategic value of entertainment research by applying methodologies and insights from political and corporate polling.  He is an ARF David Ogilvy Award winner and contributor and pollster to The Hollywood Reporter. Before arriving at NRG, he was the Founder and CEO of the Media and Entertainment practice at Penn Schoen Berland. In a 17-year career at PSB, he built the practice into one of the most highly successful and well-respected entertainment polling firms in the world. Previously, Jon served as Director of Internet Strategy for Hillary Clinton's successful Senate campaign win in 2000. In this role he directed and managed campaign web strategy and execution. Jon is a graduate of the University of Pennsylvania. He and his wife have their hands full with twins Ava and Olivia, and \"big\" James.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Built to Spill"
						},
						{
							"subject": "Movie",
							"answer": "Hoop Dreams"
						},
						{
							"subject": "TV Show",
							"answer": "Making a Murderer"
						},
						{
							"subject": "Superhero",
							"answer": "Wolverine"
						},
						{
							"subject": "Game",
							"answer": "Tennis"
						}
					]
				},
				{
					"name": "Rob Barrish",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Rob.Barrish.jpg",
					"bio": "Rob brings over 25 years of technology, platform, product and services expertise to NRG. After beginning his career at Intersearch (now Kantar) in the telecom practice, Rob joined GfK where he co-founded its US Technology practice and built up team of insights consultants focused on telecom, consumer electronics, and IT products and services for B2B and consumer brands. Rob led GfK's team of Global Account Directors for the top technology and media accounts and also served as Global Account Director for GfK's largest technology account.  Rob graduated from Franklin and Marshall College with a BA in Economics and Spanish and from University of Illinois with an MBA. Rob lives in Princeton, NJ with his wife and young daughter Sarah.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Big Lebowski"
						},
						{
							"subject": "Superhero",
							"answer": "Aquaman-Swimming is the best release"
						},
						{
							"subject": "Food",
							"answer": "Thai Food, love Yuum Salads! The hotter, the better."
						},
						{
							"subject": "Sports Teams",
							"answer": "Philadelphia Eagles, Fly Eagles Fly!"
						},
						{
							"subject": "Directors",
							"answer": "The Coen Brothers"
						}
					]
				},
				{
					"name": "Kathy Benjamin",
					"jobTitle": "Executive Vice President, Business Transformation",
					"pictureUrl": "../../assets/img/people/Kathy.Benjamin.jpg",
					"bio": "Kathy's responsibilities are three-fold: she manages NRG's data science team, leads innovations and operations for film tracking, and is responsible for bringing NRG's social offering to market. Kathy's unique blend of collaborative leadership, client management/consulting, passion for continuous improvement, and market research expertise prompted a colleague to call her the “Olivia Pope of NRG.\" In other words, she gets things handled (though she doesn't know where any bodies are buried). Kathy has also worked at Synovate, J.D. Power & Associates, and General Motors and has degrees in Statistics from Iowa State University and the University of Michigan. ",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Jayhawks"
						},
						{
							"subject": "Movie",
							"answer": "How can I pick just one? If I must: Raiders of the Lost Ark"
						},
						{
							"subject": "Superhero",
							"answer": "Jessica Jones"
						},
						{
							"subject": "Game",
							"answer": "Tennis"
						},
						{
							"subject": "Cocktail",
							"answer": "Pinot Noir from Santa Rita Hills AVA"
						}
					]
				},
				{
					"name": "Matt Blong",
					"jobTitle": "Senior Vice President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Matt.Blong.jpg",
					"bio": "Matt oversees the LA based Global Tracking team. Matt has been with NRG since 2008, and has been focused on Global Tracking since 2012, in which time he has worked with all of the major studios to help guide their films across 13 countries. Matt joined NRG after graduating from the University of California at Santa Cruz in 2008 with a BA in Sociology. He is an avid sports fan and documentary enthusiast, and spends much of his free time chasing around his pet rabbit, Nicholas.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Big Lebowski"
						},
						{
							"subject": "Team",
							"answer": "LA Lakers"
						},
						{
							"subject": "Book",
							"answer": "The Devil in the White City"
						},
						{
							"subject": "TV Show",
							"answer": "It's Always Sunny in Philadelphia"
						},
						{
							"subject": "Food",
							"answer": "Lasagna"
						}
					]
				},
				{
					"name": "Nick Crofoot",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Nick.Crofoot.jpg",
					"bio": "Nick joined NRG in 2019, where he works with Platforms & Technology clients to uncover profound insights that guide important strategic decisions across the go-to-market life cycle. A seasoned research practitioner, his expertise includes product innovation, value proposition development, segmentation and market sizing, positioning and messaging strategy, corporate reputation and brand management, and issues/crisis polling. Previously he was a Senior Vice President and the global account lead for a Fortune 50 technology client at PSB Research. Nick is a graduate of Dartmouth College and lives in Denver, with his wife and two children, Palmer and Annie.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The West Wing(seasons 1-4) "
						},
						{
							"subject": "Quote",
							"answer": "\"Work hard, be kind, and amazing things will happen.\"Conan O'Brien"
						},
						{
							"subject": "Book",
							"answer": "I know it might sound a little corny, but I find something so resplendent in the simplicity of Nicholas Sparks' writing."
						},
						{
							"subject": "Game",
							"answer": "Risk"
						},
						{
							"subject": "Director",
							"answer": "Matthew Heineman"
						}
					]
				},
				{
					"name": "Alicia Driscoll",
					"jobTitle": "Senior Vice President, Business Transformation",
					"pictureUrl": "../../assets/img/people/Alicia.Driscoll.jpg",
					"bio": "Alicia leads the Gaming + Interactive Media group. In her role, she works with top clients including console leaders, AAA publishers, mobile developers, and digital content creators providing research and strategic consulting services at all stages of the product development lifecycle. Prior to joining National Research Group, she worked at PSB Research where she led the gaming division. Alicia graduated from Dartmouth College with degrees in Psychology and Applied and Professional Ethics.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Troop Beverly Hills"
						},
						{
							"subject": "Game",
							"answer": "Triple Town (mobile)"
						},
						{
							"subject": "Restaurant",
							"answer": "Bar Pintxo (Santa Monica)"
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey Sour"
						},
						{
							"subject": "Game Show Host",
							"answer": "Kirk Fogg"
						}
					]
				},
				{
					"name": "Josh Hack",
					"jobTitle": "Senior Vice President, Head of Global Content Insights",
					"pictureUrl": "../../assets/img/people/Josh.Hack.jpg",
					"bio": "Josh works with film and television studios to provide insights that guide content development, production, and marketing strategy. He specializes in global brand and positioning research, and has conducted qualitative and quantitative studies domestically and throughout Latin America, Europe, and Asia. Before joining NRG, Josh was Director of Media and Entertainment Research at Penn Schoen Berland. Prior to PSB, Josh worked in brand strategy for Grey Advertising in London. Josh has an MSc in Media and Communications from the London School of Economics and a BA in English Literature from the University of California, Los Angeles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Best Years of Our Lives"
						},
						{
							"subject": "TV Show",
							"answer": "Picket Fences"
						},
						{
							"subject": "Director",
							"answer": "Terry Gilliam"
						},
						{
							"subject": "Book",
							"answer": "Slaughterhouse-Five"
						},
						{
							"subject": "Quote",
							"answer": "\"There are two types of people in the world: those who can extrapolate from incomplete data.\""
						}
					]
				},
				{
					"name": "Jeff Hall",
					"jobTitle": "Executive Vice President, Head of Qualitative",
					"pictureUrl": "../../assets/img/people/Jeff.Hall.jpg",
					"bio": "Jeff was born and raised in Rochester, New York and got his undergraduate degree in Marketing at the University of Oklahoma. He received his Masters in Business Administration in Finance and Marketing at the Simon School of Business at the University of Rochester. He began his career as a research executive at Young and Rubicam New York, and helped win the 20th Century Fox account for Y&R, moving to Hollywood soon after. In Hollywood he worked at NRG (the first time) for 5 years before moving to Warner Bros Pictures, then later to Paramount Pictures where he ran Theatrical Market Research for 15 years. He joined PSB in 2012 to grow their qualitative offerings, and came full circle back to NRG in January of 2016. At PSB and NRG he has worked on a wide range of projects from TV shows, hair color, movie franchises, restaurants, video games, celebrity chefs and more.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Blondie"
						},
						{
							"subject": "Movie",
							"answer": "Casablanca"
						},
						{
							"subject": "Superhero",
							"answer": "The Creeper"
						},
						{
							"subject": "Food",
							"answer": "Veal Scallopini"
						},
						{
							"subject": "Actor",
							"answer": "Humphrey Bogart"
						}
					]
				},
				{
					"name": "Neil Harrison",
					"jobTitle": "President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Neil.Harrison.jpg",
					"bio": "Neil joined NRG in 2006 to relaunch its international tracker, and continues to lead its management and development, in addition to working across product and business development. Neil is a European Studies graduate from Bath University, and has a Masters in Media from the University of Glasgow. After two years teaching in Paris, he began his film career in distribution at FilmFour in London, before moving into market research at FirstMovies, prior to joining NRG.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Lawrence of Arabia"
						},
						{
							"subject": "Book",
							"answer": "Fathers and Sons"
						},
						{
							"subject": "Actor",
							"answer": "Jean Gabin"
						},
						{
							"subject": "Actress",
							"answer": "Ingrid Bergman"
						},
						{
							"subject": "Director",
							"answer": "Aki Kaurismäki"
						}
					]
				},
				{
					"name": "Deepa Iyengar",
					"jobTitle": "Executive Vice President, Head of Qualitative ",
					"pictureUrl": "",
					"bio": "Deepa, a renowned market research expert, has more than 20 years of qualitative and quantitative experience covering all key vertials and every phase of the product lifecycle. As EVP, Head of Qualitative on the Platforms and Tech team, she is responsible for building and growing integrated qualitative capabilities and services. Prior to NRG, Deepa led qualitative and UX research at Ipsos for two of the company's biggest global tech accounts. She has a strong academic background with two MBAs and a Masters in International Relations from the world's leading academic institutions. Deepa lives in California with her husband and 2 dogs.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Breaking Bad and Sons of Anarchy"
						},
						{
							"subject": "Movie",
							"answer": "Lord of the Rings"
						},
						{
							"subject": "Band",
							"answer": "Eagles"
						},
						{
							"subject": "Book",
							"answer": "Pillars of the Earth"
						},
						{
							"subject": "Food",
							"answer": "Anything East Asian, South-East Asian and Peruvian"
						}
					]
				},
				{
					"name": "Jay Kaufman",
					"jobTitle": "Executive Vice President, Head of Sports",
					"pictureUrl": "../../assets/img/people/Jay.Kaufman.jpg",
					"bio": "Jay joined NRG in 2021 to lead and formally launch the growing sports research and consulting practice within Platforms & Technology. Previously, he spent 20+ years at the NBA, most recently as Senior Vice President, Global Research & Insights. In that role. Jay was responsible for using data and insights to guide strategy and decision-making across the league’s media business, global fan growth strategies, game and product research, brand positioning, partnerships and critical issues tracking. Jay lives just outside of New York City with his wife and daughter.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Dumb and Dumber"
						},
						{
							"subject": "TV Show",
							"answer": "Curb Your Enthusiasm"
						},
						{
							"subject": "Band",
							"answer": "Pearl Jam"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						},
						{
							"subject": "Sports Team",
							"answer": "I love all my Boston teams equally"
						}
					]
				},
				{
					"name": "Katie Kelley",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Katie.Kelley.jpg",
					"bio": "Katie works with both our film and streaming clients to provide global expertise and consultancy. She is an expert in both qualitative and quantitative studies, and works across all stages of the content lifecycle, including global greenlight, franchise/series development, content testing & screening, and marketing campaign positioning strategy. Prior to joining NRG, Katie was VP of International Research & Strategy at Paramount Pictures, and she is uniquely positioned to advise our clients on their biggest global content production and marketing questions. Prior to this, Katie worked in the UK for PSB First Movies and Virgin Atlantic. Katie has a BA in Politics & American Studies from Sussex University, UK & Georgetown University.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The X Files"
						},
						{
							"subject": "Vacation",
							"answer": "Santorini, Greece"
						},
						{
							"subject": "Restaurant",
							"answer": "The Duke William, Ickham, UK"
						},
						{
							"subject": "Cocktail",
							"answer": "French 75"
						},
						{
							"subject": "Actress",
							"answer": "Emma Thompson"
						}
					]
				},
				{
					"name": "Collin Leirvik",
					"jobTitle": "Executive Vice President, Head of Gaming",
					"pictureUrl": "../../assets/img/people/Collin.Leirvik.jpg",
					"bio": "Collin joined NRG in 2020 to lead games and interactive media practice within Platforms & Technology. Collin brings extensive industry passion and experience to the team, as well as his expertise as a mix methods research and strategist. Previously, he was Vice President, Head of Quantitative at LRW Greenberg, leading programs for industry leading platform, publisher, developers, and emerging technology brands. Collin lives in the San Francisco Bay Area with his wife and two children, Grayson and Elias.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Khruangbin"
						},
						{
							"subject": "Movie",
							"answer": "There Will Be Blood"
						},
						{
							"subject": "Game",
							"answer": "Skyrim"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Kauai"
						},
						{
							"subject": "Director",
							"answer": "Paul Thomas Anderson"
						}
					]
				},
				{
					"name": "Amber McBenttez",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Amber.McBenttez.jpg",
					"bio": "Amber leads NRG's Content & Strategy team, specializing in providing consultative research to entertainment clients (across film, television, and OTT) to guide branding, marketing, and content strategies. Amber is an expert in custom primary research and has substantial experience implementing advanced statistical and analytical approaches to customize solutions, including multi-dimensional segmentations, factor analysis, linear regression models, and conjoint/discrete choice analysis. Prior to NRG, Amber led the custom primary research team at Nielsen, supporting all US media clients. Amber has a degree in Sociology and Spanish from the University of California, Los Angeles.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "This is Us "
						},
						{
							"subject": "Quote",
							"answer": "\"It's Fine\""
						},
						{
							"subject": "Food/Dish",
							"answer": "Any and all Mexican food "
						},
						{
							"subject": "Cocktail",
							"answer": "Dirty Martini(but not too dirty!)"
						},
						{
							"subject": "Actor",
							"answer": "Denzel Washington"
						}
					]
				},
				{
					"name": "James McNamara",
					"jobTitle": "Chief Operating Officer",
					"pictureUrl": "../../assets/img/people/James.McNamara.jpg",
					"bio": "James oversees all of NRG's Operations and assists in setting the direction of the firm. With over a decade of leadership experience, James specializes in leveraging technology to create efficient, scalable, and agile operational teams dedicated to solving clients' toughest challenges. Prior to NRG, James was an Executive Vice President of the Media and Entertainment Research practice at PSB (a WPP company). James graduated from the University of Virginia with a B.S. in Computer Science from the School of Engineering & Applied Sciences (Wahoowa!).",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dave Matthews Band"
						},
						{
							"subject": "Movie",
							"answer": "Gladiator"
						},
						{
							"subject": "TV Show",
							"answer": "24"
						},
						{
							"subject": "Quote",
							"answer": "\"Roads? Where we're going, we don't need roads.\" -Doc Brown"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Arcos de la Frontera, Spain"
						}
					]
				},
				{
					"name": "Kerri Norton",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Kerri.Norton.jpg",
					"bio": "Kerri has 10 years of primary media research experience, specializing in providing TV and OTT clients with actionable insights for programming, branding, marketing, and sales. Her keen eye for visual storytelling complements her research toolkit, which includes a wide range of qualitative and quantitative methodologies, allowing her to customize each project to best meet her clients' needs and objectives. Kerri is also a RIVA trained moderator and loves meeting and connecting with people all over the world.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Princess Bride"
						},
						{
							"subject": "TV Show",
							"answer": "Orphan Black"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Tuscany"
						},
						{
							"subject": "Cocktail",
							"answer": "French 75"
						},
						{
							"subject": "Actress",
							"answer": "Jessica Chastain"
						}
					]
				},
				{
					"name": "Stephen Palmer",
					"jobTitle": "President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Stephen.Palmer.jpg",
					"bio": "Stephen has specialized in international movie research since 2001. He has worked with all the major studios, as well as many filmmakers and leading entertainment companies. Stephen's breadth of client experience allows him to provide insight at all stages of a film's life cycle, from early market positioning assessments, through playability and testing the strategic impact of marketing materials. Stephen has extensive experience with both established and emerging international markets, particularly LATAM and Asia. Stephen graduated from the University of Manchester, in England, with a Bachelor's degree in Mathematics and Management Sciences.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Shining"
						},
						{
							"subject": "Quote",
							"answer": "\"Either the wallpaper goes, or I do\" -Oscar Wilde, allegedly on his deathbed"
						},
						{
							"subject": "Food",
							"answer": "An old-fashioned Sunday roast"
						},
						{
							"subject": "Cocktail",
							"answer": "Caprioska"
						},
						{
							"subject": "Actress",
							"answer": "Sally Hopkins, Allison Janney"
						}
					]
				},
				{
					"name": "Roy Persson",
					"jobTitle": "Senior Vice President, Corporate Affairs & PR, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Roy has nearly 20 years of research experience; helping clients measure organizational performance and develop strategies to support their business objectives. Specializing in communications and corporate affairs he has helped global organizations better understand their reputation landscape, providing guidance on key policies, initiatives, and messaging. He has covered several industries, deploying qualitative and quantitative techniques in several regions, across a spectrum of unique stakeholder groups. Roy has market research experience in reputation, advocacy, employee satisfaction, message development, crisis management, branding, thought leadership, customer satisfaction, communications, advertising, as well as other disciplines. He holds an MBA from Bryant University.",
					"favourites": [
						{
							"subject": "Game",
							"answer": "American football, to watch , play, and coach"
						},
						{
							"subject": "Quote",
							"answer": "\"People will forget what you said, people will forget what you did, but people will never forget how you made them feel.\" - Maya Angelou (American author and civil rights activist)"
						},
						{
							"subject": "Sports Team",
							"answer": "New England Patriots (Tom Brady is the GOAT)"
						},
						{
							"subject": "Food",
							"answer": "Chicken wings"
						},
						{
							"subject": "TV Show",
							"answer": "It's Always Sunny in Philadelphia"
						}
					]
				},
				{
					"name": "Chris Rethore",
					"jobTitle": "Chief Strategy Officer",
					"pictureUrl": "../../assets/img/people/Chris.Rethore.jpg",
					"bio": "Chris leads NRG’s growth strategy initiatives with an emphasis on enhancing value for clients through product innovation and thought leadership. With nearly two decades of research and leadership experience, Chris specializes in the development and launch of best-in-class insights solutions that leverage cutting-edge data science to anticipate and solve critical client challenges. Prior to NRG, Chris was Chief Operating Officer at MarketCast overseeing firmwide operations, marketing, and the growth of its acquired business portfolio. Chris graduated from the University of Pennsylvania with a B.A. in History.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Natural"
						},
						{
							"subject": "Class in School",
							"answer": "History"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Napa Valley"
						},
						{
							"subject": "Restaurant",
							"answer": "Steirereck (Vienna)"
						},
						{
							"subject": "Sports Team",
							"answer": "Boston Red Sox"
						}
					]
				},
				{
					"name": "Julia Roland",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Julia.Roland.jpg",
					"bio": "For over two decades, Julia has supported the marketing, consumer, enterprise and product research needs of the world’s largest tech, telecom, media and consumer brands. As a senior client partner, she designs and leads a broad range of high-impact research engagements. Her experience, most recently at Ipsos/Synovate, as well as Nielsen, Telephia and Harris Interactive, spans brand/product strategy, audience insights, customer journey, marketing effectiveness, ad strategy, retail insights, and UX. She also has extensive experience integrating behavioral metrics and other types of non-survey data. Julia lives in NJ with her husband Seth, son Daniel, and daughters Hannah and Laura (when they take a break from life in NYC).",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Pulp Fiction"
						},
						{
							"subject": "Game",
							"answer": "Scrabble"
						},
						{
							"subject": "Food",
							"answer": "Popcorn and French Fries"
						},
						{
							"subject": "Quote",
							"answer": "\"No [wo]man is a failure who has friends.\"-Clarence the Angel"
						},
						{
							"subject": "Actor",
							"answer": "Matt Damon"
						}
					]
				},
				{
					"name": "Benjamin Rogers",
					"jobTitle": "President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Benjamin.Rogers.jpg",
					"bio": "Ben leads our Platforms & Technology Client Practice, which delivers game-changing insights across dimensions of the product and services lifecycle, including market landscaping, innovation, brand and positioning strategy, creative & platform optimization, and performance tracking. Ben, who previously served as EVP, Head of Media Development at Ipsos, brings over 20 years of technology platform, product, and services expertise to NRG, via leadership posts in London and the SF Bay Area. After beginning his career at NOP/GfK, and leading various teams on technology accounts for Kantar, he spent nearly a decade at Synovate/Ipsos. Ben lives in the San Francisco Bay Area and has two young children, daughter Riley and son Adrian.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Iron Maiden"
						},
						{
							"subject": "Quote",
							"answer": "If you didn't do anything that wasn't good for you it would be a very dull life. What are you gonna do? Everything that is pleasant in life is dangerous. Have you noticed that?\" - Ian \"Lemmy\" Kilmister"
						},
						{
							"subject": "Food/Dish",
							"answer": "I lived in London for 8 years, so you KNOW it's a good curry!"
						},
						{
							"subject": "Sports Team",
							"answer": "DA BEARS!"
						},
						{
							"subject": "Class In School",
							"answer": "The History of War (basically just watched documentaries which I do anyway!)"
						}
					]
				},
				{
					"name": "Heather Sajeski",
					"jobTitle": "Senior Vice President of People",
					"pictureUrl": "../../assets/img/people/Heather.Sajeski.jpg",
					"bio": "Heather leads NRG's Human Resources team as the Vice President of People.  Prior to joining NRG, Heather spent her early career at PSB Research helping clients across industries solve their biggest problems using data driven approaches.  She later became Vice President of Knowledge at PSB, helping to develop numerous internal training programs and leading employee development initiatives.  She brings both her research background as well as her training and development knowledge to lead all of NRG's people initiatives.   Heather graduated from The George Washington University with a BA in International Affairs and Economics.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dave Matthews Band"
						},
						{
							"subject": "Movie",
							"answer": "All of the Fast and Furious Movies (except Tokyo Drift)"
						},
						{
							"subject": "Quote",
							"answer": "\"Of course it is happening inside your head, Harry, but why on earth should that mean that it is not real?\" — Harry Potter and the Deathly Hallows"
						},
						{
							"subject": "Book",
							"answer": "A secret History"
						},
						{
							"subject": "Sports Team",
							"answer": "Philadelphia Eagles"
						}
					]
				},
				{
					"name": "Cindi Smith",
					"jobTitle": "Vice President, Diversity, Equity & Inclusion",
					"pictureUrl": "../../assets/img/people/Cindi.Smith.jpg",
					"bio": "Cindi is involved in all aspects of primary research for our motion picture clients. Her primary focus is on client communication and managing workflow processes within the Screenings Division. She also works as a moderator and leads focus group discussions on ad effectiveness and for production and marketing test screenings.  Prior to joining NRG, Cindi had a successful career in sales and marketing with American Express and Associated Production Music. She has a MBA from The University of Phoenix and a BS in Finance from California State University, Long Beach. During her free time Cindi enjoys watching movies, shopping and exploring the world.",
					"favourites": [
						{
							"subject": "Superhero",
							"answer": "Wonder Woman - what's not to love about a woman with her very own invisible plane?"
						},
						{
							"subject": "Band",
							"answer": "Prince"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Italy"
						},
						{
							"subject": "TV Show",
							"answer": "Shameless"
						},
						{
							"subject": "Cocktail",
							"answer": "Depends on my mood - Either a Dirty Vodka Martini (with Blue Cheese olives) or a nice glass of Champagne"
						}
					]
				},
				{
					"name": "Ray Subers",
					"jobTitle": "Senior Vice President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Ray.Subers.jpg",
					"bio": "Ray has worked on bringing to market NRG's new long-range tracking product, Campaign Management. He remains involved in the continuing evolution and operation of the product, and regularly consults with clients on how to get the most value out of this new data. Prior to joining NRG, Ray was a senior analyst on the international theatrical distribution team at Paramount Pictures. In a past life, he ran the popular box office tracking site Box Office Mojo.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Raiders of the Lost Ark"
						},
						{
							"subject": "Game",
							"answer": "Scrabble"
						},
						{
							"subject": "Cocktail",
							"answer": "Manhattan"
						},
						{
							"subject": "Team",
							"answer": "Philadelphia Eagles"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Jenny Swisher",
					"jobTitle": "Chief People Officer",
					"pictureUrl": "../../assets/img/people/Jenny.Swisher.jpg",
					"bio": "Jenny is a modern HR/People Operations leader who drives people strategy alignment with business strategy to foster organizational success. I believe in fostering a culture where talent is supported as professionals and humans, where they can their authentic self, achieve high performance by contributing in a purposeful way, and have the opportunity to elevate and further their impact. Jenny is a mom of two (Jessica and Dylan), a SoCal girl through and through, an avid runner, and a continuous learner.",
					"favourites": [
						{
							"subject": "Actor",
							"answer": "Tom Hanks"
						},
						{
							"subject": "Movie",
							"answer": "Gladiator"
						},
						{
							"subject": "Quote",
							"answer": "\"To inspire people, don't show them your super powers. Show them theirs.\" — Alexander Den Heijer"
						},
						{
							"subject": "Director",
							"answer": "Steven Spielberg"
						},
						{
							"subject": "Food",
							"answer": "Mexican and anything spicy!"
						}
					]
				},
				{
					"name": "Aaron Williams",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Aaron.Williams.jpg",
					"bio": "Aaron joined NRG in 2020 and works with our Platform & Technology clients, helping them uncover insights spanning the product lifecycle. Aaron has extensive technology research expertise, having advised major tech companies on key business initiatives for nearly 20 years. He has worked extensively with B2B technical audiences, including IT Professionals and Developers, in both quantitative and qualitative research, including moderation. Previously, Aaron worked for Synovate (now Ipsos) and Paradoxes, Inc., as well as Microsoft’s Central Market Research Group running large, global tracking studies. Aaron has an MBA from the University of Washington with emphases in Marketing and Management.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "They Might Be Giants"
						},
						{
							"subject": "Movie",
							"answer": "Ferris Bueller's Day Off"
						},
						{
							"subject": "Book",
							"answer": "Zen and the Art of Motorcyle Maintenance"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Costa Rica"
						},
						{
							"subject": "Sports Team",
							"answer": "Indiana Hoosiers Basketball"
						}
					]
				},
				{
					"name": "Leanna Wood",
					"jobTitle": "Senior Vice President, Global Operations",
					"pictureUrl": "../../assets/img/people/Leanna.Wood.jpg",
					"bio": "Leanna is focused on NRG's operational units and ensuring they are functioning as efficiently as possible. She manages many of the firm's external vendor relationships, designs and improves operational practices, and ensures all fieldwork is completed accurately and on schedule.  Before joining NRG, she served as Senior Director, Head of Online Sampling at Penn Schoen Berland. Leanna graduated from The George Washington University with a BA in International Affairs. ",
					"favourites": [
						{
							"subject": "Vacation Spot",
							"answer": "Greece"
						},
						{
							"subject": "Movie",
							"answer": "Breakfast at Tiffany's"
						},
						{
							"subject": "Book",
							"answer": "The Shadow of the Wind by Carlos Ruiz Zafon"
						},
						{
							"subject": "Restaurant",
							"answer": "Minibar (DC)"
						},
						{
							"subject": "Team",
							"answer": "New England Patriots"
						}
					]
				},
				{
					"name": "Becky Wu, Ph.D.",
					"jobTitle": "Executive Vice President, Marketing Sciences",
					"pictureUrl": "../../assets/img/people/Becky.Wu.jpg",
					"bio": "Becky leads our Marketing Science and Data Science practice. She brings 20 years of expertise and creativity in leveraging integrated methodologies, advanced analytics and multi-dimensional data assets. Becky has been a trailblazer in not only co-inventing one of the research industry’s first passive behavioral metering technologies, but also establishing best practices in bridging survey data, digital behavioral data, media data and transactional data. Her focus centers around helping clients and the NRG team formulate better insights and data strategy by capitalizing on the convergence of traditional statistical analytics and data science techniques. Becky holds a Ph.D. in Communications from Pennsylvania State University.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Pink Martini"
						},
						{
							"subject": "Quote",
							"answer": "\"Time has been my Democritus.\" - Jorge Luis Borges"
						},
						{
							"subject": "Actress",
							"answer": "Nicole Kidman"
						},
						{
							"subject": "Superhero",
							"answer": "The Little Prince"
						},
						{
							"subject": "Food/Dish",
							"answer": "Anything Seafood"
						}
					]
				}
			]
		},
		"client-services": {
			"title": "Building the scene",
			"list": [
				{
					"name": "Jennifer Akemi",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Jennifer.Akemi.jpg",
					"bio": "Jennifer provides actionable insights for theatrical and streaming clients within the Content & Strategy team. Prior to NRG, she worked with consumer insights and marketing strategy for the Telecommunications and Entertainment industries in Brazil – where she launched 120+ home video products at Warner Brothers. A serial learner, Jennifer has a BA in Marketing from University of São Paulo, MBA in Digital Marketing from Superior School of Advertising & Marketing, and an extension course in User Research for UX from UC Berkeley. When she’s not working, you can find her watching movies, playing video games, traveling, skiing, and trying new food.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Jorge Ben Jor"
						},
						{
							"subject": "Movie",
							"answer": "Oldboy (2003)"
						},
						{
							"subject": "TV Show",
							"answer": "The Boys"
						},
						{
							"subject": "Game",
							"answer": "Fortnite"
						},
						{
							"subject": "Food/Dish",
							"answer": "Sushi"
						}
					]
				},
				{
					"name": "Parisa Amiri",
					"jobTitle": "Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Parisa.Amiri.jpg",
					"bio": "Parisa has over six years of experience working with various studio clients to better understand the theatrical and home entertainment landscape. As manager of the home entertainment team, she has been integral in revitalizing NRG's home entertainment tracker to measure how consumers watch movies at home, their purchase motivators and influencers, and several other retail behaviors. Before joining NRG, Parisa worked at Interpret LLC, where she conducted intent to purchase and ad test research. She is a 2010 graduate of Loyola Marymount University, where she earned her BA in business. In her spare time, she enjoys traveling, cooking, and corgis!",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Star Wars: Episode V - The Empire Strikes Back"
						},
						{
							"subject": "TV Show",
							"answer": "Friends"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Santorini, Greece"
						},
						{
							"subject": "Cocktail",
							"answer": "“The Misfit” Grapefruit Basil Gimlet"
						},
						{
							"subject": "Director",
							"answer": "David Fincher"
						}
					]
				},
				{
					"name": "Danny Aoshana",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Danny.Aoshana.jpg",
					"bio": "Danny started his career in entertainment research in 2014. Over the years he has provided studios, TV networks and streaming clients with content development insights - from concept to execution, both domestically and internationally. Prior to joining NRG, he worked at Screen Engine/ASI and Penn Schoen Berland where he focused on pilot testing and theatrical creative testing. Danny graduated summa cum laude from California State University, Northridge with a BA in Psychology (Honors) and a minor in Marketing. Danny loves to travel, try new restaurants and is always looking to try a new HIIT workout.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Twenty One Pilots"
						},
						{
							"subject": "Movie",
							"answer": "Jumanji (1995)"
						},
						{
							"subject": "Superhero",
							"answer": "Deadpool"
						},
						{
							"subject": "Game",
							"answer": "Clue"
						},
						{
							"subject": "Food/Dish",
							"answer": "Quesadillas"
						}
					]
				},
				{
					"name": "Meg Armstrong",
					"jobTitle": "Entertainment Market Research Analyst, Content & Strategy",
					"pictureUrl": "",
					"bio": "Meg is an Entertainment Market Research Analyst on the Content & Strategy team. She graduated from Colgate University with a Bachelor of Arts in Sociology and Film and Media Studies, with a focus in Entertainment Advertising and Generational Analysis. After spending several years living abroad in Southeast Asia and the UK, she is now based in NYC. In her free time, you can find her (trying to) live out her favorite classic New York sit-com dreams, inspired by Friends, Seinfeld, Sex and the City, and How I Met Your Mother.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Parent Trap"
						},
						{
							"subject": "TV Show",
							"answer": "Stranger Things"
						},
						{
							"subject": "Restaurant",
							"answer": "Balthazar (New York)"
						},
						{
							"subject": "Cocktail",
							"answer": "Aperol Spritz"
						},
						{
							"subject": "Director",
							"answer": "Richard Curtis"
						}
					]
				},
				{
					"name": "Ragini Bahl",
					"jobTitle": "Vice President, Client Relationship Management ",
					"pictureUrl": "",
					"bio": "Ragini has over 10 years of experience in entertainment market research. Ragini currently manages unscripted and scripted program testing, series maintenance, and creative testing for broadcast, cable and digital-first platforms. For the past 10 years, she has worked extensively with broadcast, cable and pay-TV clients to develop best practices for scripted and unscripted programming, along with a host of normative and analytical tools to effectively assess the potential of content. In her spare time, Ragini loves anything outdoors (hiking, biking, kayaking, anything in the California sunshine) and traveling with her husband of 4 years.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Breaking Bad"
						},
						{
							"subject": "Quote",
							"answer": "\"If there is no struggle, there is no progress.\""
						},
						{
							"subject": "Book",
							"answer": "A Thousand Splendid Suns"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Vietnam"
						},
						{
							"subject": "Cocktail",
							"answer": "Greygoose and water (least amount of calories)"
						}
					]
				},
				{
					"name": "Alexander Bakeis",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Alex.Bakeis.jpg",
					"bio": "Originally from San Jose, California, Alex graduated from the University of Notre Dame in 2021, where he double majored in Marketing and Film. He previously applied his lifelong passion for entertainment at various production companies as a film and television development intern. His studies provided hands-on research experience, which led him to the Content & Strategy team. In his free time, Alex enjoys hiking, live music, and traveling..",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Veep"
						},
						{
							"subject": "Cocktail",
							"answer": "Moscow Mule"
						},
						{
							"subject": "Sports Team",
							"answer": "Notre Dame football"
						},
						{
							"subject": "Actor",
							"answer": "Laura Dern"
						},
						{
							"subject": "Director",
							"answer": "Denis Villeneuve"
						}
					]
				},
				{
					"name": "Rob Barrish",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Rob.Barrish.jpg",
					"bio": "Rob brings over 25 years of technology, platform, product and services expertise to NRG. After beginning his career at Intersearch (now Kantar) in the telecom practice, Rob joined GfK where he co-founded its US Technology practice and built up team of insights consultants focused on telecom, consumer electronics, and IT products and services for B2B and consumer brands. Rob led GfK's team of Global Account Directors for the top technology and media accounts and also served as Global Account Director for GfK's largest technology account.  Rob graduated from Franklin and Marshall College with a BA in Economics and Spanish and from University of Illinois with an MBA. Rob lives in Princeton, NJ with his wife and young daughter Sarah.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Big Lebowski"
						},
						{
							"subject": "Superhero",
							"answer": "Aquaman-Swimming is the best release"
						},
						{
							"subject": "Food",
							"answer": "Thai Food, love Yuum Salads! The hotter, the better."
						},
						{
							"subject": "Sports Teams",
							"answer": "Philadelphia Eagles, Fly Eagles Fly!"
						},
						{
							"subject": "Directors",
							"answer": "The Coen Brothers"
						}
					]
				},
				{
					"name": "Alex Behzadi",
					"jobTitle": "Senior Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Alex.Behzadi.jpg",
					"bio": "Prior to joining NRG, Alex spent five years at The Salter Group, an L.A. based media advisory firm, as well as four years managing the Analytics & Strategy team at DaVita. After receiving his MBA from the McCombs School at UT-Austin, Alex decided to transition to a career in market research, here at NRG. Outside of work, Alex loves playing sports (tennis, soccer, golf, ping pong, bowling, mini golf), going to see movies/concerts/stand-up comedy, and playing the guitar.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Bon Iver"
						},
						{
							"subject": "Movie",
							"answer": "Almost Famous"
						},
						{
							"subject": "Quote",
							"answer": "Out beyond ideas of right-doing and wrong-doing, there is a field; I will meet you there.- Rumi"
						},
						{
							"subject": "Book",
							"answer": "All the Light We Cannot See"
						},
						{
							"subject": "Sports Team",
							"answer": "Manchester United"
						}
					]
				},
				{
					"name": "Allie Bennett",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Allie.Bennett.jpg",
					"bio": "Originally from Annapolis, Maryland, Allie went to Elon University, where she graduated with degrees in Media Analytics and Cinema & Television Arts. Prior to joining NRG, Allie spent three years at MarketCast, where she worked as a Field Coordinator and Senior Analyst. Outside of work, Allie spends her time volunteering with Minds Matter of Los Angeles or cuddling up on the couch for a movie with her rescue dog, Emmy (named after the awards).  Her favorite topics of conversation outside TV and movies include politics, personality tests, board games, and where to find the best hot chocolate.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Forrest Gump"
						},
						{
							"subject": "Class in School",
							"answer": "History"
						},
						{
							"subject": "Superhero",
							"answer": "Spiderman"
						},
						{
							"subject": "Book",
							"answer": "\"Just Mercy\" by Bryan Stevenson"
						},
						{
							"subject": "Game",
							"answer": "Settlers of Catan"
						}
					]
				},
				{
					"name": "Justin Bernstein",
					"jobTitle": "Senior Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Justin.Berstein.jpg",
					"bio": "Justin is joining the Global Tracking team as a Senior Director and product lead on Franchise Futures and will be reporting to Neil Harrison. He comes from International Distribution at Paramount Pictures and is currently a part-time MBA student at USC. In his, albeit limited, free time you can find Justin staying active with his 2-year old Labradoodle, Stella, or frequenting his favorite KBBQ spot with his wife and friends.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Spy Game"
						},
						{
							"subject": "TV Show",
							"answer": "Rick and Morty"
						},
						{
							"subject": "Sports Team",
							"answer": "Manchester United"
						},
						{
							"subject": "Game",
							"answer": "Monopoly"
						},
						{
							"subject": "Book",
							"answer": "Dark Matter by Blake Crouch"
						}
					]
				},
				{
					"name": "Elizabeth Betchart",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Elizabeth.Betchart.jpg",
					"bio": "A Bay Area native, Elizabeth graduated from Santa Clara University with a Bachelor's in Communication in 2021. She joined NRG because of her love for market research and the entertainment industry. In her free time she enjoys working out, reading, and watching new movies and shows.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "500 Days of Summer"
						},
						{
							"subject": "Food",
							"answer": "Double Pepperoni Pizza"
						},
						{
							"subject": "Sports Team",
							"answer": "The San Francisco Giants"
						},
						{
							"subject": "Restaurant",
							"answer": "Nola in Palo Alto"
						},
						{
							"subject": "Book",
							"answer": "The Seven Husbands of Evelyn Hugo"
						}
					]
				},
				{
					"name": "Nick Blando",
					"jobTitle": "Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Nick.Blando.jpg",
					"bio": "Nick joined NRG in 2022 and with a background in both client relations and market research. Prior to joining NRG, he worked as a brand advocate at the Home Depot and in the consumer marketing insights division of Newell Brands. Nick graduated from Florida State University with degrees in Marketing and Political Science. He currently lives in Atlanta, GA with his fiancée, Maddie, and dog, Jameson.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Counterparts"
						},
						{
							"subject": "Movie",
							"answer": "Snatch"
						},
						{
							"subject": "Restaurant",
							"answer": "Gunshow (Atlanta, GA)"
						},
						{
							"subject": "Sports Team",
							"answer": "Chelsea FC"
						},
						{
							"subject": "Food",
							"answer": "Tacos"
						}
					]
				},
				{
					"name": "Matt Blong",
					"jobTitle": "Senior Vice President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Matt.Blong.jpg",
					"bio": "Matt oversees the LA based Global Tracking team. Matt has been with NRG since 2008, and has been focused on Global Tracking since 2012, in which time he has worked with all of the major studios to help guide their films across 13 countries. Matt joined NRG after graduating from the University of California at Santa Cruz in 2008 with a BA in Sociology. He is an avid sports fan and documentary enthusiast, and spends much of his free time chasing around his pet rabbit, Nicholas.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Big Lebowski"
						},
						{
							"subject": "Team",
							"answer": "LA Lakers"
						},
						{
							"subject": "Book",
							"answer": "The Devil in the White City"
						},
						{
							"subject": "TV Show",
							"answer": "It's Always Sunny in Philadelphia"
						},
						{
							"subject": "Food",
							"answer": "Lasagna"
						}
					]
				},
				{
					"name": "Ashleigh Bohr",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Ashleigh.Marzynski.jpg",
					"bio": "Ashleigh works primarily on creative ad testing, screenings, tracking and NRG's annual Moviegoing Report. Outside of NRG, Ashleigh teaches a graduate course, Film Economics: Marketing and Distribution for Carnegie Mellon University. She has a Masters in Entertainment Industry Management from Carnegie Mellon and a BA in Communication and Arts Management from the University of Wisconsin-Stevens Point. As a graduate student Ashleigh interned with various entertainment companies including Open Road Films, CBS Films, MGM, NBC and Nielsen. Previously she worked in aviation.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Contact "
						},
						{
							"subject": "Band",
							"answer": "Fleetwood Mac"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Door County, Wisconsin"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						},
						{
							"subject": "Team",
							"answer": "Green Bay Packers"
						}
					]
				},
				{
					"name": "Raphael Bruni",
					"jobTitle": "Senior Analyst, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Raphael joined NRG in July 2021 shortly after graduating from Boston University with a Bachelor's degree in economics. As a young professional, he is passionate about telling stories with data through rigorous analysis and has developed an extensive skillset that entails data science, research, writing, and communication. He is interested in pursuing a client-orientated career, as he feels great pride in having the ability to help others through his own work. He loves collaborating on teams, as he believes cooperation is a great way for everyone involved to refine their talents.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Arctic Monkeys"
						},
						{
							"subject": "Movie",
							"answer": "Goodfellas"
						},
						{
							"subject": "TV Show",
							"answer": "Breaking Bad"
						},
						{
							"subject": "Quote",
							"answer": "\"Truth is like poetry. And most people f*cking hate poetry.\" - Unknown (via The Big Short)"
						},
						{
							"subject": "Sports Team",
							"answer": "Greenbay Packers"
						}
					]
				},
				{
					"name": "Isaac Businger",
					"jobTitle": "Senior Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Isaac.Businger.jpg",
					"bio": "Isaac previously worked at Interpret where he was primarily tasked with film tracking and trailer test duties. He is a native east coaster (Maryland) and has a degree in Bioengineering from MIT.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Emancipator"
						},
						{
							"subject": "Movie",
							"answer": "Alien"
						},
						{
							"subject": "Quote",
							"answer": "\"Time is a great teacher, but unfortunately it kills all its pupils.\""
						},
						{
							"subject": "Sports Team",
							"answer": "Arsenal"
						},
						{
							"subject": "Director",
							"answer": "Fede Alvarez"
						}
					]
				},
				{
					"name": "Justin Campbell",
					"jobTitle": "Executive Director, Content & Strategy",
					"pictureUrl": "",
					"bio": "Justin began his career at NRG in 2003 and has experience in all facets of theatrical marketing research, most extensively creative advertising and test screenings.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Assassination of Jesse James by the Coward Robert Ford"
						},
						{
							"subject": "Band",
							"answer": "Joy Division"
						},
						{
							"subject": "Game",
							"answer": "Fallout 4"
						},
						{
							"subject": "TV Show",
							"answer": "The Office (U.S.)"
						},
						{
							"subject": "Quote",
							"answer": "\"I intend to live forever, or die trying.\" -Groucho Marx"
						}
					]
				},
				{
					"name": "Maribel Castañeda",
					"jobTitle": "Senior Analyst, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Maribel.Castaneda.jpg",
					"bio": "Maribel is a 2019 graduate of Wellesley College. She majored in Economics and minored in Philosophy, fusing her interests in both fields into a passion for consumer research. She enjoys transforming data-driven insights into impactful recommendations for clients across a variety of industries. Outside of work, you can find her lost in her thoughts pondering some of life's biggest questions: what am I having for lunch tomorrow?",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Parks and Rec"
						},
						{
							"subject": "Quote",
							"answer": "\"I think, therefore I am.\" René Descartes"
						},
						{
							"subject": "Game",
							"answer": "Fallout"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Barcelona Spain"
						},
						{
							"subject": "Restaurant",
							"answer": "Osteria Mozza ( Los Angeles)"
						}
					]
				},
				{
					"name": "James Cannice",
					"jobTitle": "Research Analyst, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/James.Cannice.jpg",
					"bio": "A Bay Area native, James graduated from Pepperdine University with a Bachelor’s in Creative Writing and, later, from the University of San Francisco with a Master’s in Marketing Intelligence. He joined NRG following his love for all forms of storytelling and discovering consumer insights. In his free time, he enjoys writing and most things spooky, whether those be books, movies, tv, video or board games, or haunted houses.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Princess Bride"
						},
						{
							"subject": "Band",
							"answer": "Panic! at the Disco"
						},
						{
							"subject": "Game",
							"answer": "Outlast 2"
						},
						{
							"subject": "Book",
							"answer": "The Return - Rachel Harrison"
						},
						{
							"subject": "TV Show",
							"answer": "Over the Garden Wall"
						}
					]
				},
				{
					"name": "Aviva Chaidell",
					"jobTitle": "Senior Research Manager, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Aviva grew up in New York City and moved back there after she graduated from American University with a degree in Statistics. She realized there that she loves to know the why in consumer behavior. Prior to joining NRG, she worked on financial services and CPG clients for four years at Ipsos. Outside of work, she loves playing different types of sports, especially baseball, and rooting on the Mets. In addition, she loves exploring new places and food in New York City and beyond.",
					"favourites": [
						{
							"subject": "Sports Team",
							"answer": "New York Mets"
						},
						{
							"subject": "Food",
							"answer": "Pasta"
						},
						{
							"subject": "Game",
							"answer": "Clue"
						},
						{
							"subject": "TV Show",
							"answer": "Bachelor Franchise"
						},
						{
							"subject": "Quote",
							"answer": "\"Life moves pretty fast. If you don't stop and look around once in a while, you could miss it. \"Ferris Bueller's Day Off"
						}
					]
				},
				{
					"name": "Christopher Charles",
					"jobTitle": "Research Operations Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Chris.Charles.jpg",
					"bio": "Chris graduated from Adelphi University with a Bachelor's in Marketing, where he developed a love of research methodology and consumer behavior. He has previously worked in Research operations and in participant screening and is now a Research Operations Coordinator with NRG. Outside of work, Chris is a tennis coach, plays team handball for Long Island and is an avid gamer.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Hailkyuu!!"
						},
						{
							"subject": "Quote",
							"answer": "\"Experience without theory is blind, but theory without experience is mere intellectual play \"Immanuel Kant"
						},
						{
							"subject": "Game",
							"answer": "God of War"
						},
						{
							"subject": "Cocktail",
							"answer": "Rum Punch"
						},
						{
							"subject": "Sports Team",
							"answer": "Aresenal"
						}
					]
				},
				{
					"name": "Valerie Chisum",
					"jobTitle": "Vice President, Platform and Technology Clients",
					"pictureUrl": "../../assets/img/people/Valerie.Chisum.jpg",
					"bio": "Valerie joined NRG in 2022 after first falling in love with the art and science of research during her Sociology courses in undergrad. In the interim years she has honed her research skills with a variety of clients across many verticals. Valerie loves a challenge and thrives when partnering with clients to design research that yields actionable insights. When she isn't researching, she enjoys being outdoors; some favorites include trail running, backpacking, volleyball, mountain biking, hiking, and scuba diving. She lives in beautiful Boise, Idaho with her husband, two children, pup, and six chickens.",
					"favourites": [
						{
							"subject": "Food",
							"answer": "Thai"
						},
						{
							"subject": "Book",
							"answer": "Cien Años de Soledad"
						},
						{
							"subject": "Game",
							"answer": "Cribbage"
						},
						{
							"subject": "Cocktail",
							"answer": "Vesper (after which her dog is named)"
						},
						{
							"subject": "Band",
							"answer": "Fleetwood Mac and Van Morrison frequently appear in her playlists"
						}
					]
				},
				{
					"name": "Lisa Clark",
					"jobTitle": "Associate Director of Research, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Lisa.Clark.jpg",
					"bio": "Based in the London office, Lisa works across various custom projects spanning a broad range of areas including TV, brand positioning and the burgeoning Chinese theatrical market. Prior to joining National Research Group she spent over 7 years working in broadcast research, starting her career at E! Entertainment, before moving to Discovery Networks and later, Sky. She is a keen photographer, a theme-park enthusiast and a lover of reality TV! ",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Clueless"
						},
						{
							"subject": "Quote",
							"answer": "\"It's kind of fun to do the impossible.\" -Walt Disney"
						},
						{
							"subject": "Vaction Spot",
							"answer": "Orlando, Florida"
						},
						{
							"subject": "TV Show",
							"answer": "Friends"
						},
						{
							"subject": "Actor",
							"answer": "Tom Hanks"
						}
					]
				},
				{
					"name": "Meghan Clough",
					"jobTitle": "Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Meghan.Clough.jpg",
					"bio": "Meghan is a member of NRG's Platform & Technology Clients team, where she partners with clients to answer their pressing business questions by conducting custom research and delivering actionable insights. Before joining NRG, Meghan started her market research career at Ipsos where she worked primarily with CPG clients to better understand market trends, brand positioning, and portfolio and growth opportunities. Meghan graduated from Miami University (Ohio) with a BA in English Literature and Buffalo State College with an MA also in English Literature.  ",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dermott Kennedy"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Anywhere on a lake with a boat."
						},
						{
							"subject": "Food",
							"answer": "Sushi"
						},
						{
							"subject": "Cocktail",
							"answer": "Spicy Margarita"
						},
						{
							"subject": "Sports Team",
							"answer": "Buffalo Bills"
						}
					]
				},
				{
					"name": "Nicole Clouser",
					"jobTitle": "Vice President, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Nicole has a passion for research, turning insight into strategy, with nearly 20 years of experience in the industry. She has worked across corporate, media, academic, and non-profit sectors, primarily focused in B2B and B2C brand health tracking, consumer experience, brand positioning, messaging and product development to drive internal and external branding and marketing efforts. On the Platforms and Technology team, Nicole helps top tech clients achieve their business goals through innovative research designs and delivering actionable research solutions. Nicole is a graduate of The George Washington University and The Queen's University, Belfast and currently lives in Boise with her husband.",
					"favourites": [
						{
							"subject": "Actor",
							"answer": "Harrison Ford"
						},
						{
							"subject": "TV Show",
							"answer": "Vera, Foyle's war and anything on Acorn/BBC"
						},
						{
							"subject": "Book",
							"answer": "\"Life is for living, go for it.\" - Jan Speulda (Nicole's Mom)"
						},
						{
							"subject": "Book",
							"answer": "The Great Gatsby"
						},
						{
							"subject": "Director",
							"answer": "Alfred Hitchcock"
						}
					]
				},
				{
					"name": "Nella Coleman",
					"jobTitle": "Senior Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Nella.Coleman.jpg",
					"bio": "Nella is a researcher and relationship builder who collects, analyzes, and reports on data that describe the ways people interact with one another, their environments, and media. She has spent years conducting interdisciplinary research in academic, corporate, nonprofit, and community-based settings across the country. Nella earned Bachelor’s degrees in Political Science and Legal Studies from University of Illinois Springfield and a Master’s degree in Criminology, Law and Society from University of California Irvine. In her free time, you can find her creating digital art, going to concerts, and binge watching tv shows.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "General Hospital"
						},
						{
							"subject": "Cocktail",
							"answer": "Mezcal Margarita"
						},
						{
							"subject": "Band",
							"answer": "Beres Hammond"
						},
						{
							"subject": "Game",
							"answer": "Animal Crossing"
						},
						{
							"subject": "Quote",
							"answer": "\"As you enter positions of trust and power, dream a little before you think.\"Toni Morrison"
						}
					]
				},
				{
					"name": "Lucy Collins",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Lucy.Collins.jpg",
					"bio": "Originally from Chicago, Lucy graduated from the University of Notre Dame with a dual degree in History and Economics. She was actively involved in several original qualitative/quantitative research projects, including a history thesis and an international economic inequality project. After graduation, she worked as an editorial assistant and researcher for a publishing company out of Chicago. In her free time, Lucy enjoys running, watching movies, travel, and discussing the significance of pop-culture moments over a good meal.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Psych"
						},
						{
							"subject": "Movie",
							"answer": "Some Like it Hot"
						},
						{
							"subject": "Sports Team",
							"answer": "Chicago White Sox"
						},
						{
							"subject": "Book",
							"answer": "East of Eden"
						},
						{
							"subject": "Director",
							"answer": "Edgar Wright"
						}
					]
				},
				{
					"name": "Nick Crofoot",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Nick.Crofoot.jpg",
					"bio": "Nick joined NRG in 2019, where he works with Platforms & Technology clients to uncover profound insights that guide important strategic decisions across the go-to-market life cycle. A seasoned research practitioner, his expertise includes product innovation, value proposition development, segmentation and market sizing, positioning and messaging strategy, corporate reputation and brand management, and issues/crisis polling. Previously he was a Senior Vice President and the global account lead for a Fortune 50 technology client at PSB Research. Nick is a graduate of Dartmouth College and lives in Denver, with his wife and two children, Palmer and Annie.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The West Wing(seasons 1-4) "
						},
						{
							"subject": "Quote",
							"answer": "\"Work hard, be kind, and amazing things will happen.\"Conan O'Brien"
						},
						{
							"subject": "Book",
							"answer": "I know it might sound a little corny, but I find something so resplendent in the simplicity of Nicholas Sparks' writing."
						},
						{
							"subject": "Game",
							"answer": "Risk"
						},
						{
							"subject": "Director",
							"answer": "Matthew Heineman"
						}
					]
				},
				{
					"name": "Francesca de la Fuente",
					"jobTitle": "Senior Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Francesca.de.la.Fuente.jpg",
					"bio": "As part of NRG's Content & Strategy, Francesca conducts quantitative and qualitative research studies at several stages of content production for entertainment clients. Before that, Francesca worked in the custom research studio at dscout inc, generating insights for technology clients. Born and raised in California, she has a B.A. in Anthropology from University of California, Los Angeles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Mad Max: Fury Road"
						},
						{
							"subject": "Quote",
							"answer": "\"Man had always assumed he was more intelligent than dolphins because he had achieved so much—the wheel, New York, wars and so on—whilst all the dolphins had ever done was muck about in the water having a good time. But conversely, the dolphins had always believed they were far more intelligent than man—for precisely the same reasons.\" Douglas Adams"
						},
						{
							"subject": "Book",
							"answer": "Watership Down"
						},
						{
							"subject": "Vaction Spot",
							"answer": "Anywhere with a nice beach."
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey Sour"
						}
					]
				},
				{
					"name": "Amber Delotsang",
					"jobTitle": "Reserach Operations Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Amber.Delotsang.jpg",
					"bio": "From Ithaca, NY and a graduate of Northeastern University, Amber is a critical thinker, leader, and skilled at balancing multiple competing priorities. She's kind of like Hermione Granger meets Nancy Drew meets Jessica Day from \"New Girl.\" Prior to NRG, she was an Associate at a media communications agency. She fell in love with research in 2020 while completing a 6-month user research internship at Patreon. In her off time, she's busy being an Asian-interest sorority National COO, exploring LA, and streaming shows and movies.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Begin Again"
						},
						{
							"subject": "Food",
							"answer": "Dumplings and anything spicy"
						},
						{
							"subject": "Restaurant",
							"answer": "Madre! Oaxacan Restaurant and Mezcaleria (Los Angeles)"
						},
						{
							"subject": "Cocktail",
							"answer": "Mezcal anything"
						},
						{
							"subject": "Quote",
							"answer": "\"Everything in moderation, including moderation.\"-Oscar Wilde"
						}
					]
				},
				{
					"name": "Kenzy Desbleds",
					"jobTitle": "Senior Research Executive, Global Tracking",
					"pictureUrl": "../../assets/img/people/Kenzie.Desbleds.jpg",
					"bio": "Kenzy is a member of the Global Tracking team and has been working in the Market Research industry for over twelve years. He joined National Research Group in 2013 and prior to this, worked for Harris Interactive UK, GfK UK and TNS Sofres France. He is fluent in French (mother tongue) and English. Kenzy studied in Limoges and La Rochelle (France). He graduated with a “Brevet de Technicien Supérieur en Commerce International”, which is equivalent to a degree in International Trade. He loves team sports, especially football, basketball and handball and is also passionate about cinema, particularly French cinema.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": ""
						},
						{
							"subject": "Band",
							"answer": ""
						},
						{
							"subject": "Book",
							"answer": ""
						},
						{
							"subject": "TV Show",
							"answer": ""
						},
						{
							"subject": "Course of School",
							"answer": ""
						}
					]
				},
				{
					"name": "Alex Di Staulo",
					"jobTitle": "Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Alex.Di.Staulo.jpg",
					"bio": "Prior to joining the Content & Strategy team, Alex graduated from Clemson University with a bachelor’s degree in Business Management and a minor in Political Science. Afterwards, Alex joined the consumer market insights team at Newell Brands where he worked with national brands such as Mr. Coffee, Crock-Pot, and Oster, however, his love for film and passion for market research and analytics drove him to pursue a role here at NRG. When he is not working, Alex enjoys playing guitar, camping, and stressing far too much about every inevitable Cleveland Browns loss.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Shins"
						},
						{
							"subject": "Movie",
							"answer": "Prisoners"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						},
						{
							"subject": "Sports Team",
							"answer": "Cleveland Brown"
						},
						{
							"subject": "Director",
							"answer": "Denis Villeneuve/Taika Waititi"
						}
					]
				},
				{
					"name": "Christina DiStefano",
					"jobTitle": "Senior Analyst, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Christina.DiStefano.jpg",
					"bio": "Christina graduated in 2020 from Bryant University, with a degree in Marketing and Communications. Her passion for research and telling a story through data led her to NRG as a Research Analyst for the Platform & Technology Clients team. Prior to NRG, she conducted research in the beauty and health & wellness industries. Outside of work, she loves to be draw, swim, or go on a hike.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Queen"
						},
						{
							"subject": "TV Show",
							"answer": "The Good Place"
						},
						{
							"subject": "Superhero",
							"answer": "Spiderman"
						},
						{
							"subject": "Game",
							"answer": "Kingdom Hearts"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Spain"
						}
					]
				},
				{
					"name": "Chinwe Ejiogu",
					"jobTitle": "Research Executive, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Chinwe.Ejiogu.jpg",
					"bio": "After recently completing her psychology degree at the University of Reading, Chinwe was brought to NRG through her love and passion for research, consumer psychology and all things entertainment. Prior to NRG, she has experience working as a Research Assistant in academia and as a UX Researcher for a start-up. In her free time, Chinwe enjoys re-watching her favourite movies, baking cookies and travelling.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Princess Bride"
						},
						{
							"subject": "TV Show",
							"answer": "New Girl"
						},
						{
							"subject": "Superhero",
							"answer": "Spider-man"
						},
						{
							"subject": "Book",
							"answer": "The Knife of Never Letting Go"
						},
						{
							"subject": "Cocktail",
							"answer": "Strawberry Daiquiri"
						}
					]
				},
				{
					"name": "Uri Farkas",
					"jobTitle": "Senior Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Uri.Farkas.jpg",
					"bio": "Uri is part of NRG’s Platforms & Technology team, where he partners with clients to tackle their unique challenges and successfully achieve their business objectives. His market research experience spans digital market research, public affairs, thought leadership, corporate reputation, and nation branding. Uri holds a B.S. in Mathematics and a B.A. Political Science from the University of Arkansas in Fayetteville, as well as master’s degrees in International Affairs and Media and Mass Communications from The New School in New York City.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "After the Fox"
						},
						{
							"subject": "Book",
							"answer": "To Kill a Mockingbird"
						},
						{
							"subject": "Game",
							"answer": "Chess"
						},
						{
							"subject": "Cocktail",
							"answer": "Chuflay"
						},
						{
							"subject": "Game Show Host",
							"answer": "Bob Barker"
						}
					]
				},
				{
					"name": "Alyssa Federico",
					"jobTitle": "Senior Director, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Alyssa is a Senior Research Director on the Platform & Technology team. She started her market research career in the Quant division at Ipsos and continued there for 8 years. Before joining NRG, she ran the CPG pod at Fuel Cycle for 2 years. A New York Native, Alyssa graduated from Manhattanville College with a Major in Business Marketing and a minor in History, and now lives in Brooklyn.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Life"
						},
						{
							"subject": "TV Show",
							"answer": "SNL"
						},
						{
							"subject": "Game",
							"answer": "Celebrity"
						},
						{
							"subject": "Cocktail",
							"answer": "Espresso Martini"
						},
						{
							"subject": "Food",
							"answer": "Charcuterie Boards"
						}
					]
				},
				{
					"name": "Heather Field",
					"jobTitle": "Vice President, Brand Strategy & Innovation",
					"pictureUrl": "../../assets/img/people/Heather.Field.jpg",
					"bio": "Heather joined NRG in 2022. Prior to NRG, Heather spent 15 years at Wunderman Thompson partnering with brands across a range of industries to inform strategy and optimize communications. She also has extensive experience in the entertainment industry having worked at NPD MusicWatch during a pivotal time when digital music was rapidly replacing legacy technologies. Heather was able to help clients understand the marketing environment and manage through this major shift in the industry. Heather is a graduate of Brown University and currently lives in Connecticut with her husband and two kids.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Neil Young"
						},
						{
							"subject": "TV Show",
							"answer": "Schitt's Creek"
						},
						{
							"subject": "Game",
							"answer": "Yahtzee"
						},
						{
							"subject": "Cocktail",
							"answer": "Aperol Spritz"
						},
						{
							"subject": "Actor",
							"answer": "Will Ferrell"
						}
					]
				},
				{
					"name": "Perri Feinsilber",
					"jobTitle": "Senior Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Perri.Feinsilber.jpg",
					"bio": "Perri creatively executes quantitative and qualitative research studies to inform development, production and marketing strategy for entertainment clients. Perri previously worked at youth-focused media company AwesomenessTV in its in-house research agency. There she became proficient in “Generation Z” and reported on youth culture insights, ranging from its ever-changing media consumption behavior to its unique perception of brands. Perri has a B.A. in Film & Media Studies and Psychology from Washington University in St. Louis. She is originally from New York.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Arcade Fire"
						},
						{
							"subject": "Book",
							"answer": "My Life on the Road by Gloria Steinem"
						},
						{
							"subject": "Movie",
							"answer": "When Harry Met Sally"
						},
						{
							"subject": "Cocktail",
							"answer": "Moscow Mule"
						},
						{
							"subject": "TV Show",
							"answer": "Broad City"
						}
					]
				},
				{
					"name": "Stephanie Fernandez",
					"jobTitle": "Research Manager, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Stephanie joined NRG in 2021 and works with our Platform & Technology clients, uncovering insights across the product lifecycle. Stephanie has extensive qualitative and quantitative experience having worked across a variety of verticals. Previously, Stephanie worked for FleishmanHillard and Lieberman Research Worldwide where she worked on international and domestic custom and tracking studies. Stephanie has a BA in Anthropology from Macalester college.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Nathan For You"
						},
						{
							"subject": "Movie",
							"answer": "The Lobster"
						},
						{
							"subject": "Game",
							"answer": "Dance Dance Revolution"
						},
						{
							"subject": "Restaurant",
							"answer": "Dr.Limon in Miami, FL"
						},
						{
							"subject": "Cocktail",
							"answer": "Pisco Sour"
						}
					]
				},
				{
					"name": "Andy Fielder",
					"jobTitle": "Vice President, Client Engagement",
					"pictureUrl": "../../assets/img/people/Andy.Fielder.jpg",
					"bio": "Andy joined NRG in 1983 and has been with the company ever since. Andy has moderated focus groups for all major studio and TV clients. Andy manages field recruiting for test audiences at the home office in Los Angeles and has conducted screenings in London, Tokyo, Mexico City, Sydney, Taipei, and Seoul. ",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Sound of Music"
						},
						{
							"subject": "Game",
							"answer": "Trivial Pursuit"
						},
						{
							"subject": "Book",
							"answer": "Lyndon Johnson The Passage of Power"
						},
						{
							"subject": "TV Show",
							"answer": "American Experience"
						},
						{
							"subject": "Class in School",
							"answer": "Theater"
						}
					]
				},
				{
					"name": "Scott Galante",
					"jobTitle": "Vice President, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Scott started his research career at the mobile game developer Gameloft, and has since worked at various research suppliers such as Benenson Strategy Group, Radius GMR, and Bovitz, working primarily in technology, foodservice, beverage, CPG, and retail verticals. Scott graduated from Skidmore College with a BA in Sociology, and is currently pursuing an MBA part-time at Fordham University. When Scott’s not working, he can typically be found playing the latest video games, practicing improv comedy, spending time with his wife and son, or trying out new slow-cooker or baking recipes.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Coheed and Cambria"
						},
						{
							"subject": "Movie",
							"answer": "Hot Fuzz"
						},
						{
							"subject": "TV Show",
							"answer": "Doctor Who"
						},
						{
							"subject": "Game",
							"answer": "Final Fantasy 7"
						},
						{
							"subject": "Food",
							"answer": "Pizza"
						}
					]
				},
				{
					"name": "Melissa Gattuso",
					"jobTitle": "Senior Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Melissa.Gattuso.jpg",
					"bio": "Melissa got her start in entertainment, gaining experience in development, management, and production. Prior to joining NRG, she was working in the intersection of entertainment, health, and research at Hollywood, Health & Society, a program of the USC Annenberg Norman Lear Center. She earned her master's in Communication Management from the University of Southern California and bachelor's in Television, Radio & Film from Syracuse University.",
					"favourites": [
						{
							"subject": "Game Show Host",
							"answer": "Alex Trebek"
						},
						{
							"subject": "Movie",
							"answer": "E.T. The Extra Terrestrial"
						},
						{
							"subject": "TV Show",
							"answer": "The Good Place"
						},
						{
							"subject": "Game",
							"answer": "Stardew Valley"
						},
						{
							"subject": "Food",
							"answer": "Bagels"
						}
					]
				},
				{
					"name": "Andrea Ghazarian",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Andrea.Ghazarian.jpg",
					"bio": "Andrea works for NRG's Content & Strategy, where her ability to extract stories from large datasets and identify patterns of behavior inform development and marketing strategy for entertainment clients. Prior to joining NRG, Andrea applied principles of behavioral science to predict consumer behavior for various Fortune 500 companies across industries during her time at System1 Research. She graduated from UCLA in 2016 with a BA in Psychology, and there developed her passion for research in the Social and Affective Neuroscience Laboratory.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "The Song of Achilles"
						},
						{
							"subject": "Movie",
							"answer": "Pride and Prejudice (2005)"
						},
						{
							"subject": "Sports Team",
							"answer": "Arsenal FC"
						},
						{
							"subject": "Quote",
							"answer": "\"My friends, you bow to no one.\""
						},
						{
							"subject": "Actress",
							"answer": "Viola Davis"
						}
					]
				},
				{
					"name": "Robert Glaser",
					"jobTitle": "Senior Research Manager, Global Tracking",
					"pictureUrl": "../../assets/img/people/Robert.Glaser.jpg",
					"bio": "Robert joined NRG in 2022 with a background in global research, having significant experience leading teams in project design, fieldwork, and reporting. Though his research background is primarily quantitative he specializes in leveraging qualitative and digital approaches to develop a comprehensive research design. His passion has always been film, earning a degree in Screenwriting from the University of Miami and providing script coverage for a major production company. He is an avid reader, a surprisingly talented home cook, and never tires of playing with dogs.",
					"favourites": [
						{
							"subject": "Director",
							"answer": "Wes Craven"
						},
						{
							"subject": "Movie",
							"answer": "The Silence of the Lambs"
						},
						{
							"subject": "Book",
							"answer": "Pet Sematary"
						},
						{
							"subject": "Sports Team",
							"answer": "San Diego Padres"
						},
						{
							"subject": "Game",
							"answer": "Scrabble"
						}
					]
				},
				{
					"name": "Carrie Gordon",
					"jobTitle": "Vice President and Research Moderator, Theatrical",
					"pictureUrl": "../../assets/img/people/Carrie.Gordon.jpg",
					"bio": "Carrie Gordon has worked as a moderator in both the theatrical and home entertainment divisions of NRG since 1995. Over the past 20 years she has worked with movie studios, production companies and independent distributors, conducting thousands of focus groups for production and marketing test screenings, as well as panels and one-on one in depth interviews. Carrie works to provide insights about moviegoers to studios and production companies, from the ideation phase and following through to post production, commercial/trailer and print ad testing.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": ""
						},
						{
							"subject": "Band",
							"answer": ""
						},
						{
							"subject": "Book",
							"answer": ""
						},
						{
							"subject": "TV Show",
							"answer": ""
						},
						{
							"subject": "Course of School",
							"answer": ""
						}
					]
				},
				{
					"name": "Cadence Greenberg",
					"jobTitle": "Senior Director, Research Design and Strategy",
					"pictureUrl": "../../assets/img/people/Cadence.Greenberg.jpg",
					"bio": "Inherently curious, Cadence joined NRG to help expand its influence as a thought leader in the entertainment and technology space, by dreaming up and conducting industry and cultural trend research. Simultaneously, she's focused on driving growth by executing custom research products centering around strategic initiatives for a variety of clients. Before joining NRG, Cadence conducted advertising effectiveness research at Kantar and custom primary research studies at PSB Research. She graduated magna cum laude from NYU with a B.A. and M.A. in Italian Studies.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Funny Girl"
						},
						{
							"subject": "TV Show",
							"answer": "The Sopranos"
						},
						{
							"subject": "Class in School",
							"answer": "History"
						},
						{
							"subject": "Quote",
							"answer": "\"He used to say that sleep after dinner was sliver, but before dinner it was golden.\""
						},
						{
							"subject": "Vacation Spot",
							"answer": "Any Beach"
						}
					]
				},
				{
					"name": "Josh Hack",
					"jobTitle": "Senior Vice President, Head of Global Content Insights",
					"pictureUrl": "../../assets/img/people/Josh.Hack.jpg",
					"bio": "Josh works with film and television studios to provide insights that guide content development, production, and marketing strategy. He specializes in global brand and positioning research, and has conducted qualitative and quantitative studies domestically and throughout Latin America, Europe, and Asia. Before joining NRG, Josh was Director of Media and Entertainment Research at Penn Schoen Berland. Prior to PSB, Josh worked in brand strategy for Grey Advertising in London. Josh has an MSc in Media and Communications from the London School of Economics and a BA in English Literature from the University of California, Los Angeles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Best Years of Our Lives"
						},
						{
							"subject": "TV Show",
							"answer": "Picket Fences"
						},
						{
							"subject": "Director",
							"answer": "Terry Gilliam"
						},
						{
							"subject": "Book",
							"answer": "Slaughterhouse-Five"
						},
						{
							"subject": "Quote",
							"answer": "\"There are two types of people in the world: those who can extrapolate from incomplete data.\""
						}
					]
				},
				{
					"name": "Matt Haes",
					"jobTitle": "Research Executive, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Matt.Haes.jpg",
					"bio": "Prior to joining NRG, Matt has seen the ins and outs of the film industry, starting with an internship at BBC Films where he discovered a passion for developing stories and engaging with content. Working on projects such as The Voice UK, independent film, commercials, and more, he's got a keen insight into the ever growing media landscape. Matt took his passion for storytelling across the world and lived on Naoshima in Japan for 2 years, teaching English and global culture local communities before working at the Japanese Embassy in London. You can usually find him travelling or surrounded by dogs.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Children of Men Singer"
						},
						{
							"subject": "TV Show",
							"answer": "RuPaul's Drag Race"
						},
						{
							"subject": "Game",
							"answer": "The Legend of Zelda (any and all)"
						},
						{
							"subject": "Actress",
							"answer": "Cate Blanchett"
						}
					]
				},
				{
					"name": "Jeff Hall",
					"jobTitle": "Executive Vice President, Head of Qualitative",
					"pictureUrl": "../../assets/img/people/Jeff.Hall.jpg",
					"bio": "Jeff was born and raised in Rochester, New York and got his undergraduate degree in Marketing at the University of Oklahoma. He received his Masters in Business Administration in Finance and Marketing at the Simon School of Business at the University of Rochester. He began his career as a research executive at Young and Rubicam New York, and helped win the 20th Century Fox account for Y&R, moving to Hollywood soon after. In Hollywood he worked at NRG (the first time) for 5 years before moving to Warner Bros Pictures, then later to Paramount Pictures where he ran Theatrical Market Research for 15 years. He joined PSB in 2012 to grow their qualitative offerings, and came full circle back to NRG in January of 2016. At PSB and NRG he has worked on a wide range of projects from TV shows, hair color, movie franchises, restaurants, video games, celebrity chefs and more.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Blondie"
						},
						{
							"subject": "Movie",
							"answer": "Casablanca"
						},
						{
							"subject": "Superhero",
							"answer": "The Creeper"
						},
						{
							"subject": "Food",
							"answer": "Veal Scallopini"
						},
						{
							"subject": "Actor",
							"answer": "Humphrey Bogart"
						}
					]
				},
				{
					"name": "Megan Harmon",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Meg.Harmon.jpg",
					"bio": "Megan specializes in generating key insights for marketing, branding, and development strategy through custom research for key entertainment players across TV, streaming, theatrical, and other media. Her experience spans a variety of methodologies, audiences, and global markets, translating dense information into actionable recommendations via visual storytelling and using advanced analytics to level up findings. Prior to NRG, Megan has been a part of the custom research teams at MarketCast and Ipsos. Megan has a Masters degree in Applied Psychology with a specialization in Consumer Psychology from the University of Southern California.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Interpol"
						},
						{
							"subject": "Movie",
							"answer": "Donnie Darko"
						},
						{
							"subject": "Superhero",
							"answer": "Sailor Moon"
						},
						{
							"subject": "Book",
							"answer": "Watchmen"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						}
					]
				},
				{
					"name": "Adam Harris",
					"jobTitle": "Senior Research Executive, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Adam.Harris.jpg",
					"bio": "Prior to joining NRG in 2021, Adam was in the Senior Management at Vue Entertainment's flagship complex; The West End Leicester Square. Coordinating events as varied as the \"A Star is Born\" UK premiere through to the 2019 London Film Festival’s main venue, Adam has strong knowledge of working with studios, screen content and corporate sales; the aim to ensure every piece of content receives the attention required to deliver upon its full potential. Adam has always had a love of entertainment, previously working on a TV website to determine the odds of renewal for primetime shows.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": " Jurassic Park"
						},
						{
							"subject": "TV Show",
							"answer": "LOST"
						},
						{
							"subject": "Sports Team",
							"answer": "Newcastle United (Football)"
						},
						{
							"subject": "Actor",
							"answer": "Jeff Goldblum"
						},
						{
							"subject": "Quote",
							"answer": "\"All we have to decide is what to do with the time that is given to us.\" - Gandalf the Grey"
						}
					]
				},
				{
					"name": "Neil Harrison",
					"jobTitle": "President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Neil.Harrison.jpg",
					"bio": "Neil joined NRG in 2006 to relaunch its international tracker, and continues to lead its management and development, in addition to working across product and business development. Neil is a European Studies graduate from Bath University, and has a Masters in Media from the University of Glasgow. After two years teaching in Paris, he began his film career in distribution at FilmFour in London, before moving into market research at FirstMovies, prior to joining NRG.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Lawrence of Arabia"
						},
						{
							"subject": "Book",
							"answer": "Fathers and Sons"
						},
						{
							"subject": "Actor",
							"answer": "Jean Gabin"
						},
						{
							"subject": "Actress",
							"answer": "Ingrid Berman"
						},
						{
							"subject": "Director",
							"answer": "Aki Kaurismäki"
						}
					]
				},
				{
					"name": "Colton Herrington",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Colton.Herrington.jpg",
					"bio": "Colton is part of the Content & Strategy team where he partners with streaming, theatrical, and traditional TV clients in optimizing their creative materials and overall creative strategy. His previous experience includes working in the Campaign Analytics department at MarketCast, and before that, on the studio side in a dual research and media role at Relativity EuropaCorp Distribution. Colton studied Integrated Marketing Communications and Business Administration at the University of Mississippi, where he was also a film critic for The Daily Mississippian and a member of the honors college. He graduated summa cum laude.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Florence + the Machine"
						},
						{
							"subject": "Movie",
							"answer": "Hereditary"
						},
						{
							"subject": "TV Show",
							"answer": "The Comeback"
						},
						{
							"subject": "Cocktail",
							"answer": "Boulevardier"
						},
						{
							"subject": "Actress",
							"answer": "Natalie Portman"
						}
					]
				},
				{
					"name": "Holly Hewlett",
					"jobTitle": "Senior Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Holly.Hewlett.jpg",
					"bio": "Holly brings eight years of international entertainment experience, having started her career in digital marketing for major studios and entertainment brands, before transitioning into market research. Prior to joining NRG, she spent six years at MarketCast, leading on both qualitative and quantitative projects and becoming a trusted thought-partner to theatrical and streaming clients across the globe. In this unique and fast-moving space, Holly understands the importance of using research to tell a story that is clear, concise and, most importantly, actionable. She has a strong understanding of local market nuance and uses this foundation to inform both global and market-specific analysis. Holly graduated from New College, University of Oxford with a degree in Ancient and Modern History. In her free time, she is an avid reader, Netflix binger and an amateur competitive powerlifter.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Titanic"
						},
						{
							"subject": "Favorite Class in School",
							"answer": "History"
						},
						{
							"subject": "Quote",
							"answer": "When something goes wrong in your life, just yell 'plot twist!' and move on"
						},
						{
							"subject": "Favorite Book",
							"answer": "The Age of Innocence"
						},
						{
							"subject": "Favorite Cocktail",
							"answer": "Aperol Spritz"
						}
					]
				},
				{
					"name": "Soubie Im",
					"jobTitle": "Senior Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Soubie.Im.jpg",
					"bio": "Soubie graduated from the University of Pennsylvania with a degree in Philosophy, Political Science, and Economics, and a minor in Survey Research and Data Analytics. Prior to joining NRG, she was with Nielsen, where she worked with CPG clients. Soubie's love for both data analytics and the entertainment industry was what brought her to NRG. Outside of work, she loves listening to pop culture podcasts and hiking.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Strokes"
						},
						{
							"subject": "TV Show",
							"answer": "Breaking Bad"
						},
						{
							"subject": "Book",
							"answer": "Steve Jobs Walter Isaacson"
						},
						{
							"subject": "Game",
							"answer": "Sims 3 and Zoo Tycoon"
						},
						{
							"subject": "Food/Dish",
							"answer": "Anything Korean"
						}
					]
				},
				{
					"name": "Deepa Iyengar",
					"jobTitle": "Executive Vice President, Head of Qualitative ",
					"pictureUrl": "",
					"bio": "Deepa, a renowned market research expert, has more than 20 years of qualitative and quantitative experience covering all key vertials and every phase of the product lifecycle. As EVP, Head of Qualitative on the Platforms and Tech team, she is responsible for building and growing integrated qualitative capabilities and services. Prior to NRG, Deepa led qualitative and UX research at Ipsos for two of the company's biggest global tech accounts. She has a strong academic background with two MBAs and a Masters in International Relations from the world's leading academic institutions. Deepa lives in California with her husband and 2 dogs.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Breaking Bad and Sons of Anarchy"
						},
						{
							"subject": "Movie",
							"answer": "Lord of the Rings"
						},
						{
							"subject": "Band",
							"answer": "Eagles"
						},
						{
							"subject": "Book",
							"answer": "Pillars of the Earth"
						},
						{
							"subject": "Food",
							"answer": "Anything East Asian, South-East Asian and Peruvian"
						}
					]
				},
				{
					"name": "Devika Johar",
					"jobTitle": "Senior Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Devika.Johar.jpg",
					"bio": "Devika's first glimpse into the world of research was as a respondent, when at 7 years old she spilled her guts about Barbie for an afternoon. Cut to a couple decades later, she's a qualitative researcher and brand strategist with over 8 years of experience across various categories and global markets. Her heart lies with media research, though, and she believes in the power of content to change the world. She's worked extensively with clients such as MTV, Sony Pictures and Disney to evolve their brand values, launch new channels and shows as well as develop a strong content strategy. She finds joy in designing new methodologies and techniques to arrive at richer insights and has presented a number of papers at international research forums. When she isn't working or binge watching her favorite shows for the 700th time, Devika is feeding her culinary passion and creating vegan desserts.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Grey's Anatomy, The Newsroom"
						},
						{
							"subject": "Quote",
							"answer": "\"Be a little kinder than you have to.\" -E. Lockhart"
						},
						{
							"subject": "Superhero",
							"answer": "Professor Minerva McGonagall! Her superpower - absolute badassery!"
						},
						{
							"subject": "Book",
							"answer": "The Harry Potter Series"
						},
						{
							"subject": "Director",
							"answer": "Zoya Akhtar"
						}
					]
				},
				{
					"name": "Jacklyn Juetten",
					"jobTitle": "Research Manager, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Jacklyn.Juetten.jpg",
					"bio": "Jacklyn joined NRG in 2022 and works with Platform & Technology clients. She has a passion for storytelling and comes to NRG from Lake Research Partners where she conducted qualitative and quantitative research for candidates for public office, advocacy groups, and municipalities. Prior to this she worked on political and organizing campaigns for organized labor. Based in her native Los Angeles, Jacklyn holds a B.A. in Political Science from San Jose State University and an M.A in Political Science from California State University, Los Angeles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "5th Element"
						},
						{
							"subject": "Food",
							"answer": "Noodles of any kind"
						},
						{
							"subject": "Game Show Host",
							"answer": "Steve Harvey"
						},
						{
							"subject": "Actor",
							"answer": "Sharon Stone"
						},
						{
							"subject": "Book",
							"answer": "The Sorrows of Young Werther"
						}
					]
				},
				{
					"name": "Gabi Kassnar",
					"jobTitle": "Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Gabi.Kassnar.jpg",
					"bio": "Gabi has nearly 8 years of experience working on a wide range of consumer brands and issues research, including corporate reputation, brand positioning, creative testing and messaging, with a strong focus on turning insight into strategy. Prior to joining NRG, she worked at PSB Research and the Glover Park Group in Washington D.C. before that. Gabi is a graduate of American University where she earned a B.S. in Business Administration with a concentration in Marketing and a Minor in Communication Studies.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dave Matthews Band"
						},
						{
							"subject": "Quote",
							"answer": "\"Winter is coming.\" -House Stark"
						},
						{
							"subject": "TV Show",
							"answer": "Friends"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Monteverde, Costa Rica"
						},
						{
							"subject": "Sports Team",
							"answer": "Philadelphia Eagles"
						}
					]
				},
				{
					"name": "Jay Kaufman",
					"jobTitle": "Executive Vice President, Head of Sports",
					"pictureUrl": "../../assets/img/people/Jay.Kaufman.jpg",
					"bio": "Jay joined NRG in 2021 to lead and formally launch the growing sports research and consulting practice within Platforms & Technology. Previously, he spent 20+ years at the NBA, most recently as Senior Vice President, Global Research & Insights. In that role. Jay was responsible for using data and insights to guide strategy and decision-making across the league’s media business, global fan growth strategies, game and product research, brand positioning, partnerships and critical issues tracking. Jay lives just outside of New York City with his wife and daughter.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Dumb and Dumber"
						},
						{
							"subject": "TV Show",
							"answer": "Curb Your Enthusiasm"
						},
						{
							"subject": "Band",
							"answer": "Pearl Jam"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						},
						{
							"subject": "Sports Team",
							"answer": "I love all my Boston teams equally"
						}
					]
				},
				{
					"name": "Matt Keating",
					"jobTitle": "Senior Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Matt.Keating.jpg",
					"bio": "Matt is passionate about helping drive action within clients' organizations. Managing custom qualitative and quantitative research across the entire business lifecycle, he is a consultative partner on strategic business questions among B2C and B2B audiences. Prior to joining NRG, Matt held insights roles on both the client and supplier-side including eight years at GfK working with technology and telecommunications clients.  Matt graduated from The College of New Jersey with a BA in Sociology and The University of Connecticut with a MA in Survey Research.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The Big Bang Theory"
						},
						{
							"subject": "Book",
							"answer": "The Martian- Andy Weir"
						},
						{
							"subject": "Game",
							"answer": "Stratego"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Banff, AB and Canada"
						},
						{
							"subject": "Restaurant",
							"answer": "One53 (Rocky Hill, NJ); Charcoal (Yardley, PA)"
						}
					]
				},
				{
					"name": "Katie Kelley",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Katie.Kelley.jpg",
					"bio": "Katie works with both our film and streaming clients to provide global expertise and consultancy. She is an expert in both qualitative and quantitative studies, and works across all stages of the content lifecycle, including global greenlight, franchise/series development, content testing & screening, and marketing campaign positioning strategy. Prior to joining NRG, Katie was VP of International Research & Strategy at Paramount Pictures, and she is uniquely positioned to advise our clients on their biggest global content production and marketing questions. Prior to this, Katie worked in the UK for PSB First Movies and Virgin Atlantic. Katie has a BA in Politics & American Studies from Sussex University, UK & Georgetown University.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The X Files"
						},
						{
							"subject": "Vacation",
							"answer": "Santorini, Greece"
						},
						{
							"subject": "Restaurant",
							"answer": "The Duke William, Ickham, UK"
						},
						{
							"subject": "Cocktail",
							"answer": "French 75"
						},
						{
							"subject": "Actress",
							"answer": "Emma Thompson"
						}
					]
				},
				{
					"name": "Nicole Keklik",
					"jobTitle": "Research Director, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Nicole joins the Platform and Technology team as a Research Director, where she focuses on the team’s qualitative offerings. Nicole specializes in moderating across different projects and approaches to uncover rich consumer insights that inform client’s key business questions. Nicole got her start in London where she immersed herself in the world of culture and insights, specifically focusing on youth audiences and worked with a plethora of media, tech, content, gaming and toy clients. Nicole graduated from Quinnipiac University with her MBA and played Division I tennis. Nicole is a moderation whisperer, when she’s not moderating you can find her obsessing over her English Cream Retriever, George.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Goodfellas OR Bridesmaids"
						},
						{
							"subject": "TV Show",
							"answer": "Ozark"
						},
						{
							"subject": "Cocktail",
							"answer": "Spicy Ginger Margarita"
						},
						{
							"subject": "Game Show Host",
							"answer": "Wayne Brady"
						},
						{
							"subject": "Sports",
							"answer": "Tennis"
						}
					]
				},
				{
					"name": "Yaz Khan",
					"jobTitle": "Research Manager, Global Tracking",
					"pictureUrl": "",
					"bio": "Yaz joined NRG in 2021 as part of the Global Tracking Team. She is based in the UK but supports both teams out of LA and London. Prior to NRG, Yaz was employed at Comscore and managed the reporting of box office data where she established strong working relationships with multiple clients within film distribution and exhibition. Later she moved across to Comscore’s partner Gower Street Analytics providing box office estimates across six major markets, supporting studios to maximise revenue for their films.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The honest answer is probably Titanic (apparently I watched it 3 times in a row)"
						},
						{
							"subject": "Food",
							"answer": "Chocolate"
						},
						{
							"subject": "TV Show",
							"answer": "Strictly Come Dancing"
						},
						{
							"subject": "Game Show Host",
							"answer": "Michael McIntyre"
						},
						{
							"subject": "Band",
							"answer": "Boyz II Men"
						}
					]
				},
				{
					"name": "Paige Klaniecki",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Paige.Klaniecki.jpg",
					"bio": "Paige comes to NRG with a lifelong passion for all things storytelling and entertainment. A Philadelphia native with a love of bad puns, she graduated from Temple University in 2017 with a BA in English, Film & Media Arts, and Economics, and has both dramaturgy experience from the Philadelphia Theatre Company as well as corporate marketing and branding experience in the housing and tech industries. When not enjoying the latest hit series, film, or video game, Paige spends her free time writing, cooking new recipes (and occasionally succeeding), traveling, playing Dungeons & Dragons, and creating museum scavenger hunts.",
					"favourites": [
						{
							"subject": "Movies",
							"answer": "The Lord of the Rings trilogy"
						},
						{
							"subject": "TV Shows",
							"answer": "There are too many to choose from! But recently? Barry"
						},
						{
							"subject": "Book",
							"answer": "Cloud Atlas"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Anywhere and everywhere-- I love traveling!"
						},
						{
							"subject": "Cocktail",
							"answer": "Last Word"
						}
					]
				},
				{
					"name": "Moeka Komachi",
					"jobTitle": "Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Moe.Komachi.jpg",
					"bio": "Moe has academic and professional experience spanning three continents, and is fluent in English and Japanese, with working proficiency in Mandarin. Prior to joining National Research Group, she worked at PSB Research where she managed the gaming division. Moe graduated from the University of Southern California with an MS in Applied Psychology and also has a BSocSc degree in Psychology and Criminology from The University of Hong Kong. Outside of work, she can be found enjoying any LA fad from yoga, kickboxing, “hiking” with Pokémon GO, to cronuts.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "La La Land"
						},
						{
							"subject": "Quote",
							"answer": "The fridge is a clear example that what matters is what's inside. "
						},
						{
							"subject": "Class in School",
							"answer": "PE"
						},
						{
							"subject": "Game",
							"answer": "Disney Tsum Tsum"
						},
						{
							"subject": "Cocktail",
							"answer": "Amaretto Sour"
						}
					]
				},
				{
					"name": "Sammy Kong",
					"jobTitle": "Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Sammy.Kong.jpg",
					"bio": "Sammy joined NRG in 2017 with 7 years of international media research, starting off at Lagardère in Paris before moving back to London to work for Discovery Networks and Viacom (mostly covering MTV, Comedy Central and Nickelodeon). As well as having experience in global multi-platform reporting, she has worked across primary research projects such as content testing, media consumption, marketing, branding and consumer product innovation. Sammy graduated from Henley Business School with a Bachelors degree in International Business with French. She loves trying new events from the latest restaurant to dancing in the London 2012 Olympic Opening Ceremony!",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The Big Bang Theory"
						},
						{
							"subject": "Superhero",
							"answer": "IronMan"
						},
						{
							"subject": "Food/Dish",
							"answer": "Eggs"
						},
						{
							"subject": "Cocktail",
							"answer": "Espresso Martini"
						},
						{
							"subject": "Actor",
							"answer": "Tom Hardy"
						}
					]
				},
				{
					"name": "Eliza Kosse",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Eliza.Kosse.jpg",
					"bio": "A recent Classics graduate from the University of Cambridge, Eliza joined NRG in Summer 2017 and has since been splitting her time between ad hoc projects and international tracking. As a newcomer to the industry, she is always eager to get involved with new opportunities, and balances this alongside her three passions – film, books and coffee.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Glass Animals"
						},
						{
							"subject": "Movie",
							"answer": "Three Billboards Outside Ebbing, Missouri"
						},
						{
							"subject": "Book",
							"answer": "Ethan Frome"
						},
						{
							"subject": "Game",
							"answer": "Articulate"
						},
						{
							"subject": "Actor",
							"answer": "Colin Farrell"
						}
					]
				},
				{
					"name": "David Lawson",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/David.Lawson.jpg",
					"bio": "David has years of strategic experience across a variety of industries and methodologies. He started his career working on brand identity and awareness initiatives for clients such as Verizon Wireless, TJ Maxx/Marshalls and Dunkin Donuts. Following, he managed long term communities for PepsiCo and General Mills. Most recently, David worked as lead moderator where he managed qualitative research initiatives in network and TV show positioning, campaign development, and series maintenance. Throughout his career, he has moderated hundreds of groups, ethnographies, IDIs, and more across a range of industries and demographics.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Italian Job"
						},
						{
							"subject": "TV Show",
							"answer": "Six Feet Under"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Amsterdam"
						},
						{
							"subject": "Restaurant",
							"answer": "Avec (Chicago)"
						},
						{
							"subject": "Cocktail",
							"answer": "Bourbon"
						}
					]
				},
				{
					"name": "Adam Lehner",
					"jobTitle": "Senior Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Adam.Lehner.jpg",
					"bio": "Adam uses his background in data and research initiatives to report on consumer and entertainment insights for the Content & Strategy team out of the NY office. Prior to NRG, Adam coordinated quantitative and qualitative research studies for a range of media clients at Edelman Intelligence. A proud native of Western NY, Adam graduated from Syracuse University with degrees in Economics and American History. Outside the office, you can find him listening to the latest Ringer podcast, tracking Oscars favorites, or stressfully watching the Vikings on Sundays.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "A Star is Born"
						},
						{
							"subject": "TV Show",
							"answer": "Succession"
						},
						{
							"subject": "Book",
							"answer": "Anna Karenina"
						},
						{
							"subject": "Food/Dish",
							"answer": "Garbage Plate"
						},
						{
							"subject": "Actor",
							"answer": "Jack Nicholson"
						}
					]
				},
				{
					"name": "Collin Leirvik",
					"jobTitle": "Executive Vice President, Head of Gaming",
					"pictureUrl": "../../assets/img/people/Collin.Leirvik.jpg",
					"bio": "Collin joined NRG in 2020 to lead games and interactive media practice within Platforms & Technology. Collin brings extensive industry passion and experience to the team, as well as his expertise as a mix methods research and strategist. Previously, he was Vice President, Head of Quantitative at LRW Greenberg, leading programs for industry leading platform, publisher, developers, and emerging technology brands. Collin lives in the San Francisco Bay Area with his wife and two children, Grayson and Elias.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Khruangbin"
						},
						{
							"subject": "Movie",
							"answer": "There Will Be Blood"
						},
						{
							"subject": "Game",
							"answer": "Skyrim"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Kauai"
						},
						{
							"subject": "Director",
							"answer": "Paul Thomas Anderson"
						}
					]
				},
				{
					"name": "Justin Leo",
					"jobTitle": "Lead Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Justin.Leo.jpg",
					"bio": "Justin assists NRG's research analysts, helping them out with screenings, ad testing, tracking and being the main survey designer. Prior to this role, Justin was the office coordinator, a team leader in NRG's coding department, an advisor on student films, and an office manager at a small production com. He holds a BA in Communication from La Salle University in Philadelphia, and an MFA in film from Chapman University in Orange County. Justin and his wife enjoy movies, travelling, and culinary arts. Justin keeps a close eye on the NBA and NFL (especially Philadelphia sports teams).",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Big Lebowski"
						},
						{
							"subject": "Vacation Spot",
							"answer": "San Simeon, California"
						},
						{
							"subject": "Team",
							"answer": "Philadelphia Eagles"
						},
						{
							"subject": "TV Show",
							"answer": "The Venture Brothers"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Amberly Lerner",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Amberly.Lerner.jpg",
					"bio": "A longtime fan of pop culture and entertainment, Amberly got a B.A. in English and Communication Studies at the University of Massachusetts Amherst, which culminated in a senior thesis on the representation of Asian American characters in Netflix Original Programming, a paper that has been published in an undergraduate academic journal. First working for a boutique research agency, Amberly honed critical market research skills before taking the plunge at NRG, learning methodologies such as focus groups, IDIs, concept tests, segmentations, and more. When not at work, Amberly loves to play Dungeons & Dragons and cheer on the Colorado Avalanche.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Moonlight"
						},
						{
							"subject": "TV Show",
							"answer": "Schitt's Creek"
						},
						{
							"subject": "Food",
							"answer": "Beef Chow Fun"
						},
						{
							"subject": "Game",
							"answer": "Dungeons & Dragons"
						},
						{
							"subject": "Director",
							"answer": "Bong Joon-Ho"
						}
					]
				},
				{
					"name": "Casey Linehan",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Casey.Linehan.jpg",
					"bio": "Originally from Rye, New York, Casey graduated in 2020 from the University of Pennsylvania with a Bachelor's degree in business analytics and marketing. She interned with NRG in the Summer of 2019 before joining full time as an analyst for the Content & Strategy team. Outside of work, Casey enjoys baking and writing plays and music.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Mountain Goats"
						},
						{
							"subject": "Movie",
							"answer": "Eternal Sunshine of the Spotless Mind"
						},
						{
							"subject": "TV Show",
							"answer": "Community"
						},
						{
							"subject": "Food/Dish",
							"answer": "Thanksgiving Dinner"
						},
						{
							"subject": "Cocktail",
							"answer": "Rosemary Orange Gin and Tonic"
						}
					]
				},
				{
					"name": "Alec Lintz",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Alec.Lintz.jpg",
					"bio": "A native of Cleveland, Ohio, Alec graduated from Duke University with a degree in Public Policy and certificate in Markets and Management Studies. His admiration for the inspiring power of storytelling brings him to NRG from Washington, where he spent his early career in research across various parts of the federal government and think thanks. Outside of work, Alec enjoys playing and hosting bar trivia, spending time with family, perfecting his homemade movie theater popcorn recipe, and prematurely graying his hair as a Duke men's basketball fan.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Avengers: Endgame"
						},
						{
							"subject": "Superhero",
							"answer": "Scarlet Witch"
						},
						{
							"subject": "Game",
							"answer": "Star Wars: Battlefront II (2005)"
						},
						{
							"subject": "Food/Dish",
							"answer": "Bibimbap"
						},
						{
							"subject": "Restaurant",
							"answer": "Heavenly Buffaloes (Durham, NC)"
						}
					]
				},
				{
					"name": "Sarah Liu",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Sarah.Liu.jpg",
					"bio": "Sarah graduated from the University of Chicago majoring in Economics and Cinema & Media Studies, and earned her Master's degree in Global Media and Communications from the University of Southern California and the London School of Economics and Political Science. Originally an aspiring auteur, Sarah developed a passion for social science research through several graduate research projects analyzing entertainment professionals' work experiences in the animation, video game, and music industries in China and the United States. In her spare time, Sarah enjoys crafting new story ideas, streaming video games on Twitch, and playing urban folk ballads on the guitar.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Fallen Angels (1995)"
						},
						{
							"subject": "Class in School",
							"answer": "Post-War American Avant-Garde Cinema"
						},
						{
							"subject": "Book",
							"answer": "The Order of Odd Fish"
						},
						{
							"subject": "Game",
							"answer": "Honor of Kings"
						},
						{
							"subject": "Director",
							"answer": "Zhou Hao"
						}
					]
				},
				{
					"name": "Hillary Lynch",
					"jobTitle": "Senior Analyst, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Graduating summa cum laude from UCLA with a degree in Communications, Hillary started at NRG as an intern for the Platforms & Technology team before joining as a full-time analyst. Outside of work, you can usually find her at a basketball game or visiting the San Diego Zoo and Safari Park.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Atitude 67"
						},
						{
							"subject": "Movie",
							"answer": "Chinatown"
						},
						{
							"subject": "Game",
							"answer": "Hard to pick one, so I'll go with the Batman: Arkham series as a whole"
						},
						{
							"subject": "Sports Team",
							"answer": "Dallas Mavericks"
						},
						{
							"subject": "Actress",
							"answer": "Ingrid Bergman"
						}
					]
				},
				{
					"name": "Miguel Madrigal",
					"jobTitle": "Research Operations Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Miguel.Madrigal.jpg",
					"bio": "Miguel graduated from California State University, Northridge with a Bachelor's Degree in Marketing and a minor in Writing and Rhetoric. Before joining NRG, he worked on the T-Mobile account at Initiative, a marketing agency under the Interpublic Group umbrella. When he isn't working, Miguel enjoys testing the limits of his air fryer.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Beach House"
						},
						{
							"subject": "Movie",
							"answer": "Children of Men"
						},
						{
							"subject": "Book",
							"answer": "The Stranger"
						},
						{
							"subject": "Game",
							"answer": "Disco Elysium"
						},
						{
							"subject": "Director",
							"answer": "Gaspar Noe"
						}
					]
				},
				{
					"name": "Nicky Maspons",
					"jobTitle": "Research Analyst, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Nicky.Maspons.jpg",
					"bio": "Nicky graduated from the University of Miami in 2020 with a Bachelor’s in finance and a Master’s in analytics. Prior to joining NRG, he worked at Misfits Gaming as a member of the sales team. Nicky’s passion for gaming and data driven storytelling is what led him to join NRG. When not at work, you can find him doing all the things he pretended not to like in high school: reading comics, playing Dungeons & Dragons, and watching cartoons and anime.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Adventure Time"
						},
						{
							"subject": "Game",
							"answer": "Hearthstone"
						},
						{
							"subject": "Band",
							"answer": "Run The Jewels"
						},
						{
							"subject": "Movie",
							"answer": "Superbad"
						},
						{
							"subject": "Director",
							"answer": "John Hughes"
						}
					]
				},
				{
					"name": "Aline Matthewsian",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Aline.Matthewsian.jpg",
					"bio": "Aline works closely with clients across all stages of the TV content lifestyle, breathing life into data and guiding key business decisions. Her primary research experience also includes brand tracking, ad effectiveness, and evaluation of brand health and equity. She graduated from UCLA with her Bachelor of Arts in Psychology and later received her Masters in Communication Management, with an emphasis in Entertainment, from USC.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Robin Hood: Men in Tights"
						},
						{
							"subject": "TV Show",
							"answer": "Friday Night Lights"
						},
						{
							"subject": "Quote",
							"answer": "\"Spontaneity is the best kind of adventure.\""
						},
						{
							"subject": "Vacation Spot",
							"answer": "Costa Rica"
						},
						{
							"subject": "Sports Team",
							"answer": "Lakers"
						}
					]
				},
				{
					"name": "Ryan Mauri",
					"jobTitle": "Senior Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Ryan.Mauri.jpg",
					"bio": "Ryan joined NRG in 2021 as part of the sports research and consulting practice within the Platforms & Technology team. He has over 10 years of market research experience, the majority of which focusing on sports & entertainment at Ipsos, ViacomCBS and Nielsen Sports. Ryan lives just outside of New York City in Long Island with his wife and son.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Shawshank Redemption & The Dark Knight"
						},
						{
							"subject": "TV Show",
							"answer": "Survivor"
						},
						{
							"subject": "Game",
							"answer": "Madden"
						},
						{
							"subject": "Sports Team",
							"answer": "Tennessee Titans"
						},
						{
							"subject": "Food",
							"answer": "Meatball Pizza"
						}
					]
				},
				{
					"name": "John McAllister",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/John.McAllister.jpg",
					"bio": "After working in education, John obtained his Master of Entertainment Industry Management degree from Carnegie Mellon University. As a student, he developed a passion for research and its ability to inform creative decisions. That lead him to join NRG as a Research Analyst. He has previously completed research projects for A&E Networks and Programmers of Color Collective as well as interned for a variety of entertainment companies like Solstice Studios, Megalomedia, and Faceware.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The Real Housewives of Any City"
						},
						{
							"subject": "Band",
							"answer": "HAIM"
						},
						{
							"subject": "Food",
							"answer": "Peanut Butter"
						},
						{
							"subject": "Game Show Host",
							"answer": "Padma Lakshmi"
						},
						{
							"subject": "Actor",
							"answer": "Toni Collette"
						}
					]
				},
				{
					"name": "Amber McBenttez",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Amber.McBenttez.jpg",
					"bio": "Amber leads NRG's Content & Strategy team, specializing in providing consultative research to entertainment clients (across film, television, and OTT) to guide branding, marketing, and content strategies. Amber is an expert in custom primary research and has substantial experience implementing advanced statistical and analytical approaches to customize solutions, including multi-dimensional segmentations, factor analysis, linear regression models, and conjoint/discrete choice analysis. Prior to NRG, Amber led the custom primary research team at Nielsen, supporting all US media clients. Amber has a degree in Sociology and Spanish from the University of California, Los Angeles.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "This is Us "
						},
						{
							"subject": "Quote",
							"answer": "\"It's Fine\""
						},
						{
							"subject": "Food/Dish",
							"answer": "Any and all Mexican food "
						},
						{
							"subject": "Cocktail",
							"answer": "Dirty Martini(but not too dirty!)"
						},
						{
							"subject": "Actor",
							"answer": "Denzel Washington"
						}
					]
				},
				{
					"name": "Megan McKown",
					"jobTitle": "Senior Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Megan.McKown.jpg",
					"bio": "Megan graduated from Villanova University, where she studied marketing and international business. Prior to joining NRG, she worked in television media planning at Essence Global. Megan's love of research and storytelling brought her to NRG as well as the opportunity to work in the fast-paced entertainment industry. Outside of work she enjoys hiking, traveling, fitness, and reading.",
					"favourites": [
						{
							"subject": "Class in School",
							"answer": "Art History"
						},
						{
							"subject": "Book",
							"answer": "Life of Pi - Yann Martel"
						},
						{
							"subject": "Game",
							"answer": "Exploding Kittens"
						},
						{
							"subject": "Cocktail",
							"answer": "Moscow Mule"
						},
						{
							"subject": "Team",
							"answer": "Pittsburgh Steelers"
						}
					]
				},
				{
					"name": "Faye Mendes",
					"jobTitle": "Senior Research Executive, Global Tracking",
					"pictureUrl": "../../assets/img/people/Faye.Mendes.jpg",
					"bio": " Prior to joining National Research Group, Faye worked at TTI Global and TNS. She graduated from EHSAL European University College Brussels Dubai in 2009 with a Masters of Business Administration specializing in Marketing. She is passionate about photography, trying out different cuisines (with special love for Arabic cuisine), and loves watching movies.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Lord of the Rings Trilogy"
						},
						{
							"subject": "Quote",
							"answer": "\"For success, attitude is equally important as ability.\" -Walter Scott"
						},
						{
							"subject": "Book",
							"answer": "Pride and Prejudice"
						},
						{
							"subject": "Director",
							"answer": "Steven Spielberg"
						},
						{
							"subject": "Band",
							"answer": "Backstreet Boys"
						}
					]
				},
				{
					"name": "Eve Metallo",
					"jobTitle": "Senior Research Manager, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Eve developed a passion for market research when studying at Michigan State University, where she graduated with a Master’s Degree in Marketing Research. Before joining NRG, Eve conducted market research at Lieberman Research Worldwide and Voxpopme in a variety of verticals. Outside of work, she enjoys surfing, running, hiking, spending time in the great outdoors, and traveling.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "50 First Dates"
						},
						{
							"subject": "Quote",
							"answer": "\"Integrity is doing the right thing, even when no one is watching.\" -C.S. Lewis"
						},
						{
							"subject": "Food",
							"answer": "Dark Chocolate"
						},
						{
							"subject": "Game",
							"answer": "Surfing"
						},
						{
							"subject": "Band",
							"answer": "Israel Kamakawiwo'ole"
						}
					]
				},
				{
					"name": "Hannah Mills",
					"jobTitle": "Research Analyst, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Hannah joined NRG in 2022 and works as a Research Analyst on the Platforms and Technology team, supporting the investigation of new insights for our clients. Hannah graduated with a B.S. in Psychology from the University of Washington, and has experience working on academic research concerning the intersections between marketing, human behavior, and community connection. Hannah is passionate about continuous personal growth, and hopes to continue learning more about the integration of technology into research practices, and the use of data supported strategies to develop new ideas and optimize approaches.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Spirited Away"
						},
						{
							"subject": "TV Show",
							"answer": "Extraordinary Attorney Woo"
						},
						{
							"subject": "Food",
							"answer": "Coffee Jelly"
						},
						{
							"subject": "Game",
							"answer": "Stardew Valley"
						},
						{
							"subject": "Band",
							"answer": "Magdalena Bay"
						}
					]
				},
				{
					"name": "Kaneisha Montague",
					"jobTitle": "Senior Reserach Analyst, Global Tracking",
					"pictureUrl": "",
					"bio": "Born in Barbados, currently living in Atlanta (20 years). I'm a lover of all things creative, mainly ballet! Spelman graduate class of '14, BA of Science. Began my research career as a digital analyst at The Weather Channel (was not in charge of the weather) and grew into a linear & broadcast analyst at Katz broadcasting. Simultaneously managed 5 networks (Bounce, GRIT, LAFF, ESCAPE, MYSTERY) + the SVOD service Brown Sugar. Grew into an analyst for Court TV US & UK. Experienced in financial, program and traffic analytics as well.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Earth Gang"
						},
						{
							"subject": "Movie",
							"answer": "Belle, Eat Pray Love & Pulp Fiction"
						},
						{
							"subject": "Show",
							"answer": "New Girl, The Challenge & Sweet Bitter"
						},
						{
							"subject": "Game",
							"answer": "Taboo & Blackjack"
						},
						{
							"subject": "Director",
							"answer": "Issa Rae"
						}
					]
				},
				{
					"name": "Brianna Mooney",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Brianna.Mooney.jpg",
					"bio": "With more than six years of entertainment research experience, Brianna understands the power of using data-driven storytelling and actionable insights to help inform key marketing decisions. She has worked on a variety of studies, including ad effectiveness, post release, and custom. Prior to NRG, Brianna worked at MarketCast where she conducted creative content research for major studio and streaming clients. Brianna graduated from Arizona State University with a B.S. in Health Sciences and also holds an MBA, with a concentration in Marketing, from Pepperdine University.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Janet Jackson"
						},
						{
							"subject": "Movie",
							"answer": "Boomerang"
						},
						{
							"subject": "Show",
							"answer": "Fresh Prince of Bel-Aire"
						},
						{
							"subject": "Game",
							"answer": "Monopoly"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Moorea"
						}
					]
				},
				{
					"name": "Crystal Morales",
					"jobTitle": "Manager, Global Tracking",
					"pictureUrl": "../../assets/img/people/Crystal.Morales.jpg",
					"bio": "Crystal is a Los Angeles native who studied Marketing at California State University of Northridge. Before joining NRG, she was at Kantar for 2 years where she developed her data analysis skills working on multiple Brand and Advertising Trackers. She enjoys the continuous storytelling aspect of tracking and being able to turn data into actionable insights. In her free time she enjoys hiking with her dog Luna, baking and studying Italian.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "New Girl"
						},
						{
							"subject": "Class in School",
							"answer": "Statistics"
						},
						{
							"subject": "Game",
							"answer": "Rock Band"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Cabo San Lucas"
						},
						{
							"subject": "Food",
							"answer": "Pizza"
						}
					]
				},
				{
					"name": "Lucy Murrey",
					"jobTitle": "Senior Research Analyst, Global Marketing",
					"pictureUrl": "../../assets/img/people/Lucy.Murrey.jpg",
					"bio": "As a part of the Global Marketing team at NRG, Lucy conducts thought leadership research on the future of media and technology. A writer, researcher, data scientist and people-person, Lucy is passionate about storytelling as a means for improving social outcomes. Prior to NRG, Lucy produced global digital events for HubSpot and conducted global PR and social media for Reebok International. Lucy graduated from Northeastern University with a Bachelor of Arts degree in Communications Studies and minors in Business Administration and Marketing Analytics.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Sex and the City"
						},
						{
							"subject": "Book",
							"answer": "The Mother of All Questions"
						},
						{
							"subject": "Quote",
							"answer": "\"People will forget what you said, people will forget what you did, but people will never forget how you made them feel.\"-Maya Angelou"
						},
						{
							"subject": "Cocktail",
							"answer": "Negroni"
						},
						{
							"subject": "Food",
							"answer": "Chips & Guacamole"
						}
					]
				},
				{
					"name": "Gary Nolan",
					"jobTitle": "Senior Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Gary.Nolan.jpg",
					"bio": "Gary is responsible for managing the day to day activities of the international tracker, including weekly calls and meetings with key clients, delivery of tracking reports and management of the Global Tracking team. He joined National Research Group in 2011 and prior to this worked on the market research team of Epson Europe. He is an Irish native and graduated with a Bachelor of Commerce degree from University College Dublin in 2007; he also holds an MSc in Marketing Practice from the Michael Smurfit Graduate Business School in Dublin, graduating in 2008. He has a huge interest in all things film and spends a lot of his free time at the local cineplex",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Donnie Darko"
						},
						{
							"subject": "Band",
							"answer": "The Killers"
						},
						{
							"subject": "Book",
							"answer": "Harry Potter Series"
						},
						{
							"subject": "TV Show",
							"answer": "Game of Thrones"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan (no relation unfortunately)"
						}
					]
				},
				{
					"name": "Kerri Norton",
					"jobTitle": "Executive Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Kerri.Norton.jpg",
					"bio": "Kerri has 10 years of primary media research experience, specializing in providing TV and OTT clients with actionable insights for programming, branding, marketing, and sales. Her keen eye for visual storytelling complements her research toolkit, which includes a wide range of qualitative and quantitative methodologies, allowing her to customize each project to best meet her clients' needs and objectives. Kerri is also a RIVA trained moderator and loves meeting and connecting with people all over the world.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Princess Bride"
						},
						{
							"subject": "TV Show",
							"answer": "Orphan Black"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Tuscany"
						},
						{
							"subject": "Cocktail",
							"answer": "French 75"
						},
						{
							"subject": "Actress",
							"answer": "Jessica Chastain"
						}
					]
				},
				{
					"name": "Reagan Osborne",
					"jobTitle": "Director, Project Management, Content & Strategy",
					"pictureUrl": "",
					"bio": "Reagan joined NRG in 2021, working in Project Management of Content & Strategy. In this role, he provides support to the leadership team by defining structure and creating simplicity in daily processes and practices.  He has been working in market research since 2011, with experience in every area of the industry including recruiting, client services, quantitative/qualitative project management. Reagan enjoys writing & traveling and aims to see as much of the world as he can.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Star Wars (1977)"
						},
						{
							"subject": "TV Show",
							"answer": "Smallville"
						},
						{
							"subject": "Quote",
							"answer": "\"It's a dangerous business, going out your door...you step into the road, and if you don't keep your feet, there's no telling where you might be swept off to.\" - JRR Tolkien"
						},
						{
							"subject": "Superhero",
							"answer": "Superman"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						}
					]
				},
				{
					"name": "Stephen Palmer",
					"jobTitle": "President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Stephen.Palmer.jpg",
					"bio": "Stephen has specialized in international movie research since 2001. He has worked with all the major studios, as well as many filmmakers and leading entertainment companies. Stephen's breadth of client experience allows him to provide insight at all stages of a film's life cycle, from early market positioning assessments, through playability and testing the strategic impact of marketing materials. Stephen has extensive experience with both established and emerging international markets, particularly LATAM and Asia. Stephen graduated from the University of Manchester, in England, with a Bachelor's degree in Mathematics and Management Sciences.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Shining"
						},
						{
							"subject": "Quote",
							"answer": "\"Either the wallpaper goes, or I do\" -Oscar Wilde, allegedly on his deathbed"
						},
						{
							"subject": "Food",
							"answer": "An old-fashioned Sunday roast"
						},
						{
							"subject": "Cocktail",
							"answer": "Caprioska"
						},
						{
							"subject": "Actress",
							"answer": "Sally Hopkins, Allison Janney"
						}
					]
				},
				{
					"name": "Ben Pappenheimer",
					"jobTitle": "Research Manager, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Ben currently lives outside of Seattle and is a Research Manager for the Platform & Technology team. Prior to joining NRG he worked as an analyst at both GfK and GutCheck, where he worked on qual and quant projects in a variety of verticals. He also has a rich storytelling background from being a videographer in the music industry and earning a M.A. in Anthropology/Social Sciences from the University of Chicago. Outside of work, he enjoys going to museums, playing video games, and reading.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Converge"
						},
						{
							"subject": "Game",
							"answer": "Ghost of Tsushima"
						},
						{
							"subject": "Movie",
							"answer": "Alien"
						},
						{
							"subject": "TV Show",
							"answer": "It's Always Sunny in Philadelphia"
						},
						{
							"subject": "Sports Team",
							"answer": "Boston Celtics"
						}
					]
				},
				{
					"name": "Kimia Paridehpour",
					"jobTitle": "Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Kimia.Paridehpour.jpg",
					"bio": "Kimia is part of the Content & Strategy team where she optimizes her client's creative materials and strategies by uncovering the stories and patterns in large datasets. Prior to joining NRG, Kimia generated key insights for marketing and brand health, as the lead on several large tracking studies for various Fortune 500 tech companies, translating dense data into actionable insights. Kimia earned her B.A. in Psychology from UCLA, where she was heavily involved in social science academic research.",
					"favourites": [
						{
							"subject": "Quote",
							"answer": "\"There are only two days in the year that nothing can be done. One is called Yesterday and the other is called Tomorrow. Today is the right day to Love, Believe, Do and mostly Live.\" - Dalai Lama XIV"
						},
						{
							"subject": "Book",
							"answer": "The Alchemist"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Morocco"
						},
						{
							"subject": "Food/Dish",
							"answer": "Sushi"
						},
						{
							"subject": "Cocktail",
							"answer": "Espresso Martini"
						}
					]
				},
				{
					"name": "Jon Penn",
					"jobTitle": "Chief Executive Officer",
					"pictureUrl": "../../assets/img/people/Jon.Penn.jpg",
					"bio": "As CEO, Jon is responsible for all things NRG. Jon has spent nearly two decades modernizing and expanding the strategic value of entertainment research by applying methodologies insights from political and corporate polling.  He is an ARF David Ogilvy Award winner and contributor and pollster to The Hollywood Reporter. Before arriving at NRG, he was the Founder and CEO of the Media and Entertainment practice at Penn Schoen Berland. In a 17-year career at PSB, he built the practice into one of the most highly successful and well-respected entertainment polling firms in the world. Previously, Jon served as Director of Internet Strategy for Hillary Clinton's successful Senate campaign win in 2000. In this role he directed and managed campaign web strategy and execution. Jon is a graduate of the University of Pennsylvania. He and his wife have their hands full with twins Ava and Olivia, and \"big\" James.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Built to Spill"
						},
						{
							"subject": "Movie",
							"answer": "Hoop Dreams"
						},
						{
							"subject": "TV Show",
							"answer": "Making a Murderer"
						},
						{
							"subject": "Superhero",
							"answer": "Wolverine"
						},
						{
							"subject": "Game",
							"answer": "Tennis"
						}
					]
				},
				{
					"name": "Natalie Perez",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Natalie.Perez.jpg",
					"bio": "Natalie brings expertise and enthusiasm to NRG's Content and Strategy team as a Senior Analyst. Prior to joining NRG, Natalie worked in the Spanish-language television industry leveraging market research to gain a better understanding of the Hispanic market and develop strategic insights to grow viewership for the network. In her free time, she enjoys watching reality TV, attending yoga and fitness classes, and researching her next travel destination.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Remember the Titans"
						},
						{
							"subject": "Food",
							"answer": "Pizza and Ice Cream"
						},
						{
							"subject": "Book",
							"answer": "The Alchemist"
						},
						{
							"subject": "TV Show",
							"answer": "Big Brother"
						},
						{
							"subject": "Game",
							"answer": "Monopoly Deal - it's a card game and much more fun than the board game, I promise!"
						}
					]
				},
				{
					"name": "Roy Persson",
					"jobTitle": "Senior Vice President, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Roy has nearly 20 years of research experience; helping clients measure organizational performance and develop strategies to support their business objectives. Specializing in communications and corporate affairs he has helped global organizations better understand their reputation landscape, providing guidance on key policies, initiatives, and messaging. He has covered several industries, deploying qualitative and quantitative techniques in several regions, across a spectrum of unique stakeholder groups. Roy has market research experience in reputation, advocacy, employee satisfaction, message development, crisis management, branding, thought leadership, customer satisfaction, communications, advertising, as well as other disciplines. He holds an MBA from Bryant University.",
					"favourites": [
						{
							"subject": "Game",
							"answer": "American football, to watch , play, and coach"
						},
						{
							"subject": "Quote",
							"answer": "\"People will forget what you said, people will forget what you did, but people will never forget how you made them feel.\" - Maya Angelou (American author and civil rights activist)"
						},
						{
							"subject": "Sports Team",
							"answer": "New England Patriots (Tom Brady is the GOAT)"
						},
						{
							"subject": "Food",
							"answer": "Chicken wings"
						},
						{
							"subject": "TV Show",
							"answer": "It's Always Sunny in Philadelphia"
						}
					]
				},
				{
					"name": "Andrew Pilkington",
					"jobTitle": "Senior Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Andrew.Pilkington.jpg",
					"bio": "Andy is a key member of our London based Global Tracking team. In addition to core tracking duties, he provides analytical services across a range of products. Prior to joining NRG, Andy worked at PSB First Movies, where he was responsible for research screenings, exit polling, creative testing and positioning studies. He also has experience working in cinema exhibition where he assisted in the marketing of Hollywood studio releases. Andy graduated from the University of Cumbria with a degree in film and television production and is a devoted film and TV fan, gamer and a self-proclaimed geek.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Airborne Toxic Event"
						},
						{
							"subject": "Movie",
							"answer": "Back to the Future"
						},
						{
							"subject": "TV Show",
							"answer": "Friday Night Lights"
						},
						{
							"subject": "Game",
							"answer": "Red Dead Redemption"
						},
						{
							"subject": "Director",
							"answer": "Steven Spielberg"
						}
					]
				},
				{
					"name": "Elizabeth Potash",
					"jobTitle": "Senior Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Elizabeth.Potash.jpg",
					"bio": "An entertainment data storyteller, Elizabeth serves the Global Tracking team as the industry propels into the future of content on any size screen. She manages research intelligence and client relations for both streaming and theatrical content around the world. Elizabeth has previously worked on film data at Comscore and digital media analytics for Studio71 in LA prior to joining NRG, and studied psychology at Duke and USC for a consumer research focus. Outside of NRG, Elizabeth is also an instructor-certified aerial yogi and a cat mom.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "The Magpie Murders"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Napa/Sonoma"
						},
						{
							"subject": "Restaurant",
							"answer": "The Bazaar, Beverly Hills"
						},
						{
							"subject": "Sports Team",
							"answer": "Duke Blue Devils"
						},
						{
							"subject": "Quote",
							"answer": "\"It's nice to be important, but it's more important to be nice\""
						}
					]
				},
				{
					"name": "Jesson Rata",
					"jobTitle": "Research Manager, Global Tracking",
					"pictureUrl": "../../assets/img/people/Jesson.Rata.jpg",
					"bio": "Jesson joins NRG's Global Tracking team while being based in San Francisco. He will be providing support on all aspects of global entertainment content trackers, primarily focusing on the SVOD tracker which monitors title and platform trends. Previously, Jesson worked on a variety of custom research projects across categories: Retail, Technology, CPG, Automotive, and has cultivated his skills in both Quant and Qual research at Hall & Partners, Google, and Ipsos--where he started his Market Research career in Advertising/Brand Health Tracking and Copy Testing. Jesson currently enjoys anything in the Arts and still dreams of becoming the next King of Pop.",
					"favourites": [
						{
							"subject": "Game",
							"answer": "The Legend of Zelda: Ocarina of Time"
						},
						{
							"subject": "Cocktail",
							"answer": "French 75"
						},
						{
							"subject": "TV Show",
							"answer": "Parks and Recreation"
						},
						{
							"subject": "Actor",
							"answer": "Robin Williams"
						},
						{
							"subject": "Quote",
							"answer": "\"Strive not to be a success, but rather to be of value\" -Albert Einstein"
						}
					]
				},
				{
					"name": "Chris Rethore",
					"jobTitle": "Chief Strategy Officer",
					"pictureUrl": "../../assets/img/people/Chris.Rethore.jpg",
					"bio": "Chris leads NRG’s growth strategy initiatives with an emphasis on enhancing value for clients through product innovation and thought leadership. With nearly two decades of research and leadership experience, Chris specializes in the development and launch of best-in-class insights solutions that leverage cutting-edge data science to anticipate and solve critical client challenges. Prior to NRG, Chris was Chief Operating Officer at MarketCast overseeing firmwide operations, marketing, and the growth of its acquired business portfolio. Chris graduated from the University of Pennsylvania with a B.A. in History.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Natural"
						},
						{
							"subject": "Class in School",
							"answer": "History"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Napa Valley"
						},
						{
							"subject": "Restaurant",
							"answer": "Steirereck (Vienna)"
						},
						{
							"subject": "Sports Team",
							"answer": "Boston Red Sox"
						}
					]
				},
				{
					"name": "Alex Reyes",
					"jobTitle": "Senior Manager, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Alex joined NRG in 2020 after wanting to work more closely with gaming and technology clients. He first became interested in market research when he was a research assistant while studying at UCSB for his undergraduate degree. Before coming to NRG, he was at Ipsos where he helped execute projects for predominately television and entertainment clients.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Strokes"
						},
						{
							"subject": "Game",
							"answer": "No favorite, but loves to play various games on his PS4"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Italy - Does not matter where, but is partial to anywhere in the south"
						},
						{
							"subject": "Food/Dish",
							"answer": "Ramen - Tsujita and Tastu are the best spots in LA"
						},
						{
							"subject": "Cocktail",
							"answer": "Mojito"
						}
					]
				},
				{
					"name": "Tyler Robinson",
					"jobTitle": "Research Manager, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Tyler.Robinson.jpg",
					"bio": "Tyler is joining the Platforms & Technology Clients team as a Research Manager and will be reporting to Moeka Komachi. Prior to joining NRG, Tyler worked as a Senior Research Analyst at Greenberg, focusing primarily on gaming clients. Tyler graduated from UC Santa Barbara with a B.S. in BioPsychology.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Fantastic Mr. Fox"
						},
						{
							"subject": "Band",
							"answer": "Sticky Fingers"
						},
						{
							"subject": "Book",
							"answer": "Caribbean by James Michener"
						},
						{
							"subject": "Game",
							"answer": "Apex Legends"
						},
						{
							"subject": "Quote",
							"answer": "\"May we all die twice\" - Thomas Shelby, Peaky Blinders"
						}
					]
				},
				{
					"name": "Elise Rochefort",
					"jobTitle": "Senior Research Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Elise.Rochefort.jpg",
					"bio": "Elise has over 15 years of research and insights experience in entertainment, specializing in TV and OTT research. Prior to NRG, Elise led the Strategic Insights practice at Canada’s largest broadcaster where she worked with over 30 broadcast and cable TV brands. Elise has extensive experience in uncovering opportunities to increase viewership and subscriber retention by analyzing a variety of sources including custom research, TV ratings, and first party data. Elise graduated from Wilfrid Laurier University in Waterloo, Ontario, with an Honors Bachelor of Business Administration.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Ocean's Eleven (2001)"
						},
						{
							"subject": "TV Show",
							"answer": "Breaking Bad"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan"
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey Sour"
						},
						{
							"subject": "Actor",
							"answer": "Matt Damon"
						}
					]
				},
				{
					"name": "Kristin Rodriguez",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Kristin.Rodriguez.jpg",
					"bio": "With over a decade of experience in research, Kristin brings her expertise in quantitative and qualitative research methods to guide marketing, and content strategies for clients in the streaming/TV space. Prior to NRG, Kristin led teams at Kantar Added Value, and Lieberman Research Worldwide. Kristin graduated from The University of Southern California, with a Bachelor's degree in Public Relations.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Strictly Ballroom"
						},
						{
							"subject": "Superhero",
							"answer": "Wonder Woman"
						},
						{
							"subject": "Book",
							"answer": "Outlander"
						},
						{
							"subject": "Cocktail",
							"answer": "Pina Colada"
						},
						{
							"subject": "Actor",
							"answer": "Matt Berry"
						}
					]
				},
				{
					"name": "Julia Roland",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Julia.Roland.jpg",
					"bio": "For over two decades, Julia has supported the marketing, consumer, enterprise and product research needs of the world’s largest tech, telecom, media and consumer brands. As a senior client partner, she designs and leads a broad range of high-impact research engagements. Her experience, most recently at Ipsos/Synovate, as well as Nielsen, Telephia and Harris Interactive, spans brand/product strategy, audience insights, customer journey, marketing effectiveness, ad strategy, retail insights, and UX. She also has extensive experience integrating behavioral metrics and other types of non-survey data. Julia lives in NJ with her husband Seth, son Daniel, and daughters Hannah and Laura (when they take a break from life in NYC).",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Pulp Fiction"
						},
						{
							"subject": "Game",
							"answer": "Scrabble"
						},
						{
							"subject": "Food",
							"answer": "Popcorn and French Fries"
						},
						{
							"subject": "Quote",
							"answer": "\"No [wo]man is a failure who has friends.\"-Clarence the Angel"
						},
						{
							"subject": "Actor",
							"answer": "Matt Damon"
						}
					]
				},
				{
					"name": "Benjamin Rogers",
					"jobTitle": "President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Benjamin.Rogers.jpg",
					"bio": "Ben leads our Platforms & Technology Client Practice, which delivers game-changing insights across dimensions of the product and services lifecycle, including market landscaping, innovation, brand and positioning strategy, creative & platform optimization, and performance tracking. Ben, who previously served as EVP, Head of Media Development at Ipsos, brings over 20 years of technology platform, product, and services expertise to NRG, via leadership posts in London and the SF Bay Area. After beginning his career at NOP/GfK, and leading various teams on technology accounts for Kantar, he spent nearly a decade at Synovate/Ipsos. Ben lives in the San Francisco Bay Area and has two young children, daughter Riley and son Adrian.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Iron Maiden"
						},
						{
							"subject": "Quote",
							"answer": "If you didn't do anything that wasn't good for you it would be a very dull life. What are you gonna do? Everything that is pleasant in life is dangerous. Have you noticed that?\" - Ian \"Lemmy\" Kilmister"
						},
						{
							"subject": "Food/Dish",
							"answer": "I lived in London for 8 years, so you KNOW it's a good curry!"
						},
						{
							"subject": "Sports Team",
							"answer": "DA BEARS!"
						},
						{
							"subject": "Class In School",
							"answer": "The History of War (basically just watched documentaries which I do anyway!)"
						}
					]
				},
				{
					"name": "Steven Ross",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Steven.Ross.jpg",
					"bio": "Born in New York, Steven attended college at Duke University where he hosted a television show on the basketball team.  After graduation, Steven moved to Los Angeles to write for television, working on several shows, including writing for shows such as Ugly Betty and The Cleveland Show.  He then decided to bring his experience in storytelling to the world of creative testing.  After spending three years working in campaign analytics at MarketCast, Steven joined NRG in 2016 as Director of Creative Testing, analyzing ad testing materials and consulting on feature film ad campaigns.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Yes"
						},
						{
							"subject": "Movie",
							"answer": "The Godfather"
						},
						{
							"subject": "Book",
							"answer": "The Godfather"
						},
						{
							"subject": "Cocktail",
							"answer": "Glenmorangie Lasanta... neat"
						},
						{
							"subject": "Game Show Host",
							"answer": "Wink Martindale"
						}
					]
				},
				{
					"name": "Daniel Rowe",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Daniel.Rowe.jpg",
					"bio": "Originally from Malvern, Pennsylvania, Daniel recently graduated from the University of Notre Dame's Masters in Management program.  He attended Notre Dame for undergrad as well, double-majoring in Neuroscience and Film/Television Studies.  His senior thesis used Saturday Night Live as a case study for how live television has evolved in the Streaming Age.  Previously, he interned with FX Networks on the Marketing and Promotions team.  In his spare time, Daniel enjoys cooking, traveling, hiking, and improv comedy.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Silence of the Lambs"
						},
						{
							"subject": "TV Show",
							"answer": "30 Rock"
						},
						{
							"subject": "Class in School",
							"answer": "TV as a Storytelling Medium"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Italy"
						},
						{
							"subject": "Sports Teams",
							"answer": "Philadelphia Eagles"
						}
					]
				},
				{
					"name": "José Salazar",
					"jobTitle": "Research Operations Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Jose.Salazar.jpg",
					"bio": "José graduated from Indiana University - Bloomington in 2021 with a BA in International Studies. Prior to joining NRG, he served as an Operations Coordinator at the Walter Center for Career Achievement. In his spare time, José can be found checking out new restaurants, tending his growing plant collection, listening to film scores, and walking his cat.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Black Swan"
						},
						{
							"subject": "Game",
							"answer": "The Legend of Zelda: Twilight Princess"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Monterrey, Mexico"
						},
						{
							"subject": "Restaurant",
							"answer": "Siam House (Bloomington)"
						},
						{
							"subject": "Cocktail",
							"answer": "Peach Mojito"
						}
					]
				},
				{
					"name": "Ronnie Saldarini",
					"jobTitle": "Senior Research Manager, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Ronnie.Saldarini.jpg",
					"bio": "Ronnie has always been interested in identifying the story behind the numbers. Graduating from Syracuse University with a dual economics and advertising degree, he understands the value of data and the importance of being able to communicate findings effectively. Ronnie has both quantitative and qualitative research experience with a focus on tech and gaming. His research has ranged from concept tests to understanding gaming genre preferences. When not working, Ronnie enjoys playing Xbox and following a cover band around the great state of New Jersey (really just in Hoboken where the band plays occasionally).",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Butch Cassidy & the Sundance Kid"
						},
						{
							"subject": "Book",
							"answer": "The Princess Bride"
						},
						{
							"subject": "Band",
							"answer": "LifeSpeed"
						},
						{
							"subject": "Game",
							"answer": "Skyrim"
						},
						{
							"subject": "Quote",
							"answer": "\"Every day is a holiday, every meal is a feast.\""
						}
					]
				},
				{
					"name": "Jasmina Saleh",
					"jobTitle": "Research Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Jasminah.Saleh.jpg",
					"bio": "Jasmina is a multi-lingual research manager focused on content consumers across traditional and digital entertainment. Having lived in Germany, South Africa, France, Switzerland and the UK, her cultural experiences inform quant and qual insights globally, in particular for key EMEA markets. Jasmina started her career at Universal Pictures in 2016, handling box office analysis before moving onto TV distribution, where she worked closely with major international broadcasters and studios. She recently joined NRG’s Content & Strategy team from MarketCast, where she was central to their Campaign Analytics team, consulting on international ad campaigns. In her free time Jas has produced short-form content, honing production and development skills to better understand the intricacies of the content we love and consume every day. Jasmina studied journalism at Cardiff University and attended the University of Pennsylvania for an exchange semester at the Wharton Business School where she majored in communication and marketing.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Chef"
						},
						{
							"subject": "TV Show",
							"answer": "30 Rock"
						},
						{
							"subject": "Superhero",
							"answer": "Lara Croft"
						},
						{
							"subject": "Game",
							"answer": "Briscola"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Portugal"
						}
					]
				},
				{
					"name": "Adam Schwarz",
					"jobTitle": "Senior Director, Global Tracking",
					"pictureUrl": "../../assets/img/people/Adam.Schwarz.jpg",
					"bio": "Adam specializes in quantitative research and strategy. He has been managing theatrical tracking for nearly a decade at NRG, and is responsible for the studio clients' needs, consulting, and executing the operational aspects of the study, all while finding time to serve on the box office forecast committee. Before joining the team at NRG, Adam worked for six years at D/R Added Value on projects including custom/ad-hoc studies, strategic multivariate segmentation, and advertising copytesting. Primary clients were focused in the automotive, restaurant, and entertainment arenas. Adam holds a bachelor's degree in business administration with concentrations in marketing and psychology from the University of Illinois, Urbana-Champaign. ",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Diamonds are Forever"
						},
						{
							"subject": "Superhero",
							"answer": "Dick Butkus"
						},
						{
							"subject": "Game",
							"answer": "Need for Speed"
						},
						{
							"subject": "TV Show",
							"answer": "24"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Maui"
						}
					]
				},
				{
					"name": "Sonya Sherman",
					"jobTitle": "Coordinator, Screenings",
					"pictureUrl": "../../assets/img/people/Sonya.Sherman.jpg",
					"bio": "Driven both personally and professionally by an unfaltering passion for film, Sonya works on the Screenings team to bring Hollywood's greatest accomplishments to the eyes of excited audiences. Originally from Boulder, Colorado, she graduated from UC Santa Barbara with undergraduate degrees in Film and Media Studies and Global Studies. Some of Sonya's hobbies include doing the NYT daily crossword, planning her annual Oscars party, daydreaming that one day, she might even attend the Oscars, going to hockey games, and playing chess against herself.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Brooklyn Nine-Nine"
						},
						{
							"subject": "Game",
							"answer": "Nerts"
						},
						{
							"subject": "Food",
							"answer": "Sandwiches"
						},
						{
							"subject": "Sports Team",
							"answer": "The Colorado Avalanche"
						},
						{
							"subject": "Director",
							"answer": "Jordan Peele"
						}
					]
				},
				{
					"name": "Heitho Shipp",
					"jobTitle": "Research Analyst, Content & Strategy",
					"pictureUrl": "",
					"bio": "Heitho Shipp works as a research analyst on the Content & Strategy team. She graduated from Carnegie Mellon University in May of 2021. She has experience working in customer relationship management analytics and financial planning in the retail industry as well as experience in consumer insights in the entertainment industry. Her goal is to meld the world of social science with the world of the media; specifically, how films and television both influence, and act as a snapshot of, the cultural moment. She can always be found at a tea shop, a bookstore, outside in a hammock, or cuddled up with her dog watching a movie or show.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "But I'm a Cheerleader"
						},
						{
							"subject": "Show",
							"answer": "Letterkenny "
						},
						{
							"subject": "Book",
							"answer": "The Princess Bride"
						},
						{
							"subject": "Actor",
							"answer": "Kaitlyn Dever"
						},
						{
							"subject": "Quote",
							"answer": "\"Your courage to do what is right has to be greater than your fear of getting hurt\" -Hasan Minhaj, Homecoming King"
						}
					]
				},
				{
					"name": "Taylin Shoemaker",
					"jobTitle": "Senior Manager, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Taylin.Shoemaker.jpg",
					"bio": "Prior to joining NRG, Taylin graduated cum laude from Occidental College with a degree in Economics and a Mathematics minor. She then took on a project management position within the apparel industry before moving on to NRG, where she is thrilled to combine her passion for entertainment with her love of research.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Bishop Briggs"
						},
						{
							"subject": "TV Show",
							"answer": "Stranger Things"
						},
						{
							"subject": "Class in School",
							"answer": "Mathematics"
						},
						{
							"subject": "Book",
							"answer": "Ender's Game"
						},
						{
							"subject": "Cocktail",
							"answer": "Gin and Tonic"
						}
					]
				},
				{
					"name": "Alyssa Silver",
					"jobTitle": "Director, Gaming",
					"pictureUrl": "",
					"bio": "Alyssa joined NRG in 2022 to help support a growing team of gamers within Platforms & Technology. She joins with 7 years of quantitative experience across different industries and methodologies, showing a strong aptitude for advanced analytics. While she's worked across every category from airlines, banks, software, and CPG her more recent focus on big tech and mobile games has led her to NRG. Alyssa has a passion for understanding people and what drives their behavior and applies that thinking in the way people play and spend money on all different types of games.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Memento"
						},
						{
							"subject": "TV Show",
							"answer": "Squid Games"
						},
						{
							"subject": "Game",
							"answer": "Quiplash"
						},
						{
							"subject": "Book",
							"answer": "Outliers"
						},
						{
							"subject": "Director",
							"answer": "Ryan Murphy"
						}
					]
				},
				{
					"name": "Alex Sink, Ph.D.",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Alex.Sink.jpg",
					"bio": "Alex has extensive experience conducting custom research projects focused on understanding the impact of entertainment media on mass audiences. His research on minority television characters has been published in top academic journals, including the Journal of Language and Social Psychology, Journalism and Mass Communication Quarterly, and Mass Communication and Society. Alex received his BA from the University of Wisconsin, Madison where he majored in Journalism and Mass Communication. He also received his MA and PhD from UCSB in Media Communication, where he received both the George D. McCune Dissertation Fellowship and the James J. Bradac Award for Excellence in Research.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Best in Show"
						},
						{
							"subject": "TV Show",
							"answer": "Survivor"
						},
						{
							"subject": "Game",
							"answer": "Mario Kart"
						},
						{
							"subject": "Cocktail",
							"answer": "White Russian"
						},
						{
							"subject": "Actress",
							"answer": "Whoopi Goldberg"
						}
					]
				},
				{
					"name": "Cindi Smith",
					"jobTitle": "Vice President, Diversity, Equity & Inclusion",
					"pictureUrl": "../../assets/img/people/Cindi.Smith.jpg",
					"bio": "Cindi is involved in all aspects of primary research for our motion picture clients. Her primary focus is on client communication and managing workflow processes within the Screenings Division. She also works as a moderator and leads focus group discussions on ad effectiveness and for production and marketing test screenings.  Prior to joining NRG, Cindi had successful career in sales and marketing with American Express and Associated Production Music. She has a MBA from The University of Phoenix and a BS in Finance from California State University, Long Beach. During her free time Cindi enjoys watching movies, shopping and exploring the world.",
					"favourites": [
						{
							"subject": "Superhero",
							"answer": "Wonder Woman - what's not to love about a woman with her very own invisible plane?"
						},
						{
							"subject": "Band",
							"answer": "Prince"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Italy"
						},
						{
							"subject": "TV Show",
							"answer": "Shameless"
						},
						{
							"subject": "Cocktail",
							"answer": "Depends on my mood - Either a Dirty Vodka Martini (with Blue Cheese olives) or a nice glass of Champagne"
						}
					]
				},
				{
					"name": "Jessica Smith",
					"jobTitle": "Senior Analyst, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Jessica.Smith.jpg",
					"bio": "Jessica graduated summa cum laude from Elon University with degrees in Strategic Communications and Psychology. Prior to joining NRG she has held many internships in communications and PR, and is excited to work closely with market research. Her love for all things entertainment grew during her time managing the movie theater on her college campus. Outside of work she enjoys traveling and playing with her dog Waffles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Booksmart"
						},
						{
							"subject": "TV Show",
							"answer": "Fleabag"
						},
						{
							"subject": "Cocktail",
							"answer": "Margarita"
						},
						{
							"subject": "Sports Team",
							"answer": "Philadelphia Eagles"
						},
						{
							"subject": "Director",
							"answer": "Taika Waititi"
						}
					]
				},
				{
					"name": "Sean Steele",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Sean.Steele.jpg",
					"bio": "Sean works across both custom research and tracking within our London office. He joined National Research Group in 2004 after working across a number of sectors with market research companies in London and Sydney. Sean is a graduate of the University of Warwick, where he studied English & American Literature. Sean's interests include football, music, politics, travel and, of course, film. His biggest challenge in recent years has been managing his rather headstrong beagle, with mixed results.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Withnail & I"
						},
						{
							"subject": "TV Show",
							"answer": "Curb Your Enthusiasm"
						},
						{
							"subject": "Book",
							"answer": "The Great Gatsby"
						},
						{
							"subject": "Team",
							"answer": "Tottenham Hotspur"
						},
						{
							"subject": "Actor",
							"answer": "Tom Hardy"
						}
					]
				},
				{
					"name": "Ray Subers",
					"jobTitle": "Senior Vice President, Global Tracking",
					"pictureUrl": "../../assets/img/people/Ray.Subers.jpg",
					"bio": "Ray has worked on bringing to market NRG's new long-range tracking product, Campaign Management. He remains involved in the continuing evolution and operation of the product, and regularly consults with clients on how to get the most value out of this new data. Prior to joining NRG, Ray was a senior analyst on the international theatrical distribution team at Paramount Pictures. In a past life, he ran the popular box office tracking site Box Office Mojo.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Raiders of the Lost Ark"
						},
						{
							"subject": "Game",
							"answer": "Scrabble"
						},
						{
							"subject": "Cocktail",
							"answer": "Manhattan"
						},
						{
							"subject": "Team",
							"answer": "Philadelphia Eagles"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Marcea Suwandi",
					"jobTitle": "Senior Coordinator, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Marcea.Suwandi.jpg",
					"bio": "Marcea graduated from UCLA with a Bachelor’s degree in Cognitive Science. She then took an admin position at a tech startup before moving on to NRG. As a coordinator on the Content & Strategy Team, Marcea assists the analysts with project setup. Outside of work she enjoys playing board games with her friends and baking treats to satisfy her sweet tooth.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The Boys, This is Us, Haikyuu!!"
						},
						{
							"subject": "Book",
							"answer": "The Hobbit"
						},
						{
							"subject": "Game",
							"answer": "Marvel Champions: The Card Game"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Bali, Indonesia"
						},
						{
							"subject": "Restaurant",
							"answer": "Nick's on 2nd, Long Beach"
						}
					]
				},
				{
					"name": "Jennifer Torson",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Jennifer.Torson.jpg",
					"bio": "Jennifer is a manager on NRG's Content & Strategy team, where she combines her love of entertainment and technology with her passion for the social sciences. At NRG she strives to help teams of all kinds to understand consumer attitudes, needs, and behaviors in order to drive better product outcomes and create unforgettable experiences. Prior to NRG, Jennifer specialized in games user research, working on AAA console and mobile titles at publishers Activision and Scopely. Jennifer graduated cum laude from U.C. San Diego with high distinction in Anthropology.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Groundhog Day"
						},
						{
							"subject": "TV Show",
							"answer": "Blue Planet"
						},
						{
							"subject": "Game",
							"answer": "Mass Effect"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Ambergris Caye, Belize"
						},
						{
							"subject": "Cocktail",
							"answer": "Lemon Drop"
						}
					]
				},
				{
					"name": "Alex Trudel",
					"jobTitle": "Analyst, Marketing Sciences",
					"pictureUrl": "../../assets/img/people/Alex.Trudel.jpg",
					"bio": "Alex graduated from UCLA with a B.S. in Statistics and a Minor in History, and was the President of the UCLA Pokémon Club, as well as the Founder and President of the UCLA Mario Kart Club. When not working, you can find him playing video games with his friends, watching sports, or playing volleyball and golf.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Snowfall and Made in Abyss"
						},
						{
							"subject": "Game",
							"answer": "Destiny 2 and Mario Kart 8"
						},
						{
							"subject": "Restaurant",
							"answer": "Tajima Ramen (Convoy Street San Diego)"
						},
						{
							"subject": "Sports Team",
							"answer": "San Diego Padres"
						},
						{
							"subject": "Band",
							"answer": "The Beach Boys"
						}
					]
				},
				{
					"name": "Meaghan Tyler",
					"jobTitle": "Director, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Meaghan.Tyler.jpg",
					"bio": "Meaghan Tyler is an accomplished qualitative researcher with more than a decade of industry experience as a researcher, moderator, strategic thinker and collaborator to some of today’s most influential brands.  With a modern approach to research, Meaghan develops creative methodologies that combine generational filters and emerging trends in consumer and pop culture.  A curious conversationalist, Meaghan is constantly learning about people and helping brands connect to build deeper relationships with their customers.  Meaghan holds a degree in Psychology and Marketing from The University of North Carolina at Chapel Hill and has recently completed coursework at IDEO U.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Grateful Dead"
						},
						{
							"subject": "Movie",
							"answer": "The Royal Tenenbaums"
						},
						{
							"subject": "TV Show",
							"answer": "Bored to Death"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Adirondack Mountains"
						},
						{
							"subject": "Game Show Host",
							"answer": "Jeff Probst... or Alex Trebek. This is hard & controversial."
						}
					]
				},
				{
					"name": "Julian Valdez",
					"jobTitle": "Market Research Analyst, Strategy & Innovation",
					"pictureUrl": "",
					"bio": "Julian joined NRG in 2022 as a Research Analyst on the Strategy and Innovation team. He holds an MS in Applied Psychology from USC where his market research journey began. On his free time he likes to be at his local movie theater, one of LA's many concert venues, or in any type of wilderness he can escape to.",
					"favourites": [
						{
							"subject": "Cocktail",
							"answer": "Michelada"
						},
						{
							"subject": "TV Show",
							"answer": "Curb Your Enthusiasm"
						},
						{
							"subject": "Game",
							"answer": "Super Smash Bros"
						},
						{
							"subject": "Sports Team",
							"answer": "Dodgers and Raiders"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Nadya Valkova",
					"jobTitle": "Research Manager, Content & Strategy",
					"pictureUrl": "",
					"bio": "As part of NRG's Content & Strategy team, Nadya supports qualitative and quantitative studies where she provides strategic insights around content and marketing for top studios and streaming platforms. Before NRG, she worked with Ipsos’ Corporate Reputation team, investigating the expectations and perceptions of senior stakeholders on a range of issues, such as misinformation, ESG, and data protection. In her free time, Nadya enjoys re-watching the MCU (and Easter Eggs deep dive videos), reading a good fantasy book, and attending ballet and contemporary dance classes around London.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Captain America and the Winter Soldier"
						},
						{
							"subject": "TV Show",
							"answer": "Supernatual"
						},
						{
							"subject": "Band",
							"answer": "Nothing but Thieves"
						},
						{
							"subject": "Book",
							"answer": "Vicious, by V. E. Schwab"
						},
						{
							"subject": "Quote",
							"answer": "\"The heart is an arrow. It demands aim to land true.\" -Leigh Bardugo, Six of Crows"
						}
					]
				},
				{
					"name": "Tina Vallejos",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Tina.Vallejos.jpg",
					"bio": "As a bilingual and bicultural researcher, Tina is passionate about studying the evolution of culture and its influence on the stories that are told and media choices we make. After starting her career at Nielsen, Tina honed her leadership and analytical skills leading Programming Research & Development at Univision, combining ratings insights with primary research to inform strategy and uncover opportunities to engage viewers. She has a BA in Business - Marketing from the University of Notre Dame and is a graduate of the Betsy Magness Leadership Institute.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Disney animated films...and Harry Potter"
						},
						{
							"subject": "Quote",
							"answer": "\"I have no special talents. I am only passionately curious.\" Einstein"
						},
						{
							"subject": "Book",
							"answer": "Untamed, Glennon Doyle"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Somehwere on a beach"
						},
						{
							"subject": "Food/Dish",
							"answer": "Pizza"
						}
					]
				},
				{
					"name": "Melissa Valus",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/Melissa.Valus.jpg",
					"bio": "Melissa focuses on all things international, and she's usually managing a variety of projects from LA, but you can occasionally find her around the globe attending focus groups and screenings. Melissa has been working in film market research since 2009: she started at First Movies and then joined NRG in 2012. She graduated from USC (Fight On!) with a BA in International Relations/ Global Business and a minor in French. Melissa loves to travel and sing, she is a big fan of bars with themes, and she gets way too much satisfaction from crossing things off her to-do list.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Forrest Gump"
						},
						{
							"subject": "Band",
							"answer": "The Beatles"
						},
						{
							"subject": "Quote",
							"answer": "\"Of course it is happening inside your head... but why on earth should that mean that it is not real?\" - Harry Potter and the Deathly Hallows"
						},
						{
							"subject": "TV Show",
							"answer": "Friends"
						},
						{
							"subject": "Cocktail",
							"answer": "Jameson & Ginger Ale"
						}
					]
				},
				{
					"name": "Austin Van Houten",
					"jobTitle": "Manager, Global Tracking",
					"pictureUrl": "../../assets/img/people/Austin.Van.Houten.jpg",
					"bio": "Prior to joining the U.S. Tracking team, Austin graduated from Clemson University with a degree in Marketing and a minor in Film Studies. From there, he received a Master's in Marketing Research from the University of Georgia. Austin moved from Greenville, South Carolina to Los Angeles to combine his love of data analysis and movies. Outside of NRG, Austin can be found writing or throwing passes out of bounds in basketball.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Beach House"
						},
						{
							"subject": "Movie",
							"answer": "The Nice Guys"
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey Sour"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Clippers/Clemson Tigers"
						},
						{
							"subject": "Director",
							"answer": "Denis Villeneuve"
						}
					]
				},
				{
					"name": "Keith Wagstaff",
					"jobTitle": "Editorial Director, Global Marketing",
					"pictureUrl": "../../assets/img/people/Keith.Wagstaff.jpg",
					"bio": "Before joining NRG, Keith led a talented team of journalists as Mashable's Tech Editor, where he won several awards from the Los Angeles Press Club. He worked as a technology reporter for NBC News and TIME, and has written for GQ, New York Magazine, The Wall Street Journal Magazine, VICE, and The Week. He earned his B.A. in Journalism from the University of Southern California.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "Collected Fictions, by Jorge Luis Borges"
						},
						{
							"subject": "TV Show",
							"answer": "Star Trek: The Next Generation"
						},
						{
							"subject": "Restaurant",
							"answer": "Roman’s, Brooklyn, NY"
						},
						{
							"subject": "Movie",
							"answer": "Do The Right Thing"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Lakers"
						}
					]
				},
				{
					"name": "Aaron Williams ",
					"jobTitle": "Executive Vice President, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Aaron.Williams.jpg",
					"bio": "Aaron joined NRG in 2020 and works with our Platform & Technology clients, helping them uncover insights spanning the product lifecycle. Aaron has extensive technology research expertise, having advised major tech companies on key business initiatives for nearly 20 years. He has worked extensively with B2B technical audiences, including IT Professionals and Developers, in both quantitative and qualitative research, including moderation. Previously, Aaron worked for Synovate (now Ipsos) and Paradoxes, Inc., as well as Microsoft’s Central Market Research Group running large, global tracking studies. Aaron has an MBA from the University of Washington with emphases in Marketing and Management.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "They Might Be Giants"
						},
						{
							"subject": "Movie",
							"answer": "Ferris Bueller's Day Off"
						},
						{
							"subject": "Book",
							"answer": "Zen and the Art of Motorcyle Maintenance"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Costa Rica"
						},
						{
							"subject": "Sports Team",
							"answer": "Indiana Hoosiers Basketball"
						}
					]
				},
				{
					"name": "Stephanie Wong",
					"jobTitle": "Senior Director, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Stephanie.Wong.jpg",
					"bio": "Stephanie joined NRG’s Platforms & Technology group in 2021, bringing with her more than a decade of experience conducting research in the media and technology space. With an eye for design, she is passionate about bringing data to life through compelling visualizations and storytelling. Prior to joining NRG, she worked at Horowitz Research, where she led the syndicated research program and conducted custom projects to inform product, content, marketing, customer experience, and brand strategies for leading media companies. Stephanie is an East Coast transplant living in Denver, and when she’s not busy exploring all the Rocky Mountains have to offer, she’s an avid scuba diver and amateur underwater photographer.",
					"favourites": [
						{
							"subject": "Quote",
							"answer": "\"Before I do anything, I ask myself, would an idiot do that? And if the answer is yes, I do not do that thing.\" - Dwight Schrute"
						},
						{
							"subject": "Superhero",
							"answer": "Batman"
						},
						{
							"subject": "Book",
							"answer": "The Wind-Up Bird Chronicle"
						},
						{
							"subject": "Game",
							"answer": "Anything Zelda"
						},
						{
							"subject": "Cocktail",
							"answer": "Old Fashioned"
						}
					]
				},
				{
					"name": "Jeff Wysocki",
					"jobTitle": "Senior Director, Project Management, Platform & Technology Clients",
					"pictureUrl": "../../assets/img/people/Jeff.Wysocki.jpg",
					"bio": "Jeff joined NRG in 2020, where he works with the Platforms and Technology team as a Director of Project Management.  In this role Jeff will help provide some structure (and sanity) by defining best practices, simplifying processes, managing resources and addressing training needs.  Jeff comes from Ipsos, where he had a variety of responsibilities across the business; from project and people management to process improvement, training development and even recruiting.  Originally from Chicago, Jeff moved to Redondo Beach in late 2018 and enjoys playing soccer and exploring California in his free time.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "Choke - By Chuck Palahniuk"
						},
						{
							"subject": "Food/Dish",
							"answer": "Deep dish pizza, preferably from Lou Malnati's"
						},
						{
							"subject": "Restaurant",
							"answer": "Roka Akor...Best steak i have ever had."
						},
						{
							"subject": "Cocktail",
							"answer": "Jack Daniels with a splash of ginger ale and cherry juice."
						},
						{
							"subject": "Game Show Host",
							"answer": "Bob Barker, not even close!"
						}
					]
				},
				{
					"name": "Andrew Youn",
					"jobTitle": "Research Analyst, Platform & Technology Clients",
					"pictureUrl": "",
					"bio": "Andrew is a Research Analyst joining the Platform & Technology Clients team. He received his B.S. in Cognitive Science from UCLA in 2018 and has been working at Kaiser Permanente's Virtual Medical Center as an analyst prior to joining NRG. Due to the shortage of music events during Covid, he has started collecting vinyl's of his favorite albums and Video Game OSTs.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Bojack Horseman"
						},
						{
							"subject": "Game",
							"answer": "Transistor (Supergiant Games)"
						},
						{
							"subject": "Sports Team",
							"answer": "Philadelphia Eagles"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan"
						},
						{
							"subject": "Quote",
							"answer": "\"If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough\" - Oprah Winfrey"
						}
					]
				},
				{
					"name": "John Young",
					"jobTitle": "Vice President, Content & Strategy",
					"pictureUrl": "../../assets/img/people/John.Young.jpg",
					"bio": "John specializes in film market research, often working on a particular movie throughout the entire research life cycle, including recruited-audience screenings, advertising tests, and focus groups. He graduated from USC with degrees in Cinema-Television Critical Studies and Print Journalism. Before joining NRG in 2012, John was a reporter for Entertainment Weekly magazine, where he got to interview many of his favorite actors and filmmakers. When he's not watching a movie, John enjoys traveling, hiking, baseball, concerts, theme parks, video games, and drinks that start with the letter “M.”",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "2001: A Space Odyssey"
						},
						{
							"subject": "Band",
							"answer": "Radiohead"
						},
						{
							"subject": "Team",
							"answer": "Los Angeles Dodgers"
						},
						{
							"subject": "Game",
							"answer": "The Legend of Zelda: Ocarina of Time"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Nicole Zorin",
					"jobTitle": "Project Manager, Global Tracking",
					"pictureUrl": "",
					"bio": "Nicole brings experience and proven abilities in Project Management, Market Research, Marketing, and Data Analytics. Using her creative and strategic skills, Nicole will help pave the way to a more effective and advanced future for the Global Tracking team. Her focus centers around collaboration with internal teams to establish ways to grow and move forward as a company. She is passionate and encourages her colleagues to embrace change and work together as pieces of a puzzle in order to produce breakthrough results.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Devil Wears Prada"
						},
						{
							"subject": "TV Show",
							"answer": "Schitt's Creek and Bob's Burgers"
						},
						{
							"subject": "Actress",
							"answer": "Jennifer Lawrence"
						},
						{
							"subject": "Food",
							"answer": "Sushi"
						},
						{
							"subject": "Cocktail",
							"answer": "Lemon Drop"
						}
					]
				}
			]
		},
		"operations": {
			"title": "Setting the stage",
			"list": [
				{
					"name": "Sheldon Abelin",
					"jobTitle": "Coding Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/Sheldon.Abelin.jpg",
					"bio": "Sheldon was born in NYC but raised in the South Bay of Los Angeles County. He graduted college with degrees in History, Communications and  Graduate Pre-law at UCLA. He married his high school sweetheart and has two incredible grown kids. SMPTE and SAG member. His favorite early jobs were at the Long Beach Grand Prix, NYC film lab trainer for Studio Film & Tape and Retention Lead at TimeWarner Cable.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Game of Thrones"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Hawaii"
						},
						{
							"subject": "Food/Dish",
							"answer": "Mexican/Chile Rellanos"
						},
						{
							"subject": "Sports Team",
							"answer": "Dodgers"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan"
						}
					]
				},
				{
					"name": "Vishnu Akella",
					"jobTitle": "Senior Fieldwork Specialist, Fieldwork",
					"pictureUrl": "",
					"bio": "Vishnu grew up in Michigan. He received his Bachelors from Case Western Reserve University in Political Science and Sociology. Prior to NRG, he worked in public opinion research and now brings his passion for entertainment and market research to NRG’s fieldwork team.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "He Got Game"
						},
						{
							"subject": "TV Show",
							"answer": "The Carmichael Show"
						},
						{
							"subject": "Restaurant",
							"answer": "Avon Donuts right at 6AM when the donuts are warm (Pontiac, MI)"
						},
						{
							"subject": "Sports Teams",
							"answer": "Detroit Lions"
						},
						{
							"subject": "Actor",
							"answer": "Shah Rukh Khan"
						}
					]
				},
				{
					"name": "Carlos Alvarenga",
					"jobTitle": "Quality Control Specialist I, Coding",
					"pictureUrl": "",
					"bio": "Carlos brings with him over 15 years of experience in the market research industry. A native of Los Angeles, CA, he got his start in the industry in San Francisco, CA in the late 1990s and continued it upon his return to his hometown in 2005. He is a fluent Spanish speaker and has been invaluable in supporting the coding/operations departments for Nielsen and now with NRG. On his days off he can be found exploring the newest doughnut shops around town, conquering the mountains at Disneyland, attending local sporting events, and attending concerts.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Smiths"
						},
						{
							"subject": "Movie",
							"answer": "Pulp Fiction"
						},
						{
							"subject": "Restaurant",
							"answer": "Carthay Circle, Anaheim"
						},
						{
							"subject": "Cocktail",
							"answer": "Negroni"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Dodgers"
						}
					]
				},
				{
					"name": "Ken Anderson",
					"jobTitle": "Director, Tracking Data Processing",
					"pictureUrl": "../../assets/img/people/Ken.Anderson.jpg",
					"bio": "Ken inadvertently responded to a classified ad looking for movie research telemarketers and got his first \"real\" job in the old NRG phone room on Hollywood Blvd in early 1988.  He soon transferred to the Coding department and worked there for several years in the pencil and paper days.  He left NRG for a few years to work for the tabulation house that did all of NRG's data reports and then returned to NRG in 2003 to bring the data processing in house. Ken currently works with the Global Tracking  team and has overseen the overnight tracking runs since Jan 2000. He lives in Thousand Oaks with his wife and two college age daughters.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Pearl Jam"
						},
						{
							"subject": "Movie",
							"answer": "Groundhog Day"
						},
						{
							"subject": "Quote",
							"answer": "\"Do your job\" - Bill Belichick"
						},
						{
							"subject": "Food/Dish",
							"answer": "White Chocolate Magnum Ice Cream Bar"
						},
						{
							"subject": "Director",
							"answer": "Wes Anderson"
						}
					]
				},
				{
					"name": "Brenden Andoseh",
					"jobTitle": "Jr Project Manager, Research Operations",
					"pictureUrl": "",
					"bio": "Brenden graduated from George Mason University with a B.A in Global Affairs, a minor in Conflict Analysis and Resolution and is a certified Scrum Master. Prior to NRG, Brenden has worked in project management and coordination on a number of multi-stakeholder consensus-building projects. Brenden seeks to leverage his project management experience to assist with the team's ability to deliver results with increased efficiency and timeliness.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Coming to America"
						},
						{
							"subject": "TV Show",
							"answer": "The Walking Dead"
						},
						{
							"subject": "Sports Team",
							"answer": "Arsenal"
						},
						{
							"subject": "Game",
							"answer": "Football"
						},
						{
							"subject": "Book",
							"answer": "War and Peace"
						}
					]
				},
				{
					"name": "Alfred Angel",
					"jobTitle": "Manager, Software Engineering",
					"pictureUrl": "../../assets/img/people/Alfred.Angel.jpg",
					"bio": "Alfred is a .Net developer with 10+ of experience in both web and client based applications.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Million Dollar Baby"
						},
						{
							"subject": "TV Show",
							"answer": "Stranger Things"
						},
						{
							"subject": "Quote",
							"answer": "\"All is well.\""
						},
						{
							"subject": "Game",
							"answer": "Soccer"
						},
						{
							"subject": "Cocktail",
							"answer": "Long Island"
						}
					]
				},
				{
					"name": "Meghan Aruffo",
					"jobTitle": "Screenings Manager, Screenings",
					"pictureUrl": "../../assets/img/people/Meghan.Aruffo.jpg",
					"bio": "Meghan Aruffo graduated from the University of Central Florida with a Degree in Interpersonal Organizational Communications. Since moving to Los Angeles she has spent the last seven years in the entertainment industry from all facets of the industry: in front of the camera, behind the camera, coordinating live studio audiences, red carpets, events and screenings.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Eternal Sunshine of a Spotless Mind"
						},
						{
							"subject": "Class in School",
							"answer": "English"
						},
						{
							"subject": "Book",
							"answer": "The Universe Has Your Back"
						},
						{
							"subject": "Vacation Spot",
							"answer": "The British Virgin Islands"
						},
						{
							"subject": "Cocktail",
							"answer": "Champagne"
						}
					]
				},
				{
					"name": "Diego Barrera",
					"jobTitle": "Specialist, Business Operations",
					"pictureUrl": "../../assets/img/people/Diego.Barrera.jpg",
					"bio": "Diego graduated from CSULA in 2019 with a Bachelor's in English. He also left with a passion for the entertainment industry, filmmaking, and anything related to movies and TV. He also enjoys spending time with friends finding new restaurants to eat at, hiking trails with his family and dogs, and contributing to Channel 101.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Jeff Rosenstock"
						},
						{
							"subject": "Movie",
							"answer": "Mishima: A Life in Four Chapters"
						},
						{
							"subject": "TV Show",
							"answer": "Curb Your Enthusiasm and Bojack Horseman"
						},
						{
							"subject": "Restaurant",
							"answer": "Far Bar"
						},
						{
							"subject": "Actor",
							"answer": "Nicholas Cage"
						}
					]
				},
				{
					"name": "Mark Bartlett",
					"jobTitle": "Coding Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/Mark.Bartlett.jpg",
					"bio": "Mark has 15 years of experience in retail, cinema and charity management roles. Mark grew up in central London, and has lived in Bromley for the last 15 years. As a manager Mark has worked for The Disney Store, HMV, Empire Cinemas and Picturehouse. Mark is a keen writer and interviewer and has contributed to several movie and music websites prior to his role in NRG's coding department. On Mark's days off he enjoys playing gigs as the lead singer of punk rock band Our Lives In Cinema, attending concerts and going for long walks with his wife Ruth.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Jeff Rosenstock"
						},
						{
							"subject": "Movie",
							"answer": "A Nightmare On Elm Street"
						},
						{
							"subject": "Show",
							"answer": "The Simpsons"
						},
						{
							"subject": "Book",
							"answer": "Sapiens - Yuval Noah Narari"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "David Battle",
					"jobTitle": "Quality Control Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/David.Battle.jpg",
					"bio": "David Battle, a native of Cleveland, Ohio and began his career in entertainment working for producer Roger Corman, writing a script about the Los Angeles riots of 1992. His script, 5 DAYS OF WAR was directed by Renny Harlin and featured Andy Garcia and Val Kilmer. David holds a BA in Government from Cornell University.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Tokyo Story"
						},
						{
							"subject": "TV Show",
							"answer": "Fargo"
						},
						{
							"subject": "Book",
							"answer": "Ready Player One"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Dublin, Ireland"
						},
						{
							"subject": "Director",
							"answer": "Coen Brothers"
						}
					]
				},
				{
					"name": "Kathy Benjamin",
					"jobTitle": "Executive Vice President, Business Transformation",
					"pictureUrl": "../../assets/img/people/Kathy.Benjamin.jpg",
					"bio": "Kathy's responsibilities are three-fold: she manages NRG's data science team, leads innovations and operations for film tracking, and is responsible for bringing NRG's social offering to market. Kathy's unique blend of collaborative leadership, client management/consulting, passion for continuous improvement, and market research expertise prompted a colleague to call her the “Olivia Pope of NRG.\" In other words, she gets things handled (though she doesn't know where any bodies are buried). Kathy has also worked at Synovate, J.D. Power & Associates, and General Motors and has degrees in Statistics from Iowa State University and the University of Michigan. ",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Jayhawks"
						},
						{
							"subject": "Movie",
							"answer": "How can I pick just one? If I must: Raiders of the Lost Ark"
						},
						{
							"subject": "Superhero",
							"answer": "Jessica Jones"
						},
						{
							"subject": "Game",
							"answer": "Tennis"
						},
						{
							"subject": "Cocktail",
							"answer": "Pinot Noir from Santa Rita Hills AVA"
						}
					]
				},
				{
					"name": "Jonathan Benoit",
					"jobTitle": "Manager, Software Engineering, Information Technology",
					"pictureUrl": "../../assets/img/people/Jonathan.Benoit.jpg",
					"bio": "Jonathan is joining the Originals IQ team as Manager, Software Engineering and will be reporting to John Paez. Prior to NRG, he managed a Research and Development software team, working on CIS software in the utilities market. In his free time, you can find Jonathan watching and thoroughly enjoying his kids sporting activities, and playing with his two dogs.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Miracle"
						},
						{
							"subject": "Band",
							"answer": "Foo Fighters"
						},
						{
							"subject": "Book",
							"answer": "Late Bloomers"
						},
						{
							"subject": "Game",
							"answer": "Poker"
						},
						{
							"subject": "Restaurant",
							"answer": "Le Continental in Quebec City"
						}
					]
				},
				{
					"name": "Steffi Castelino",
					"jobTitle": "Quantitative Fieldwork Manager, Fieldwork",
					"pictureUrl": "../../assets/img/people/Steffi.Castelino.jpg",
					"bio": "Steffi assists with managing vendor relationships and communicating with the client teams to ensure all fieldwork is completed on schedule. Prior to joining NRG, her roles included project management, customer retention, qualitative & quantitative research, budget administration, process optimization, team building, and best practices. Steffi has earned her Post Graduate Diploma of Business administration with a major in Marketing from Symbiosis",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Michael Learns to Rock"
						},
						{
							"subject": "Food/Dish",
							"answer": "Anything Chicken"
						},
						{
							"subject": "Restaurant",
							"answer": "Mumbai (India) street food!"
						},
						{
							"subject": "Cocktail",
							"answer": "Beer and more Beer"
						},
						{
							"subject": "Sports Team",
							"answer": "Toronto Raptors"
						}
					]
				},
				{
					"name": "Massie Chen",
					"jobTitle": "Staff Accountant, Accounting & Finance",
					"pictureUrl": "",
					"bio": "Massie is joining the Accounting & Finance team as a Staff Accountant and will be reporting to Rebecca Dahl. She earned her B.S. degree in Agribusiness from University of Illinois Urbana-Champaign, from which she also got a Master's degree in Accounting Science. Prior to joining NRG, she worked for a non-profit in Chicago. When she’s not working, you can track her down in her bed, in a yoga studio or at a club with her friends.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "This is Us"
						},
						{
							"subject": "Band",
							"answer": "Roxette"
						},
						{
							"subject": "Cocktail",
							"answer": "Devil Dawgs"
						},
						{
							"subject": "Restaurant",
							"answer": "My dad's cooking & home"
						},
						{
							"subject": "Book",
							"answer": "Currently reading \"Anxious People\" and I like it a lot!"
						}
					]
				},
				{
					"name": "Lynn Chu",
					"jobTitle": "Database Technican/Analyst, Information Technology",
					"pictureUrl": "../../assets/img/people/Lynn.Chu.jpg",
					"bio": "Lynn works on the Cinesys Team focusing on management of the Cinesys database. She provides analytical data for both internal analysts and Studio users. She works with norms data, calculating for a variety of research for TV, trailers, recruits, elements, performance, exit studies and uploading and verifying research data. Lynn also participated in variety of ad-hoc projects for both in-house and clients requests.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Wall-E"
						},
						{
							"subject": "TV Show",
							"answer": "I Love Lucy"
						},
						{
							"subject": "Quote",
							"answer": "\"Time is Money\""
						},
						{
							"subject": "Food/Dish",
							"answer": "Chinese and Italian"
						},
						{
							"subject": "Actor",
							"answer": "Robin Williams"
						}
					]
				},
				{
					"name": "Tommy Chu",
					"jobTitle": "Portable Network Manager, Screening Ops",
					"pictureUrl": "",
					"bio": "Tommy Chu was born and raised in Georgia, parents immigrated from Taiwan, and graduated with a Bachelor's degree in International Business from the University of Georgia (GO DAWGS!!). Responsible for setting up network infrastructure for screenings. He also managed IT resources in the restaurant industry before moving to Los Angeles, CA. Big sports fan (UGA Football, Atlanta Braves, and Manchester United), avid gamer and gadget nerd.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Godfather"
						},
						{
							"subject": "TV Show",
							"answer": "Game of Thrones"
						},
						{
							"subject": "Band",
							"answer": "Oasis"
						},
						{
							"subject": "Game",
							"answer": "FIFA '22"
						},
						{
							"subject": "Food",
							"answer": "Any and all things Asian"
						}
					]
				},
				{
					"name": "Ryan Corrigan",
					"jobTitle": "Manager, Business Operations",
					"pictureUrl": "../../assets/img/people/Ryan.Corrigan.jpg",
					"bio": "Ryan joined NRG in 2004 and has supervised the Production team since 2007. He works with departments across the company to produce and deliver a variety of client materials, including domestic and international campaign tracking, opening weekend surveys and creative ad testing reports. Ryan was a Film Studies major at the University of Massachusetts Amherst but graduated with a BA in GoldenEye for Nintendo 64! Outside of the office, he creates short form content and has worked as a writer on the Yahoo! webseries \"Ghost Ghirls\" and served as assistant director on NBCUniversal's basketball documentary \"The Pistol Shrimps.\" Boston is the greatest sports city of all time.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Fleetwood Mac"
						},
						{
							"subject": "Movie",
							"answer": "All Spielberg and Lucas 1975 to 1984, Boogie Nights"
						},
						{
							"subject": "TV Show",
							"answer": "MacGyver"
						},
						{
							"subject": "Book",
							"answer": "Travels with Charley, by John Steinbeck"
						},
						{
							"subject": "Sports Team",
							"answer": "Boston Red Sox"
						}
					]
				},
				{
					"name": "Shenuki De Silva",
					"jobTitle": "Assistant to CEO/COO",
					"pictureUrl": "../../assets/img/people/Shenuki.De.Silva.jpg",
					"bio": "Shenuki is the Assistant to the CEO & COO. She earned her Bachelor of Science in Psychology from DePaul University in Chicago, IL. She is originally from Orange County, CA and lives in Los Angeles now. In her free time she enjoys going to the beach and making charcuterie boards with her friends.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "ABBA"
						},
						{
							"subject": "Movie",
							"answer": "Legally Blonde"
						},
						{
							"subject": "Quote",
							"answer": "\"My vibe right now is just living life\""
						},
						{
							"subject": "Restaurant",
							"answer": "RPM Italian in Chicago, IL"
						},
						{
							"subject": "Cocktail",
							"answer": "Spicy Margarita"
						}
					]
				},
				{
					"name": "Alicia Driscoll",
					"jobTitle": "Senior Vice President, Business Transform",
					"pictureUrl": "../../assets/img/people/Alicia.Driscoll.jpg",
					"bio": "Alicia leads the Gaming + Interactive Media group. In her role, she works with top clients including console leaders, AAA publishers, mobile developers, and digital content creators providing research and strategic consulting services at all stages of the product development lifecycle. Prior to joining National Research Group, she worked at PSB Research where she led the gaming division. Alicia graduated from Dartmouth College with degrees in Psychology and Applied and Professional Ethics.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Troop Beverly Hills"
						},
						{
							"subject": "Game",
							"answer": "Triple Town (mobile)"
						},
						{
							"subject": "Restaurant",
							"answer": "Bar Pintxo (Santa Monica)"
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey Sour"
						},
						{
							"subject": "Game Show Host",
							"answer": "Kirk Fogg"
						}
					]
				},
				{
					"name": "Alfred Estolas",
					"jobTitle": "Director of Custom, Data Processing",
					"pictureUrl": "../../assets/img/people/Alfred.Estolas.jpg",
					"bio": "A graduate of UC Irvine, Alfred landed his first job in 2002 at the tabulation house that provided NRG data reports. A couple years later he was hired by NRG to help take DP in-house. That job is now a career in which Alfred has grown into a leader focused on efficiency, quality and team success. When away from work, Alfred can be found with his two boys doing Dad things.",
					"favourites": [
						{
							"subject": "Quote",
							"answer": "\"Attract what you expect, Reflect what you what you desire, Become what you respect, Mirror what you admire\" - Annonymous"
						},
						{
							"subject": "Superhero",
							"answer": "My Mom"
						},
						{
							"subject": "Book",
							"answer": "The Five People You Meet in Heaven"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Puerto Vallarta, Mexico"
						},
						{
							"subject": "Cocktail",
							"answer": "Water on the rocks"
						}
					]
				},
				{
					"name": "Mindie Erreich",
					"jobTitle": "Senior Training Manager, Human Resources",
					"pictureUrl": "",
					"bio": "Mindie joined NRG's HR team focusing on training and development. Before her career in market research, she worked as an event planner and then got her start in market research at Ipsos where she worked directly with clients. Ultimately, she realized her passion came from training and mentoring, so she transferred her skills over to the learning and development team. In her free time, you can find Mindie searching for her next book to read, documentary to binge or spinning.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Catch Me If You Can"
						},
						{
							"subject": "TV Show",
							"answer": "Ted Lasso"
						},
						{
							"subject": "Book",
							"answer": "The Women in the Window"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Italy"
						},
						{
							"subject": "Food",
							"answer": "Pizza"
						}
					]
				},
				{
					"name": "Danielle Evans",
					"jobTitle": "Senior Fieldwork Specialist",
					"pictureUrl": "../../assets/img/people/Danielle.Evans.jpg",
					"bio": "Danielle has been working for NRG since 2016, but was previously a professional chef for well-established London law firms. Danielle has assisted with and overseen a variety of projects, including exit polls, test screening programs, online ad testing and focus groups across the UK and other core markets. Outside of NRG, she is a keen film and theater enthusiast, and takes part in local amateur-dramatic productions and dance productions. She is also a self-admitted \"Trekkie\" and has attended several Star Trek conventions.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Star Trek: The Undiscovered Country"
						},
						{
							"subject": "TV Show",
							"answer": "RuPauls Drag Race"
						},
						{
							"subject": "Quote",
							"answer": "If you cant love yourself, how in the hell you gonna love somebody else?"
						},
						{
							"subject": "Book",
							"answer": "Harry Potter and the Order of the Phoenix"
						},
						{
							"subject": "Food/Dish",
							"answer": "Chicken Nuggets and French Fries"
						}
					]
				},
				{
					"name": "Dana Farwell",
					"jobTitle": "Manager, Qualitative Fieldwork",
					"pictureUrl": "../../assets/img/people/Dana.Farwell.jpg",
					"bio": "Dana Farwell has close to 15 years’ experience in the qualitative realm of market research, specializing in Television Entertainment, project management, recruitment, and vendor relations. She was previously at Screen Engine/ASI for 3 years, and prior to that, CBS and Jackson Adept Research. Dana was born and raised in Los Angeles, and considers herself a true “valley girl”, but a TV and Movie nerd at heart. Nowadays, she spends her time chasing after her 2 children, trying to set quality time with her husband, and is ready to travel and see the world again!",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Queen"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Saint Tropez"
						},
						{
							"subject": "Food",
							"answer": "Tacos"
						},
						{
							"subject": "Game",
							"answer": "Clue"
						},
						{
							"subject": "Cocktail",
							"answer": "Moscow Mule"
						}
					]
				},
				{
					"name": "Eric Febre",
					"jobTitle": "Digital Media Designer, Design",
					"pictureUrl": "../../assets/img/people/Eric.Febre.jpg",
					"bio": "Eric is a multimedia whiz who spins and mixes visual and audio elements into compelling, deliverable bytes for both in-house and clients projects. He followed his passion in studying art at CSULA with a concentration in storytelling and animation. Eric previously led the morning production team in assembling, organizing and quality assurance of Theatrical Tracking report hard copies distributed to major movie studios throughout Los Angeles.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Postmodern Jukebox"
						},
						{
							"subject": "TV Show",
							"answer": "The Office"
						},
						{
							"subject": "Restaurant",
							"answer": "Girl & the Goat(Chicago)"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Lakers"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan"
						}
					]
				},
				{
					"name": "Devon Foster",
					"jobTitle": "Senior Manager, Culture & Experience",
					"pictureUrl": "../../assets/img/people/Devon.Foster.jpg",
					"bio": "Devon graduated summa cum laude from the Univeristy of Colorado, Denver with a B.S. in Music Business and manages organizational culture and events at NRG. He aims to create the best experience possible for his teamates, promoting wellness and social connectivity throughout NRG. As a Colorado native, Devon loves to enjoy the outdoors, write music and spend time with his family and friends.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Avatar"
						},
						{
							"subject": "TV Show",
							"answer": "Fleabag"
						},
						{
							"subject": "Quote",
							"answer": "“One good thing about music, when it hits you, you feel no pain.” ― Bob Marley"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Evergreen, Colorado"
						},
						{
							"subject": "Director",
							"answer": "Denis Villeneuve"
						}
					]
				},
				{
					"name": "Robert Hardcastle",
					"jobTitle": "Senior Director, Business Operations",
					"pictureUrl": "../../assets/img/people/Robert.Hardcastle.jpg",
					"bio": "Robert started his career with NRG in 2014 as Operations Manager in the UK, before migrating to the Los Angeles office in April 2017. His operational responsibilities are wide ranging and varied, including overseeing the company's Legal and Insurance functions, whilst managing the Production department and having overall responsibility for Facilities in each of NRG's global offices. Before joining NRG, Robert spent 7 years working in the operations teams for some of the biggest law firms in the UK.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "24, Homeland, GOT"
						},
						{
							"subject": "Quote",
							"answer": "\"A pessimist sees the difficulty in every opportunity; an optimist sees the opportunity in every difficulty\" Sir Winston Churchill"
						},
						{
							"subject": "Vacation Spot",
							"answer": "France/Italy"
						},
						{
							"subject": "Sports Team",
							"answer": "(UK) West Ham United;(US) LA Dodgers!"
						},
						{
							"subject": "Actor",
							"answer": "Leonardo DiCaprio"
						}
					]
				},
				{
					"name": "Jennifer Harris",
					"jobTitle": "Director, Screenings",
					"pictureUrl": "../../assets/img/people/Jennifer.Harris.jpg",
					"bio": "Jennifer started her career at NRG as a screener when she thought people getting recruited for screenings on the street was a scam... and she quickly learned its a lively hood in Southern California.  Moving to a position in the office, she now knows more about movie theaters and demographics then she ever thought possible.  When she isn't watching target goals slowly move upwards, she likes to travel the world, see Broadway theater and run half marathons for shiny bling.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Any of the Chicagos"
						},
						{
							"subject": "Superhero",
							"answer": "All Marvel Heroes"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Wherever I am going next.."
						},
						{
							"subject": "Food/Dish",
							"answer": "PIZZA!"
						},
						{
							"subject": "Sports Team",
							"answer": "What is a sport??"
						}
					]
				},
				{
					"name": "Liv Horn",
					"jobTitle": " Senior Presentation and Data Designer, Design",
					"pictureUrl": "../../assets/img/people/Liv.Horn.jpg",
					"bio": "Liv made her market research debut in 2011 as a qualitative researcher. Over the years, she developed a growing passion for visually translating research data into persuasive and engaging reports and presentations. Prior to joining NRG, Liv spent five years advancing her design skills at a boutique market research consultancy, transforming client facing decks for bespoke projects. This Swedish native originating from above the polar circle, finds time for her creative outlets in front of her easel, preferably while airing a fast-paced game of hockey (Let’s Go Rangers!).",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Lion King"
						},
						{
							"subject": "TV Show",
							"answer": "Outlander"
						},
						{
							"subject": "Quote",
							"answer": "\"The most important decision we make is whether we believe we live in a friendly or hostile universe\" - Albert Einstein"
						},
						{
							"subject": "Book",
							"answer": "Alla Prima II, Everything I Know About Painting - and More, By Richard Schmid with Katie Swatland"
						},
						{
							"subject": "Sports Team",
							"answer": "New York Rangers"
						}
					]
				},
				{
					"name": "Paul Hughes",
					"jobTitle": "Director, Business Operations",
					"pictureUrl": "../../assets/img/people/Paul.Hughes.jpg",
					"bio": "Paul has over 27 years at NRG and is Manager of the Production department. He has vast experience in the production and distribution of the collected research data. He attended the University of Bridgeport where he was a Marketing major.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Who/U2"
						},
						{
							"subject": "Movie",
							"answer": "Tombstone"
						},
						{
							"subject": "TV Show",
							"answer": "Big Bang Theory"
						},
						{
							"subject": "Class in School",
							"answer": "Music"
						},
						{
							"subject": "Superhero",
							"answer": "Superman"
						}
					]
				},
				{
					"name": "Scott Jeremiasen",
					"jobTitle": "Director, Data Collection",
					"pictureUrl": "../../assets/img/people/Scott.Jeremiasen.jpg",
					"bio": "Scott joined NRG in 1988 as a telephone interviewer. Between 1990 and 2004 he worked his way up the ranks as Confirms Supervisor/Confirms Manager/Phone Room Supervisor/Assistant Manager of the Phone Room/CATI programmer, as well as aiding the Field Department and Coding Department. In 2004 Scott was the first CAPI programmer at NRG and aided in the move from pencil/paper. Scott currently is the Data Collections Manager and responsible for all survey programming. Scott's overall experience helps ensure the entire testing process runs smoothly and all deadlines are met.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "George Strait"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Maui"
						},
						{
							"subject": "Restaurant",
							"answer": "The Black Steer (Loveland, CO)"
						},
						{
							"subject": "Cocktail",
							"answer": "Budwieser and JD Shots"
						},
						{
							"subject": "Sports Team",
							"answer": "LA Kings/Dallas Cowboys (of course)"
						}
					]
				},
				{
					"name": "Michael Jouini",
					"jobTitle": "Quality Control Specialist II, Coding",
					"pictureUrl": "",
					"bio": " Michael has worked in economic research, the cruise industry, as a COBOL programmer (yes, he programmed mainframes), and now in market research for entertainment.  Michael also worked for a summer in Germany at a frozen food factory.  His interests include history, politics, art and entertainment and his hobbies include traveling, reading, hiking, going to museums and, of course, going to the movies. He has seen a lot of the US, Canada, Western Europe and has also been to Asia, Mexico and Australia.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Kind Hearts and Coronets or The Man Who Would Be King, it's a tie"
						},
						{
							"subject": "Book",
							"answer": "Tragedy and Hope by Carroll Quigley"
						},
						{
							"subject": "Game",
							"answer": "Warhammer 40,000"
						},
						{
							"subject": "Cocktail",
							"answer": "Beer, especially Belgian"
						},
						{
							"subject": "TV Show",
							"answer": "Huell Howser or Rick Steves, it's a tie"
						}
					]
				},
				{
					"name": "Rachel Kang",
					"jobTitle": "Junior Technical Product Manager, Research Operations",
					"pictureUrl": "",
					"bio": "Rachel works on the product team at NRG. Before moving into product and tech the last couple years she worked in the luxury fashion industry alongside contemporary music artists and in the NFT space. She studied Art History at John Cabot University in Rome, Italy. In her free time, she enjoys exploring how people interact with physical and digital artworks and traveling around the world.",
					"favourites": [
						{
							"subject": "Food",
							"answer": "Korean Food"
						},
						{
							"subject": "Movie",
							"answer": "Kill Bill series"
						},
						{
							"subject": "Book",
							"answer": "Crying in H Mart"
						},
						{
							"subject": "Show",
							"answer": "Arrested Development"
						},
						{
							"subject": "Cocktail",
							"answer": "Paper Plane"
						}
					]
				},
				{
					"name": "Janna Kefalas",
					"jobTitle": "Talent Acquisition Manager, Human Resources",
					"pictureUrl": "../../assets/img/people/Janna.Kefalas.jpg",
					"bio": "As a Manager, Talent Acquisition, Janna enjoys recruiting and hiring top talent at NRG. Previously, she worked as a technical recruiter at a boutique recruiting agency in LA and as an in-house recruiter at a community-based mental health clinic serving foster youth in Oakland. She holds a B.A. in Rhetoric & Communications and a B.A. in Spanish from UC Davis. Janna is a San Diego native and is a self-proclaimed musical theater nerd and podcast junkie.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Ben Folds Five"
						},
						{
							"subject": "Movie",
							"answer": "West Side Story (original) "
						},
						{
							"subject": "TV Show",
							"answer": "Mad Men"
						},
						{
							"subject": "Restaurant",
							"answer": "AOC (Beverly Grove)"
						},
						{
							"subject": "Quote",
							"answer": "\"Life is either a daring adventure or nothing at all.\" - Helen Keller"
						}
					]
				},
				{
					"name": "Ashley Kenyon",
					"jobTitle": "Senior Talent Acquisition Specialist, Human Resources",
					"pictureUrl": "../../assets/img/people/Ashley.Kenyon.jpg",
					"bio": "Ashley is the Senior HR Coordinator at National Research Group. She grew up passionate about entertainment, especially TV. She received a Communications degree at the University of Southern California and pursued a career in entertainment publicity. Most recently she comes from Amazon where she was doing publicity for their original series. She became the publicity department's intern recruiter there and her enjoyment of hiring and developing talent influenced her to change careers to human resources. On her down time, she loves to play beach volleyball, go bike riding or hiking.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Almost Famous"
						},
						{
							"subject": "TV Show",
							"answer": "Succession"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Greece"
						},
						{
							"subject": "Restaurant",
							"answer": "Carbone"
						},
						{
							"subject": "Actress",
							"answer": "Pheobe Waller-Bridge"
						}
					]
				},
				{
					"name": "Eric Kholobekian",
					"jobTitle": "Senior Manager, Talent Acquisition, Human Resources",
					"pictureUrl": "../../assets/img/people/Eric.Kholobekian.jpg",
					"bio": "Eric is an LA native who earned an undergraduate degree in Communication & Media Studies at Loyola Marymount University. Post college, he stumbled into the HR field and now leads the Talent Acquisition function on the HR team. Prior to joining NRG, Eric was a People Operations Generalist at start-up content studio, ATTN:. During his free time, you can expect to find Eric at his go-to sushi restaurant, on a hiking trail, at a local bar or two, or perhaps officiating a wedding. He's a dog lover as well as an music and crime podcast listener!",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Christine (1983)"
						},
						{
							"subject": "Quote",
							"answer": "\"I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel\" - Maya Angelou"
						},
						{
							"subject": "Book",
							"answer": "The Pigman"
						},
						{
							"subject": "Restaurant",
							"answer": "Sushi Yuzu (Toluca Lake, CA) - Prepare to wait! Forman's Whiskey Tavern across the street is a great place to kill time!"
						},
						{
							"subject": "Director",
							"answer": "Tim Burton"
						}
					]
				},
				{
					"name": "Jane Kim",
					"jobTitle": "Data Processing Technician, Data Processing",
					"pictureUrl": "../../assets/img/people/Jane.Kim.jpg",
					"bio": "Jane joined NRG in March 2021 as a Data Processing Technician. She graduated from University of California, Los Angeles with a degree in Math/Econ. In her free time, she enjoys drawing, playing games, and reading.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Vulfpeck"
						},
						{
							"subject": "TV Show",
							"answer": "Attack on Titan"
						},
						{
							"subject": "Class in School",
							"answer": "History and Math"
						},
						{
							"subject": "Book",
							"answer": "East of Eden"
						},
						{
							"subject": "Game",
							"answer": "Breath of the Wild"
						}
					]
				},
				{
					"name": "Noori Kim",
					"jobTitle": "Senior Specialist, Business Operations",
					"pictureUrl": "",
					"bio": "Noori is a Business Operations Specialist, managing the day-to-day legal and business operations at National Research Group. She graduated from Ohio State University with a B.A. in International Relations and earned her M.A. in International Affairs from the University of California, San Diego. Prior to joining NRG, she worked in various operations roles at Korean companies. Outside of work, she enjoys listening to music, watching TV shows & movies, going to sports games, and cooking Korean food.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "How I Met Your Mother, Friends, and The Office"
						},
						{
							"subject": "Movie",
							"answer": "The Harry Potter series and anything Disney"
						},
						{
							"subject": "Food",
							"answer": "Anything Korean"
						},
						{
							"subject": "Game",
							"answer": "Winning Eleven, FIFA, and Tekken"
						},
						{
							"subject": "Sports Team",
							"answer": "Tottenham Hotspur & Ohio State Buckeyes"
						}
					]
				},
				{
					"name": "Derrion King",
					"jobTitle": "Quality Control Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/Derrion.King.jpg",
					"bio": "Derrion graduated from the University of California, Riverside in 2015 with a Bachelors of Arts in Psychology. Following graduation, he worked for various entertainment companies, with a strong background in parks and resorts in the amusement park industry. After completing his internship with the consumer insights department at Universal Studios Hollywood in 2019, Derrion seeks to continue to remain curious, innovate and grow within the field of market research. When he is not working, you will find him making vlogs and riding roller coasters at Six Flags or Disneyland.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Rihanna"
						},
						{
							"subject": "Superhero",
							"answer": "Aquaman"
						},
						{
							"subject": "Book",
							"answer": "Harry Potter Series"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Orlando, FL"
						},
						{
							"subject": "Cocktail",
							"answer": "Cadilliac Margarita"
						}
					]
				},
				{
					"name": "Jeff Kluesner",
					"jobTitle": "Manager of Cinesys, Information Technology",
					"pictureUrl": "../../assets/img/people/Jeff.Kluesner.jpg",
					"bio": "Jeff started at NRG straight out of music school more than 25 years ago, and joined the Cinesys team at its inception. Over the past two decades, Jeff has had direct input in the design and content of the Cinesys product, and continues to serve NRG's staff and clients with Cinesys' wealth of data and analytical tools.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Beatles"
						},
						{
							"subject": "Movie",
							"answer": "Life of Brian"
						},
						{
							"subject": "TV Show",
							"answer": "The Office (U.K)"
						},
						{
							"subject": "Quote",
							"answer": "I could play \"Stairway to Heaven\" when I was 12. Jimmy Page didn't actually write it until he was 22. I think that says quite a lot\" - Vim Fuego (Adrian Edmondson), \"Bad News\" (Comic Strip Presents)"
						},
						{
							"subject": "Food",
							"answer": "Saag Paneer"
						}
					]
				},
				{
					"name": "Raghuver Kontham",
					"jobTitle": "Software Engineering Manager, IT Development",
					"pictureUrl": "",
					"bio": "Raghu is joining the Engineering Team as a Software Engineering Manager and will be reporting to John Paez. He earned his master’s in Computer Science with Concentration in Bio-Informatics from University of Memphis. Prior to joining NRG, Raghu has worked in managing E-commerce Platforms and developing several software applications for B2C and B2B clients. Raghu lives in Los Angeles and in his free time helps organize various social and outdoor activities and events in and around Southern California Area.",
					"favourites": [
						{
							"subject": "Game",
							"answer": "Table Tennis"
						},
						{
							"subject": "Movie",
							"answer": "Matrix"
						},
						{
							"subject": "Restaurant",
							"answer": "Pomodoro Trattoria"
						},
						{
							"subject": "Sports Team",
							"answer": "New England Patriots"
						},
						{
							"subject": "Actor",
							"answer": "Leonardo DiCaprio"
						}
					]
				},
				{
					"name": "Elizabeth Leeson",
					"jobTitle": "Qualitative Fieldwork Specialist, Fieldwork",
					"pictureUrl": "../../assets/img/people/Elizabeth.Leeson.jpg",
					"bio": "Elizabeth graduated from Wilkes University, Pennsylvania in 2018 with a Bachelor of Business Administration in Marketing degree. Prior to joining NRG, she exhibited her passion for entertainment in the realm of post-production film where she serviced top OTT platforms. When not coordinating qualitative projects, Liz can be found in the great outdoors gardening, geocaching, or just chilling in her hammock!",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Glass Animals"
						},
						{
							"subject": "Game",
							"answer": "Boggle"
						},
						{
							"subject": "Food/Dish",
							"answer": "Halupki (Stuffed cabbage)"
						},
						{
							"subject": "Restaurant",
							"answer": "Joyride Taco House, Phoenix AZ"
						},
						{
							"subject": "Cocktail",
							"answer": "Texas Ranch Water"
						}
					]
				},
				{
					"name": "Zenas Lopez",
					"jobTitle": "Vice President, Fieldwork",
					"pictureUrl": "../../assets/img/people/Zenas.Wilson.jpg",
					"bio": "Zenas manages the firm's external vendor relationships and internal fieldwork team. Prior to joining NRG, she worked at Kelton as a Field Operations Manager for the quantitative department. A California native, Zenas attended American University in Washington D.C. where she received her B.S.B.A in International Business. In her spare time, you can find her travelling or binge watching the newest Netflix series.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "Born a Crime - Trevor Noah"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Dominican Republic"
						},
						{
							"subject": "Food/Dish",
							"answer": "Potatoes (mashed, baked, fried, you name it!)"
						},
						{
							"subject": "Restaurant",
							"answer": "Raclette (NYC)"
						},
						{
							"subject": "Cocktail",
							"answer": "Cuba Libre"
						}
					]
				},
				{
					"name": "Victoria Lutz",
					"jobTitle": "Designer, Design",
					"pictureUrl": "../../assets/img/people/Victoria.Lutz.jpg",
					"bio": "Viewing herself as a creative problem solver, Victoria collaborates with people, teams, and businesses to develop design systems, strategies and processes to do better and more interesting creative work. With a B.F.A. in Graphic Design and Marketing Management minor, Victoria's goal is to help others craft their brand's story in a way that helps engage with their audience and elevate a brand's offering. If you bring her the seed, she will plant it, grow it, and harvest the sweet corn.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Rolling Stones"
						},
						{
							"subject": "Movie",
							"answer": "A Bronx Tale"
						},
						{
							"subject": "Book",
							"answer": "The Fountainhead - Ayn Rand"
						},
						{
							"subject": "Sports Team",
							"answer": "Golden State Warriors"
						},
						{
							"subject": "Director",
							"answer": "Quentin Tarantino"
						}
					]
				},
				{
					"name": "Paolo Magayon",
					"jobTitle": "System Administrator, Information Technology",
					"pictureUrl": "../../assets/img/people/Paolo.Magayon.jpg",
					"bio": "Paolo was born and raised in LA, and has experience in both ends of the vendor-client relationship. He began at Cunningham Research, where he worked every position from Recruiter to Asst. Manager, and joined NRG (the first time) in 2004 as Asst. Field Director. In late 2014, he relocated to Vegas and joined Nielsen, where he spent some of his time on-site with research partners at the MGM and Planet Hollywood. He rejoined NRG in 2018. When he's not at work, Paolo's involved in bowling league, kickball league, and N64 tournaments such as Goldeneye and Mario Kart (do you even drift, bro?)",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Westworld/Game of Thrones"
						},
						{
							"subject": "Superhero",
							"answer": "Iron Man"
						},
						{
							"subject": "Food/Dish",
							"answer": "Sushi"
						},
						{
							"subject": "Cocktail",
							"answer": "Whiskey on the Rocks"
						},
						{
							"subject": "Sports Team",
							"answer": "LA Lakers, Vegas Golden Knights"
						}
					]
				},
				{
					"name": "John Maku",
					"jobTitle": "Senior Qualitative Fieldwork Specialist, Fieldwork",
					"pictureUrl": "../../assets/img/people/John.Maku.jpg",
					"bio": "John Maku graduated from DePaul University in 2017 with a B.A. in Communication & Media Studies as well as History. Prior to NRG, John worked as a Recruiter in qualitative market research, making sure focus groups were filled with qualified respondents and ran smoothly. In his free time, John enjoys an assortment of action, horror, and sci-fi video games and movies. His other hobbies include camping and hiking in the beautiful outdoors.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Arctic Monkeys"
						},
						{
							"subject": "Movie",
							"answer": "Memento"
						},
						{
							"subject": "TV Show",
							"answer": "Scrubs"
						},
						{
							"subject": "Game",
							"answer": "Resident Evil 2"
						},
						{
							"subject": "Director",
							"answer": "The Coen Brothers"
						}
					]
				},
				{
					"name": "Doug Mata",
					"jobTitle": "Manager, Software Engineering",
					"pictureUrl": "../../assets/img/people/Doug.Mata.jpg",
					"bio": "Doug works on NRG's Software Development team creating solutions to support to the various applications and teams at NRG. Before joining NRG, he was the lead programmer of the Internet Surveys Groups at Penn Schoen Berland. Doug graduated from Cal Poly Pomona with a BS in Computer Science.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Kraftwerk"
						},
						{
							"subject": "TV Show",
							"answer": "Star Trek: Deep Space Nine"
						},
						{
							"subject": "Game",
							"answer": "Stepmania/DDR"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Sitges, Spain"
						},
						{
							"subject": "Food/Dish",
							"answer": "Loco Moco"
						}
					]
				},
				{
					"name": "James McNamara",
					"jobTitle": "Chief Operating Officer",
					"pictureUrl": "../../assets/img/people/James.McNamara.jpg",
					"bio": "James oversees all of NRG's Operations and assists in setting the direction of the firm. With over a decade of leadership experience, James specializes in leveraging technology to create efficient, scalable, and agile operational teams dedicated to solving clients' toughest challenges. Prior to NRG, James was an Executive Vice President of the Media and Entertainment Research practice at PSB (a WPP company). James graduated from the University of Virginia with a B.S. in Computer Science from the School of Engineering & Applied Sciences (Wahoowa!).",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dave Matthews Band"
						},
						{
							"subject": "Movie",
							"answer": "Gladiator"
						},
						{
							"subject": "TV Show",
							"answer": "24"
						},
						{
							"subject": "Quote",
							"answer": "\"Roads? Where we're going, we don't need roads.\" -Doc Brown"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Arcos de la Frontera, Spain"
						}
					]
				},
				{
					"name": "Irfan Mekic",
					"jobTitle": "Data Scientist, Marketing Sciences",
					"pictureUrl": "",
					"bio": "Irfan was born in Turkey, however, he is of Bosnian descent. Irfan moved to the U.S. when he was 5 years old, where he spent 10 years living in Bethlehem, Pennsylvania, before moving to Charlotte, North Carolina. He has his B.S. in Nuclear Engineering from NC State University, as well as an M.S. in Business Analytics from Wake Forest University. He is also currently pursuing an MS in Computational Analytics from Georgia Tech. He started his career at Ralph Lauren as a data analyst, before moving over to Siemens to work as a solutions architect in the data science space.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Step Brothers"
						},
						{
							"subject": "Book",
							"answer": "Anna Karenina by Leo Tolstoy"
						},
						{
							"subject": "Sports Team",
							"answer": "Liverpool F.C."
						},
						{
							"subject": "TV Show",
							"answer": "The Office"
						},
						{
							"subject": "Food",
							"answer": "Peppers with butter and cheese (Bosnian specialty)"
						}
					]
				},
				{
					"name": "Kennedy Mergenthaler",
					"jobTitle": "Manager, Fieldwork",
					"pictureUrl": "../../assets/img/people/Kennedy.Mergenthaler.jpg",
					"bio": "Kennedy assists with managing vendor relationships and communicating with the client teams to ensure all fieldwork is completed on schedule. Kennedy had started at NRG as an Office Coordinator before moving to this position. Before NRG, she worked as a Office Production Assistant at the Motion Picture and Television Fund. Kennedy graduated from Cal State Northridge with a BA in Entertainment Media Management.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Moulin Rouge"
						},
						{
							"subject": "Food/Dish",
							"answer": "Chicken Nuggets & French Fries"
						},
						{
							"subject": "Restaurant",
							"answer": "On the Thirty (Sherman Oaks)"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Dodgers"
						},
						{
							"subject": "Director",
							"answer": "Baz Luhrman"
						}
					]
				},
				{
					"name": "Gonzalo Merchan",
					"jobTitle": "Director, Coding",
					"pictureUrl": "../../assets/img/people/Gonzalo.Merchan.jpg",
					"bio": "Gonzalo oversees open end response coding for creative testing, screenings, exits, TV, video games, and many other areas of NRG's work turning respondent opinions into quantifiable and actionable insights for NRG's clients. When not working (rare) he can usually be found at Disneyland.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "La Dolce Vida"
						},
						{
							"subject": "Book",
							"answer": "Naked Lunch"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Florence, Italy"
						},
						{
							"subject": "Restaurant",
							"answer": "Chez Panisse, Berkeley CA"
						},
						{
							"subject": "Director",
							"answer": "Jean-Luc Godard"
						}
					]
				},
				{
					"name": "Ada Moreno",
					"jobTitle": "Quantitative Fieldwork Specialist, Fieldwork",
					"pictureUrl": "../../assets/img/people/Ada.Moreno.jpg",
					"bio": "Ada Moreno graduated from the University of Minnesota in 2019 with a Masters in Urban and Regional Planning. Prior to NRG, Ada worked on survey research and project management at a healthcare organization. In her free time, Ada enjoys watching movies and discovering new restaurants.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Pan's Labyrinth"
						},
						{
							"subject": "Book",
							"answer": "The Brothers Karamazov"
						},
						{
							"subject": "Band",
							"answer": "TV on the Radio"
						},
						{
							"subject": "Actor",
							"answer": "Edward Norton"
						},
						{
							"subject": "Director",
							"answer": "Stanley Kubrick"
						}
					]
				},
				{
					"name": "Julian Moscotte",
					"jobTitle": "Data Processing Technician, Data Processing",
					"pictureUrl": "../../assets/img/people/Julian.Moscotte.jpg",
					"bio": "As a UC San Diego graduate in Math and Computer Science, Julian has an extreme interest in data and the ways it can help inform us to make better decisions about the things around us. Julian's goal is to help increase efficiency and creativity when it comes to problem solving as well as making everyone else's job a little easier. When he's not working he can be found listening to music, watching or playing sports (usually this), or playing video games.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Bastille"
						},
						{
							"subject": "Movie",
							"answer": "The Martian"
						},
						{
							"subject": "Book",
							"answer": "Speaker for the Dead (Enders Game Series)"
						},
						{
							"subject": "Game",
							"answer": "Portal"
						},
						{
							"subject": "Sports Teams",
							"answer": "Dodgers, Lakers, Liverpool FC"
						}
					]
				},
				{
					"name": "George Musick",
					"jobTitle": "Vice President, Data Processing",
					"pictureUrl": "",
					"bio": "Leadership, vision, and communication are the hallmarks of George’s career. Team building, collaboration, process improvement, cutting-edge solution oriented, quality-driven, and full accountability are just some of his talents that provide the basis for his leadership abilities.  George also ran his own data processing company for 14 years with offices in New Jersey and Hawaii.",
					"favourites": [
						{
							"subject": "Charity",
							"answer": "Great Cycle Challenge to Fight Kids’ Cancer"
						},
						{
							"subject": "Quote",
							"answer": "\"We'll always have Paris.\""
						},
						{
							"subject": "Movie",
							"answer": "Casablanca, Godfather I & II, Apocalypse Now"
						},
						{
							"subject": "Game",
							"answer": "Chess. Friend me and let’s play at chess.com (I’m not all that good)"
						},
						{
							"subject": "Sports Teams",
							"answer": "Seriously? The Yankees, of course."
						}
					]
				},
				{
					"name": "Autra Namvar",
					"jobTitle": "Presentation & Data Designer",
					"pictureUrl": "../../assets/img/people/Autra.Namvar.jpg",
					"bio": "After graduating from the University of San Francisco in 2018, Autra began her marketing research and presentation design journey at KQED, a local Bay Area NPR and PBS affiliate. She loves organizing research into compelling stories, as well as incorporating her creative eye into data visualizations. You can find Autra in her happiest element with a paintbrush for her portraits in one hand and chopsticks for her sushi in the other.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Glass Animals"
						},
						{
							"subject": "TV Show",
							"answer": "Broad City"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Barcelona, Spain"
						},
						{
							"subject": "Cocktail",
							"answer": "Espresso Martini"
						},
						{
							"subject": "Actor",
							"answer": "Timothee Chalamet"
						}
					]
				},
				{
					"name": "Miki Nguyen",
					"jobTitle": "Senior Technical Manager, Research Operations",
					"pictureUrl": "../../assets/img/people/Miki.Nguyen.jpg",
					"bio": "Miki recently joined NRG as a Senior Technical Product Manager, reporting to Leanna Wood in Research Operations. Prior to NRG, he spent many years in product management and marketing roles within organizations such as Dish Wireless, Bluetooth SIG, AT&T and Philips Electronics. Miki holds a Bachelor’s of Science degree in mechanical engineering from the University of Washington and currently resides in Seattle, Washington. Away from work, he enjoys spending time outdoors with his kids, camping, fishing and riding motorcycles.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Saving Private Ryan"
						},
						{
							"subject": "Game",
							"answer": "Tennis"
						},
						{
							"subject": "Sports Team",
							"answer": "Seattle Seahawks"
						},
						{
							"subject": "Game Show Host",
							"answer": "Bob Barker"
						},
						{
							"subject": "Quote",
							"answer": "\"This too shall pass\""
						}
					]
				},
				{
					"name": "Lisa Nguyen",
					"jobTitle": "Project Manager, Research Operations",
					"pictureUrl": "../../assets/img/people/Lisa.Nguyen.jpg",
					"bio": "Lisa graduated from California State University, East Bay with a B.S. in Environmental Science and a certificate in Technical Project Management from Thinkful. She brings professional experience in working with cross-functional teams to successfully bring projects to completion while proactively seeking areas of opportunity to standardize and streamline project management processes. Outside of work, you can find her snowboarding in the mountains, surfing at beach, leveling up her rank in FPS games, or at local boba shops all over SoCal.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "FernGully: The Last Rainforest (1992); Black Hawk Down (2001); Always Be My Maybe (2019)"
						},
						{
							"subject": "TV Show",
							"answer": "House M.D."
						},
						{
							"subject": "Quote",
							"answer": "Rule #76 - No excuses. Play like a champion."
						},
						{
							"subject": "Food",
							"answer": "Lasagna"
						},
						{
							"subject": "Cocktail",
							"answer": "Lagavulin 12yr, neat with a few drops of water"
						}
					]
				},
				{
					"name": "Marie Nuñez-Grijalva",
					"jobTitle": "Specialist, Business Operations",
					"pictureUrl": "",
					"bio": "Marie has been with NRG for over 4 years. She started in the Production department as a Driver/Office Assistant. Primary duties were assembling hard copies of tracking reports followed by distribution to major movie studios and clients around Los Angeles. Currently she is working as the Coordinator/Lead Driver primarily for the Burbank office as part of the Business Operations team. In her spare time she enjoys baking and cake decorating. She has put together showers and parties for many of our coworkers.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Grey’s Anatomy"
						},
						{
							"subject": "Restaurant",
							"answer": "Rye in Kansas City"
						},
						{
							"subject": "Cocktail",
							"answer": "French martini"
						},
						{
							"subject": "Actor",
							"answer": "Tie between Nic Cage & Robert De Niro"
						},
						{
							"subject": "Director",
							"answer": "Quentin Tarantino"
						}
					]
				},
				{
					"name": "Joannie Otanez",
					"jobTitle": "HR Generalist, Human Resources",
					"pictureUrl": "",
					"bio": "Joannie joins NRG as an HR Generalist and brings over 4 years of diverse human resources experience to the team. Prior to joining NRG, Joannie worked in the education and marketing sector of human resources providing support in areas such as benefits, compliance and policies and procedures development. Joannie graduated from the University of Maryland with a MS in Human Resource Management.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "What We Do in the Shadows"
						},
						{
							"subject": "Band",
							"answer": "The Killers"
						},
						{
							"subject": "Food",
							"answer": "Pasta"
						},
						{
							"subject": "Actor",
							"answer": "Gary Oldman"
						},
						{
							"subject": "Game",
							"answer": "The Game of Life"
						}
					]
				},
				{
					"name": "Curtis Pak",
					"jobTitle": "Director, Data Processing",
					"pictureUrl": "../../assets/img/people/Curtis.Pak.jpg",
					"bio": "Curtis has over 23 years of custom DP experience in entertainment and healthcare industry. He graduated from University of Southern California with a degree in Marketing.  Prior to joining NRG, he spent the last 13 years in custom DP department for one of the largest healthcare analytics and population health management company.  On his down time, he loves spending time with his wife and three children.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Matrix"
						},
						{
							"subject": "Class in School",
							"answer": "Math/Science"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Maui"
						},
						{
							"subject": "Food/Dish",
							"answer": "Anything Korean"
						},
						{
							"subject": "Sports Team",
							"answer": "Denver Broncos"
						}
					]
				},
				{
					"name": "John Paez",
					"jobTitle": "Director, Software Engineering",
					"pictureUrl": "../../assets/img/people/John.Paez.jpg",
					"bio": "John graduated from the University of Arizona in Tucson with a BS in Business Administration, a BS in Public Administration and an MBA in Information Systems. John has 14 years of experience in technology-related roles but found his passion in software development. Outside of work, John enjoys sifting through old music charts, listening to movie podcasts, and keeping up with Broadway news.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Mamas and Papas"
						},
						{
							"subject": "Movie",
							"answer": "Lord of the Rings: The Fellowship of the Ring"
						},
						{
							"subject": "Cocktail",
							"answer": "Michelada (extra spicy)"
						},
						{
							"subject": "Sports Team",
							"answer": "Angels"
						},
						{
							"subject": "Director",
							"answer": "Ridley Scott"
						}
					]
				},
				{
					"name": "Alex Rivera",
					"jobTitle": "Quantitative Fieldwork Specialist, Fieldwork",
					"pictureUrl": "",
					"bio": "Alex Rivera holds an M.A. in Political Science from Virginia Tech and a B.A. in Philosophy and Economics from Western Kentucky University. In his free time, he reads social philosophy, plays tabletop games, and follows several esports.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "The Mountain Goats"
						},
						{
							"subject": "Movie",
							"answer": "Synecdoche, New York"
						},
						{
							"subject": "Game",
							"answer": "Dark Souls"
						},
						{
							"subject": "Director",
							"answer": "Charlie Kaufman"
						},
						{
							"subject": "Sports Team",
							"answer": "G2 Esports"
						}
					]
				},
				{
					"name": "Michael Rossmaessler",
					"jobTitle": "Quality Control Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/Michael.Rossmeassler.jpg",
					"bio": "  Michael came to market research and NRG after working in other fields. Originally, he was going to be an engineer, and while he didn't go that route, being analytical has served him well in the long run. He also spent some time in the theater so he has been around creative people (and could tell you stories, not enough room to do that here.) \"Our business really is the crossroads between analysis and the creative, always evolving.\" He's been in Los Angeles long enough to be a native, and like its diversity, the climate, the food, and of course it's hockey team !",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Metallica"
						},
						{
							"subject": "Movie",
							"answer": "The Abyss"
						},
						{
							"subject": "TV Show",
							"answer": "Mythbusters"
						},
						{
							"subject": "Cocktail",
							"answer": "Gin Gimlet (Preferably with Tanqueray, but Bombay will do)"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Kings"
						}
					]
				},
				{
					"name": "Heather Sajeski",
					"jobTitle": "Senior Vice President of People",
					"pictureUrl": "../../assets/img/people/Heather.Sajeski.jpg",
					"bio": "Heather leads NRG's Human Resources team as the Vice President of People.  Prior to joining NRG, Heather spent her early career at PSB Research helping clients across industries solve their biggest problems using data driven approaches.  She later became Vice President of Knowledge at PSB, helping to develop numerous internal training programs and leading employee development initiatives.  She brings both her research background as well as her training and development knowledge to lead all of NRG's people initiatives.   Heather graduated from The George Washington University with a BA in International Affairs and Economics.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Dave Matthews Band"
						},
						{
							"subject": "Movie",
							"answer": "All of the Fast and Furious Movies (except Tokyo Drift)"
						},
						{
							"subject": "Quote",
							"answer": "\"Of course it is happening inside your head, Harry, but why on earth should that mean that it is not real?\" — Harry Potter and the Deathly Hallows"
						},
						{
							"subject": "Book",
							"answer": "A secret History"
						},
						{
							"subject": "Sports Team",
							"answer": "Philadelphia Eagles"
						}
					]
				},
				{
					"name": "Marko Santo Domingo",
					"jobTitle": "Senior Data Processing Technician, Data Processing",
					"pictureUrl": "",
					"bio": "Marko joined NRG's Data Processing team in October 2020. Prior to NRG Marko was studying Mechanical Engineering at the University of California, Merced. On his spare time, he loves to volunteer and raise funds for UNICEF, play videogames, and read books from different cultures.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Coldplay"
						},
						{
							"subject": "Movie",
							"answer": "Your Name (君の名は)"
						},
						{
							"subject": "Book",
							"answer": "Do Androids Dream Of Electric Sheep"
						},
						{
							"subject": "Game",
							"answer": "Valorant"
						},
						{
							"subject": "Sports Team",
							"answer": "Cloud 9"
						}
					]
				},
				{
					"name": "Jane Sies",
					"jobTitle": "Executive Director, Research Operations",
					"pictureUrl": "../../assets/img/people/Jane.Sies.jpg",
					"bio": "Jane has been managing NRG's international fieldwork since 2004. Through her work with all major studios, she has overseen qualitative and quant projects on every scale; from quick turnaround exit surveys through to multi-market test screening programs and implementing international standards across the core markets and beyond. Prior to NRG, Jane was responsible for coordinating large-scale global innovation qualitative studies, including ethnographic research and workshops.",
					"favourites": [
						{
							"subject": "Quote",
							"answer": "\"Well behaved women seldom make history\" -Laurel Thatcher Ulrich"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Bellagio, Lake Como"
						},
						{
							"subject": "Cocktail",
							"answer": "French Martini"
						},
						{
							"subject": "TV Show",
							"answer": "Friends"
						},
						{
							"subject": "Team",
							"answer": "Arsenal"
						}
					]
				},
				{
					"name": "Grace Stees",
					"jobTitle": "Vice President, Design",
					"pictureUrl": "../../assets/img/people/Grace.Stees.jpg",
					"bio": "Grace leads NRG’s design team and specializes in using data to tell stories with infographics and white papers. Prior to joining NRG in 2018, Grace worked at the Swiss headquarters of Procter & Gamble and Coty Inc., on the innovation team of Sterling Brands in Los Angeles, and at the Chicago Tribune. Grace holds a degree in Publication Design / Infographics from Ohio University's Scripps College of Communication, and has experience in package design, print and editorial publication design, branding, journey-mapping, and event and experiential design. As a Midwestern transplant, Grace is happy to wake up to LA's sunshine every day and enjoys hiking and exploring California's Parks. She is always up for ice cream and loves a good cat meme.",
					"favourites": [
						{
							"subject": "Class in School",
							"answer": "Film Photography"
						},
						{
							"subject": "Quote",
							"answer": "\"All scars she heals, whether in rocks or water or sky or hearts.\" - John Muir, on Nature"
						},
						{
							"subject": "Book",
							"answer": "The Phantom Tollbooth"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Camping in Kings Canyon National Park"
						},
						{
							"subject": "Food/Dish",
							"answer": "Tacos"
						}
					]
				},
				{
					"name": "Hayley Sullivan",
					"jobTitle": "Quality Control Specialist II, Coding",
					"pictureUrl": "../../assets/img/people/Hayley.Sullivan.jpg",
					"bio": "Hayley grew up in West Sussex, England and lived in London for many years, then attended boarding school in Scotland followed by reading Geography with Development Studies (BA) at Sussex University. She loves cinema and being outdoors, especially Mountain Biking XC and downhill trails, playing golf, tennis and squash.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Pink Floyd"
						},
						{
							"subject": "Book",
							"answer": "Silence of the Lambs"
						},
						{
							"subject": "Restaurant",
							"answer": "Yemanja, Ibiza"
						},
						{
							"subject": "Cocktail",
							"answer": "Mojito"
						},
						{
							"subject": "Director",
							"answer": "Christopher Nolan"
						}
					]
				},
				{
					"name": "Jenny Swisher",
					"jobTitle": "Chief People Officer",
					"pictureUrl": "../../assets/img/people/Jenny.Swisher.jpg",
					"bio": "Jenny is a modern HR/People Operations leader who drives people strategy alignment with business strategy to foster organizational success. I believe in fostering a culture where talent is supported as professionals and humans, where they can their authentic self, achieve high performance by contributing in a purposeful way, and have the opportunity to elevate and further their impact. Jenny is a mom of two (Jessica and Dylan), a SoCal girl through and through, an avid runner, and a continuous learner.",
					"favourites": [
						{
							"subject": "Actor",
							"answer": "Tom Hanks"
						},
						{
							"subject": "Movie",
							"answer": "Gladiator"
						},
						{
							"subject": "Quote",
							"answer": "\"To inspire people, don't show them your super powers. Show them theirs.\" — Alexander Den Heijer"
						},
						{
							"subject": "Director",
							"answer": "Steven Spielberg"
						},
						{
							"subject": "Food",
							"answer": "Mexican and anything spicy!"
						}
					]
				},
				{
					"name": "James Thegerstrom",
					"jobTitle": "Senior Director, Data Processing",
					"pictureUrl": "../../assets/img/people/James.Thegerstrom.jpg",
					"bio": "Working in custom data processing servicing all departments, James utilizes 15 years of experience on a wide range of research methodologies and client needs.  Emphasizing imagination and creativity, he is always looking for a new faster method to provide his clients with comprehensive reports.  When not at work, James is most likely thinking too much about soccer.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Cocteau Twins, with Brian Eno a close second."
						},
						{
							"subject": "Movie",
							"answer": "Blade Runner"
						},
						{
							"subject": "TV Show",
							"answer": "Ab Fab!"
						},
						{
							"subject": "Vacation Spot",
							"answer": "Yosemite"
						},
						{
							"subject": "Sports Team",
							"answer": "Los Angeles Galaxy"
						}
					]
				},
				{
					"name": "Eric Tsai",
					"jobTitle": "Vice President, Marketing Sciences",
					"pictureUrl": "../../assets/img/people/Eric.Tsai.jpg",
					"bio": "Eric is the Senior Director of Marketing Sciences. He received a MS in Computer Science from Portland State University with a focus on AI and Machine Learning along with a BA in Economics from Washington University in St Louis. Eric got his start working with data in market research, then made a detour into the tech startup world, before returning to market research with NRG. Outside of work, Eric enjoys hiking, bicycling, and learning to play piano.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "The Office"
						},
						{
							"subject": "Book",
							"answer": "The Amazing Adventures of Kavalier and Clay, by Michael Chabon"
						},
						{
							"subject": "Food/Dish",
							"answer": "Sushi"
						},
						{
							"subject": "Cocktail",
							"answer": "Manhattan"
						},
						{
							"subject": "Sports Team",
							"answer": "Ohio State Football"
						}
					]
				},
				{
					"name": "Candice Vanderstreet",
					"jobTitle": "Director, Research Operations",
					"pictureUrl": "",
					"bio": "Candice has over eight years of experience in research operations and fieldwork. Prior to joining NRG, she worked as a manager at Edelman Intelligence fielding both qualitative and quantitative projects and helping develop processes and platforms related to internal operations. Candice earned her BS in Public Policy from Rochester Institute of Technology and an MBA and certificate in Project Management from SUNY Empire State College. In her free time, she can be found streaming her favorite shows, listening to audiobooks, or taking walks with her husband.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Ever After"
						},
						{
							"subject": "TV Show",
							"answer": "Expedition Unknown"
						},
						{
							"subject": "Food",
							"answer": "Coffee"
						},
						{
							"subject": "Book",
							"answer": "Harry Potter and the Sorcerer's Stone"
						},
						{
							"subject": "Band",
							"answer": "Eve 6"
						}
					]
				},
				{
					"name": "Raquel Vazquez",
					"jobTitle": "Jr. Data Processor, Data Processing",
					"pictureUrl": "",
					"bio": "Born and raised in LA, I graduated from California State University, Los Angeles with a B.S in Computer Information Systems and a certificate for Computer Programming. In my free time I enjoy reading vogue magazines, catching up on the newest fashion news, and cooking.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "The Wolf of Wall Street"
						},
						{
							"subject": "Food",
							"answer": "Anything Italian"
						},
						{
							"subject": "Cocktail",
							"answer": "Appletini"
						},
						{
							"subject": "Band",
							"answer": "The Beatles"
						},
						{
							"subject": "Director",
							"answer": "Guillermo del Toro"
						}
					]
				},
				{
					"name": "Nick Wiesenthal",
					"jobTitle": "Qualitative Fieldwork Specialist, Fieldwork",
					"pictureUrl": "",
					"bio": "Nick is a part of the Fieldwork team as a Qualitative Fieldwork Specialist. Nick earned his B.S. in Biological Sciences with a concentration in Ecological, Evolutionary, and Conservation Biology from the University of Central Florida. Before NRG, Nick worked mostly in scientific research as a fellow for the National Science Foundation examining young adult and college student mental health, concealable stigmatized identities, and sentiment analysis at scale in a sequential series of quantitative and qualitative multidisciplinary research studies. Outside of NRG, Nick enjoys listening to music, going to concerts, and keeping up with pop culture.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "The Book Thief"
						},
						{
							"subject": "Actress",
							"answer": "Natalie Portman"
						},
						{
							"subject": "Director",
							"answer": "Steven Spielberg"
						},
						{
							"subject": "Game",
							"answer": "The Last of Us Part II"
						},
						{
							"subject": "Quote",
							"answer": "\"I'm obsessively opposed to the typical.\" - Lady Gaga"
						}
					]
				},
				{
					"name": "Heather Williams",
					"jobTitle": "Data Collection Coordinator, Data Processing",
					"pictureUrl": "../../assets/img/people/Heather.Williams.jpg",
					"bio": "Heather earned her BA from Temple University, where she majored in History. During her freshman year, she took an interviewing job which led to call floor and project supervision which led to programming and data processing. When Heather is not in the office, you can find her travelling the dirt roads of the Pennsylvania Wilds looking for woodland creatures such as elk, deer, and bears.",
					"favourites": [
						{
							"subject": "TV Show",
							"answer": "Big Brother (US and Canada)"
						},
						{
							"subject": "Restaurant",
							"answer": "Driftwood Saloon & Grill (Driftwood, PA)"
						},
						{
							"subject": "Band",
							"answer": "Alkaline Trio"
						},
						{
							"subject": "Sports Team",
							"answer": "Pittsburgh Steelers, LA Lakers, SF Giants"
						},
						{
							"subject": "Quote",
							"answer": "\"If you're going through hell, keep going.\" - Winston Churchill"
						}
					]
				},
				{
					"name": "Linda Wing",
					"jobTitle": "Vice President, Marketing Sciences",
					"pictureUrl": "../../assets/img/people/Linda.Wing.jpg",
					"bio": "Linda joined NRG in 2021, where she specializes in segmentations, key drivers analyses, regressions, factor analyses, and discrete choice studies. Early in her career, she worked with various professional societies and trade associations conducting market research and industry studies. Prior to joining NRG, she was the Director of Advanced Analytics at C+R Research; working with clients in CPG, retail, health care, and financial services. Linda graduated cum laude from Northern Illinois University with a B.S. in Marketing and a minor in Mathematics. She also received her M.S. in Predictive Analytics/Data Science with a concentration in Marketing from DePaul University.",
					"favourites": [
						{
							"subject": "Movie",
							"answer": "Hidden Figures"
						},
						{
							"subject": "Book",
							"answer": "All the Light We Cannot See"
						},
						{
							"subject": "Vacation Spot",
							"answer": "St. John, U.S. Virgin Islands"
						},
						{
							"subject": "Sports Team",
							"answer": "Chicago Blackhawks"
						},
						{
							"subject": "Actor",
							"answer": "Clint Eastwood"
						}
					]
				},
				{
					"name": "Leanna Wood",
					"jobTitle": "Senior Vice President, Global Operations",
					"pictureUrl": "../../assets/img/people/Leanna.Wood.jpg",
					"bio": "Leanna is focused on NRG's operational units and ensuring they are functioning as efficiently as possible. She manages many of the firm's external vendor relationships, designs and improves operational practices, and ensures all fieldwork is completed accurately and on schedule.  Before joining NRG, she served as Senior Director, Head of Online Sampling at Penn Schoen Berland. Leanna graduated from The George Washington University with a BA in International Affairs. ",
					"favourites": [
						{
							"subject": "Vacation Spot",
							"answer": "Greece"
						},
						{
							"subject": "Movie",
							"answer": "Breakfast at Tiffany's"
						},
						{
							"subject": "Book",
							"answer": "The Shadow of the Wind by Carlos Ruiz Zafon"
						},
						{
							"subject": "Restaurant",
							"answer": "Minibar (DC)"
						},
						{
							"subject": "Team",
							"answer": "New England Patriots"
						}
					]
				},
				{
					"name": "Becky Wu, Ph.D.",
					"jobTitle": "Executive Vice President, Marketing Sciences",
					"pictureUrl": "../../assets/img/people/Becky.Wu.jpg",
					"bio": "Becky leads our Marketing Science and Data Science practice. She brings 20 years of expertise and creativity in leveraging integrated methodologies, advanced analytics and multi-dimensional data assets. Becky has been a trailblazer in not only co-inventing one of the research industry’s first passive behavioral metering technologies, but also establishing best practices in bridging survey data, digital behavioral data, media data and transactional data. Her focus centers around helping clients and the NRG team formulate better insights and data strategy by capitalizing on the convergence of traditional statistical analytics and data science techniques. Becky holds a Ph.D. in Communications from Pennsylvania State University.",
					"favourites": [
						{
							"subject": "Band",
							"answer": "Pink Martini"
						},
						{
							"subject": "Quote",
							"answer": "\"Time has been my Democritus.\" - Jorge Luis Borges"
						},
						{
							"subject": "Actress",
							"answer": "Nicole Kidman"
						},
						{
							"subject": "Superhero",
							"answer": "The Little Prince"
						},
						{
							"subject": "Food/Dish",
							"answer": "Anything Seafood"
						}
					]
				},
				{
					"name": "Leroy Zhang",
					"jobTitle": "APAC Manager, Fieldwork, Research Operations",
					"pictureUrl": "",
					"bio": "Leroy has over 8 years of market research experience, specializing in both Qualitative and Quantitative methodologies. He has extensive experience in project management and fieldwork operations, and have served clients across various industries like Technology, Entertainment, FCMG, Financial institutions and Gaming. He is also a seasoned project manager and understands the best approach to a project. Prior to joining National Research Group, Leroy worked as a Project Manager where he leads the project management department. Leroy graduated from Murdoch University with a B.A in business marketing.",
					"favourites": [
						{
							"subject": "Book",
							"answer": "Surrounded by Idiots"
						},
						{
							"subject": "Quote",
							"answer": "\"Great things come from hard work and perseverance. No excuses.\" - Kobe Bryant"
						},
						{
							"subject": "Food",
							"answer": "Steak"
						},
						{
							"subject": "Cocktail",
							"answer": "Gin & Tonic"
						},
						{
							"subject": "Sports Team",
							"answer": "Lakers"
						}
					]
				}
			]
		}
	}
}

export { Content };
